import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { rgba, percent, rem, px, important, color, padding, viewWidth, em, margin, viewHeight, scale, translateX, translate } from 'csx';
import { Stretch, Vertical, Box, Horizontal, Grid, Content, StretchSpacer, HorizontalSpacer } from 'gls/lib';
import * as React from 'react';
import React__default, { useMemo, createElement, useState, useEffect, useRef, createContext, useCallback, useContext, useLayoutEffect, useReducer, memo } from 'react';
import { keyframes, stylesheet, style, classes } from 'typestyle';
import moment from 'moment';
import { YAxis, Label, Area, Bar as Bar$1, Scatter, Line, ReferenceArea, ResponsiveContainer, ComposedChart, XAxis, CartesianGrid, ReferenceLine, Tooltip, Legend } from 'recharts';
import { scaleTime, timeMonth, timeDay, timeHour, timeMinute } from 'd3';
import { useTranslation, initReactI18next } from 'react-i18next';
import { faCaretLeft, faCaretRight, faAngleUp, faAngleDown, faCheck, faPlus, faTrash, faCog, faMinus, faPauseCircle, faPlusCircle, faCamera, faExclamationTriangle, faTimes, faPlay, faPause, faCaretUp, faCaretDown, faPlayCircle, faEye, faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import shortid from 'shortid';
import { MenuList as MenuList$1, SubMenuItem, MenuItem } from 'react-menu-list';
import tinygradient from 'tinygradient';
import { useDebouncedCallback } from 'use-debounce';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { Horizontal as Horizontal$1, Content as Content$1, Box as Box$1, Vertical as Vertical$1 } from 'gls';
import i18n, { t } from 'i18next';
import ReactTimePicker from 'rc-time-picker';
import ReactFlow, { getSmoothStepPath, BaseEdge, EdgeLabelRenderer, Position, Handle, useNodesState, useEdgesState, Controls } from 'reactflow';
import 'reactflow/dist/style.css';
import { useToasts, ToastProvider, DefaultToast } from 'react-toast-notifications';
import { v4 } from 'uuid';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker, DateRangePicker as DateRangePicker$1 } from 'react-dates';
import copy from 'copy-to-clipboard';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Loader = function (_a) {
    var message = _a.message;
    return (jsx(Stretch, __assign({ verticalAlign: "center", horizontalAlign: "center", "data-testid": "loader" }, { children: jsxs(Vertical, { children: [jsx("div", { className: classNames$b.loader }), message && jsx("label", __assign({ className: classNames$b.text }, { children: message }))] }) })));
};
var spin = keyframes({
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
});
var classNames$b = stylesheet({
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    text: {
        marginTop: 10
    },
    loader: {
        border: '3px solid #f3f3f3',
        borderTop: '3px solid #3498db',
        borderRadius: '50%',
        width: 20,
        height: 20,
        animation: "".concat(spin, " 2s linear infinite")
    }
});

var Colours = {
    primary: '#02ADC3',
    primaryLight: '#AFE2E9',
    textDark: '#637A88',
    textLight: '#A0BCC5',
    textDisabled: '#3e4b60',
    darkestBlue: '#00131F',
    darkerBlue: '#001724',
    darkBlue: '#001D2E',
    blue: '#002438',
    lightBlue: '#002D47',
    lighterBlue: '#003852',
    lightestBlue: '#004D70',
    white: '#F5F5F5',
    purple: '#829CFF',
    darkPurple: '#6245f4',
    nileBlue: '#1C4958',
    orange: '#FF9200',
    yellow: '#EEB902',
    red: '#FF1F41',
    green: '#09EF6E'
};
var Sizes = {
    small: '1.5rem',
    halfSmall: '.78571429rem',
    maxWidth: 1800,
    height: '50px',
    container: 1024,
    fontSize1: 12.5,
    fontSize2: 15,
    fontSize3: 20,
    fontSize4: 25,
    lineHeight: 1.5,
    input: 375,
    borderRadius: 5
};
var fontFamily = "'Open Sans', sans-serif";
var boxShadow = '0 5px 10px ' + rgba(0, 0, 0, 0.4).toString();
var zIndex;
(function (zIndex) {
    zIndex[zIndex["highest"] = 1000] = "highest";
    zIndex[zIndex["high"] = 100] = "high";
    zIndex[zIndex["normal"] = 1] = "normal";
    zIndex[zIndex["base"] = 0] = "base";
})(zIndex || (zIndex = {}));
var scrollClass = style({
    overflow: 'auto'
});

var styles$h = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Colours: Colours,
    Sizes: Sizes,
    fontFamily: fontFamily,
    boxShadow: boxShadow,
    get zIndex () { return zIndex; },
    scrollClass: scrollClass
});

var AlertGroupFarmers = function (_a) {
    var farmers = _a.farmers;
    if (!farmers || farmers.length < 1) {
        return null;
    }
    return (jsx(Vertical, __assign({ sizing: 1, height: percent(100), className: style({
            boxSizing: 'border-box'
        }), scroll: "vertical", spacing: rem(0.5), "data-testid": "alert-groups-farmers" }, { children: farmers.map(function (farmer, i) { return (jsxs(Box, __assign({ padding: rem(0.5), className: style({
                background: Colours.darkBlue,
                fontFamily: fontFamily,
                color: Colours.textLight
            }), "data-testid": "alert-group-farmer" }, { children: [farmer.firstName, " ", farmer.lastName] }), "".concat(i, "-").concat(farmer.firstName, "-").concat(farmer.firstName))); }) })));
};

var RightYAxis = function (props) {
    var graph = props.graph, hideAxis = props.hideAxis;
    var rightYAxisValues = useMemo(function () {
        return graph
            .filter(function (g) { return !(g.hidden || !g.yAxidId); })
            .map(function (g) {
            return {
                range: g.range,
                axisLine: true,
                tickLine: false,
                label: g.label,
                unit: g.unit,
                key: g.key,
                orientation: 'right',
                yAxisId: g.yAxidId,
                stroke: g.colour || Colours.textLight,
                hide: !!g.hideAxis ||
                    ((hideAxis === null || hideAxis === void 0 ? void 0 : hideAxis.y)
                        ? hideAxis.y || hideAxis.showFirst
                        : hideAxis)
            };
        });
    }, [graph]);
    return (jsx(Fragment, { children: rightYAxisValues.map(function (value, index) {
            return (index !== 0 && (createElement(YAxis, __assign({}, value, { yAxisId: value.yAxisId, hide: value.hide, domain: value.range || [
                    0,
                    function (dataMax) { return Math.ceil(dataMax * 1.1) || 1; }
                ], axisLine: value.axisLine, label: undefined, key: "".concat(value.key, "-").concat(index), unit: '', tickCount: 2 }), value.label && (jsx(Label, { offset: 10, angle: -90, value: "".concat(value.label, " ").concat(value.unit ? "(".concat(value.unit, ")") : ''), position: "insideLeft", className: style({
                    textAnchor: 'middle',
                    color: value.color,
                    fill: value.stroke
                }) })))));
        }) }));
};

var Dot = function (_a) {
    var onClick = _a.onClick, props = __rest(_a, ["onClick"]);
    var key = props.key, cx = props.cx, cy = props.cy, stroke = props.stroke, payload = props.payload, dataKey = props.dataKey;
    var hasPoint = Object.keys(payload).findIndex(function (key) { return key === "".concat(dataKey, "-point"); }) !== -1;
    if (!hasPoint) {
        return null;
    }
    function handleClick() {
        if (!onClick) {
            return;
        }
        onClick(props);
    }
    return (jsx("svg", __assign({ width: 20, height: 20, x: cx - 10, y: cy - 10, stroke: stroke, strokeWidth: 40, fill: "transparent", viewBox: "0 0 200 200", onClick: handleClick }, { children: jsx("path", { d: "M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0" }) }), key));
};

var AreaDatapoints = function (_a) {
    var graph = _a.graph, hide = _a.hide, handleClick = _a.handleClick, handleDataClick = _a.handleDataClick;
    var nonHiddenDatasets = graph.filter(function (v) { return !v.hidden; });
    var datasets = useMemo(function () { return nonHiddenDatasets.filter(function (v) { return v.type === 'area'; }); }, [graph]);
    return (jsx(Fragment, { children: datasets.map(function (point) {
            var yAxisId = point.yAxidId === nonHiddenDatasets[0].yAxidId
                ? 'left'
                : point.yAxidId;
            return (jsx(Area, { type: point.curveType || 'linear', strokeWidth: 2, yAxisId: yAxisId, name: point.label, connectNulls: true, fill: hide ? 'transparent' : point.colour, fillOpacity: point.opacity, hide: point.hidden, dataKey: point.key, stroke: hide ? 'transparent' : point.colour, isAnimationActive: false, strokeDasharray: point.dash, activeDot: { onClick: function (e) { return handleClick(e); } }, dot: function (props) { return jsx(Dot, __assign({}, props, { onClick: handleClick })); }, onClick: function (data) { return handleDataClick(data, point.key); } }, point.key));
        }) }));
};

var OpacityBar = function (_a) {
    var _b;
    var dataKey = _a.dataKey, props = __rest(_a, ["dataKey"]);
    var x = props.x, y = props.y, fill = props.fill, height = props.height, width = props.width;
    var correspondingKey = Object.keys(props.payload).find(function (key) { return key === "".concat(dataKey, "-data"); });
    var data = correspondingKey && props.payload[correspondingKey];
    if (!data) {
        return null;
    }
    return (jsx("rect", { className: style({
            cursor: 'pointer'
        }), x: x, y: y, width: width < 8 ? 8 : width, height: height, fill: fill, fillOpacity: ((_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.opacity) || 1, strokeWidth: 2, stroke: fill }));
};

var BarDatapoints = function (_a) {
    var graph = _a.graph, hide = _a.hide, handleDataClick = _a.handleDataClick;
    var nonHiddenDatasets = graph.filter(function (v) { return !v.hidden; });
    var datasets = useMemo(function () { return nonHiddenDatasets.filter(function (v) { return v.type === 'bar'; }); }, [graph]);
    return (jsx(Fragment, { children: datasets.map(function (point) {
            var yAxisId = point.yAxidId === nonHiddenDatasets[0].yAxidId
                ? 'left'
                : point.yAxidId;
            return (jsx(Bar$1, { yAxisId: yAxisId, name: point.label, fill: hide ? 'transparent' : point.colour, fillOpacity: point.opacity, dataKey: point.key, hide: point.hidden, stroke: hide ? 'transparent' : point.colour, shape: jsx(OpacityBar, { dataKey: point.key }), isAnimationActive: false, strokeDasharray: point.dash, onClick: function (data) { return handleDataClick(data, point.key); } }, point.key));
        }) }));
};

var OpacityCircle = function (_a) {
    var _b, _c;
    var dataKey = _a.dataKey; _a.onClick; var props = __rest(_a, ["dataKey", "onClick"]);
    var cx = props.cx, cy = props.cy, fill = props.fill, width = props.width, height = props.height;
    var correspondingKey = Object.keys(props.payload).find(function (key) { return key === "".concat(dataKey, "-data"); });
    var data = correspondingKey && props.payload[correspondingKey];
    if (!data) {
        return null;
    }
    return (jsx("circle", { cx: cx, cy: cy, r: ((_b = data === null || data === void 0 ? void 0 : data.meta) === null || _b === void 0 ? void 0 : _b.radius) || 10, strokeWidth: 2, stroke: fill, fill: fill, fillOpacity: ((_c = data === null || data === void 0 ? void 0 : data.meta) === null || _c === void 0 ? void 0 : _c.opacity) || 1, width: width, height: height }));
};

var CircleDatapoints = function (_a) {
    var graph = _a.graph, hide = _a.hide, handleDataClick = _a.handleDataClick;
    var nonHiddenDatasets = graph.filter(function (v) { return !v.hidden; });
    var datasets = useMemo(function () { return nonHiddenDatasets.filter(function (v) { return v.type === 'circle'; }); }, [graph]);
    return (jsx(Fragment, { children: datasets.map(function (point) {
            var yAxisId = point.yAxidId === nonHiddenDatasets[0].yAxidId
                ? 'left'
                : point.yAxidId;
            return (jsx(Scatter, { yAxisId: yAxisId, name: point.label, fill: hide ? 'transparent' : point.colour, fillOpacity: point.opacity, hide: point.hidden, dataKey: point.key, stroke: hide ? 'transparent' : point.colour, shape: jsx(OpacityCircle, { dataKey: point.key }), isAnimationActive: false, onClick: function (data) { return handleDataClick(data, point.key); } }, point.key));
        }) }));
};

var Flag = function (_a) {
    var _b, _c;
    var dataKey = _a.dataKey, onClick = _a.onClick, props = __rest(_a, ["dataKey", "onClick"]);
    var key = props.key, cx = props.cx, fill = props.fill, yAxis = props.yAxis;
    function handleClick() {
        if (!onClick) {
            return;
        }
        onClick(props);
    }
    var correspondingKey = Object.keys(props.payload).find(function (key) { return key === "".concat(dataKey, "-data"); });
    var data = correspondingKey && props.payload[correspondingKey];
    if (!data) {
        return null;
    }
    return (jsxs("svg", __assign({ x: cx - 168.18, y: 0, onMouseOut: function (e) { return (e.target.style.cursor = 'default'); }, onMouseOver: function (e) { return (e.target.style.cursor = 'pointer'); } }, { children: [jsx("line", { stroke: ((_b = data.meta) === null || _b === void 0 ? void 0 : _b.color) || fill, x1: 168.18, x2: 168.18, y1: 114.75, y2: yAxis.height + 20, "stroke-width": 3 }), jsxs("g", { children: [jsx("rect", { width: 40, height: 33, textRendering: "hey", fill: ((_c = data.meta) === null || _c === void 0 ? void 0 : _c.color) || fill, y: 113.75, x: 167.18, "stroke-width": 1.5, onClick: handleClick }), jsx("text", __assign({ x: 167.18 + 15, y: 135.18, "font-family": "Verdana", "font-size": "16", fill: "black" }, { children: data.value }))] })] }), key));
};

var FlagDatapoints = function (_a) {
    var graph = _a.graph, hide = _a.hide, handleDataClick = _a.handleDataClick;
    var nonHiddenDatasets = graph.filter(function (v) { return !v.hidden; });
    var datasets = useMemo(function () { return nonHiddenDatasets.filter(function (v) { return v.type === 'flag'; }); }, [graph]);
    return (jsx(Fragment, { children: datasets.map(function (point) {
            var yAxisId = point.yAxidId === nonHiddenDatasets[0].yAxidId
                ? 'left'
                : point.yAxidId;
            return (jsx(Scatter, { shape: jsx(Flag, { dataKey: point.key }), legendType: "none", yAxisId: yAxisId, name: point.label, fill: hide ? 'transparent' : point.colour, hide: point.hidden, dataKey: point.key, isAnimationActive: false, onClick: function (data) { return handleDataClick(data, point.key); } }, point.key));
        }) }));
};

var LineDatapoints = function (_a) {
    var graph = _a.graph, hide = _a.hide, handleClick = _a.handleClick, handleDataClick = _a.handleDataClick;
    var nonHiddenDatasets = graph.filter(function (v) { return !v.hidden; });
    var datasets = useMemo(function () {
        return nonHiddenDatasets.filter(function (v) { return v.type === 'line' || !v.type || v.type === 'none'; });
    }, [graph]);
    return (jsx(Fragment, { children: datasets.map(function (point) {
            var yAxisId = point.yAxidId === nonHiddenDatasets[0].yAxidId
                ? 'left'
                : point.yAxidId;
            return (jsx(Line, { type: point.curveType || 'monotone', strokeWidth: point.strokeWidth || 2, yAxisId: yAxisId, name: point.label, connectNulls: true, dataKey: point.key, stroke: hide ? 'transparent' : point.colour, hide: point.hidden, isAnimationActive: false, strokeDasharray: point.dash, activeDot: { onClick: function (e) { return handleClick(e); } }, dot: function (props) { return jsx(Dot, __assign({}, props, { onClick: handleClick })); }, onClick: function (data) { return handleDataClick(data, point.key); } }, point.key));
        }) }));
};

var Highlights = function (_a) {
    var highlights = _a.highlights;
    return (jsxs(Fragment, { children: __spreadArray([jsx(YAxis, { yAxisId: "highlights", hide: true, domain: [0, 100] }, "highlights")], highlights.map(function (highlight, index) { return (jsx(ReferenceArea, { yAxisId: "highlights", ifOverflow: "hidden", isFront: false, x1: moment(highlight.from).valueOf(), x2: moment(highlight.to).valueOf(), fill: highlight.fill, fillOpacity: highlight.opacity || 0.5 }, highlight.from)); }), true) }));
};

var LegendContent = function (_a) {
    var onClick = _a.onClick, graph = _a.graph, labels = _a.labels;
    return (jsxs("div", __assign({ style: { textAlign: 'center' } }, { children: [(labels === null || labels === void 0 ? void 0 : labels.generate)
                ? labels
                    .generate()
                    .map(function (i) {
                    var _a;
                    return (jsx(LegendItem, { color: i.color, dash: i.dash, text: i.value, hidden: (_a = graph.find(function (g) { return i.key === g.key; })) === null || _a === void 0 ? void 0 : _a.hidden, onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(i.key); } }, i.key));
                })
                : null, !(labels === null || labels === void 0 ? void 0 : labels.generate)
                ? graph
                    .filter(function (c) { return c.type !== 'none' && !c.hideLegend; })
                    .map(function (i) {
                    var _a;
                    return (jsx(LegendItem, { color: i.colour, dash: i.dash, text: i.label, hidden: (_a = graph.find(function (g) { return i.key === g.key; })) === null || _a === void 0 ? void 0 : _a.hidden, onClick: function () {
                            onClick === null || onClick === void 0 ? void 0 : onClick(i.key);
                        } }, i.key));
                })
                : null] })));
};
var LegendItem = function (_a) {
    var color = _a.color, dash = _a.dash, text = _a.text, onClick = _a.onClick, hidden = _a.hidden;
    return (jsxs("div", __assign({ style: {
            display: 'inline-block',
            marginLeft: '0.5rem',
            cursor: 'pointer'
        }, onClick: onClick }, { children: [jsx("svg", __assign({ width: "30", height: "15", viewBox: "0 0 15 7" }, { children: jsx("rect", { width: "15", height: "7", style: {
                        strokeWidth: 2,
                        stroke: color,
                        strokeDasharray: dash,
                        fill: 'transparent'
                    } }) })), jsx("span", __assign({ style: {
                    color: Colours.textLight,
                    marginLeft: '.5rem',
                    position: 'relative',
                    top: '-3.5px',
                    textDecoration: hidden ? 'line-through' : 'none'
                } }, { children: text }))] })));
};

var TagsList = function (_a) {
    var tags = _a.tags, onClick = _a.onClick;
    return (jsxs(Fragment, { children: __spreadArray([jsx(YAxis, { yAxisId: "tags", hide: true, domain: [0, 100] }, "tags"), ","], tags === null || tags === void 0 ? void 0 : tags.map(function (tag, index) { return (jsxs(Fragment, { children: [jsx(ReferenceArea, { isFront: true, ifOverflow: "extendDomain", x1: moment(tag.from).valueOf(), yAxisId: "tags", shape: function (_a) {
                        var x = _a.x, y = _a.y, height = _a.height;
                        return (jsx("rect", { x: x, y: y, width: 3, height: height, fill: tag.fill, fillOpacity: tag.opacity }));
                    } }, "".concat(tag.id, "-").concat(index, "-0")), jsx(ReferenceArea, __assign({ isFront: true, ifOverflow: "extendDomain", x1: moment(tag.from).valueOf(), x2: moment(tag.to).valueOf(), y1: 100, yAxisId: "tags", shape: function (_a) {
                        var x = _a.x, y = _a.y, width = _a.width;
                        return (jsx("rect", { onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(tag); }, x: x, y: y, width: width, height: 20, fill: tag.fill, fillOpacity: tag.opacity }));
                    } }, { children: jsx(Label, { value: tag.label, position: "insideTopLeft", fill: tag.color }) }), "".concat(tag.id, "-").concat(index, "-1"))] })); }), true) }));
};

var TooltipContent = function (props) {
    if (!props.payload) {
        return null;
    }
    var timestamp;
    var validPayloads = props.payload.filter(function (c) {
        return !String(c.dataKey).includes('-point') &&
            !String(c.dataKey).includes('-data');
    });
    var data = Object.values(validPayloads.reduce(function (p, validPayload) {
        var list = Object.keys(validPayload.payload || {})
            .filter(function (key) {
            var _a;
            return ((!String(key).includes('-point') &&
                !String(key).includes('-data') &&
                key === validPayload.dataKey) ||
                key === 'timestamp') &&
                !((_a = props.hiddenKeys) === null || _a === void 0 ? void 0 : _a.includes(key));
        })
            .reduce(function (entries, key) {
            var _a;
            if (key === 'timestamp') {
                timestamp = moment(validPayload.payload[key]).format('YYYY-MM-DD HH:mm:ss');
                return entries;
            }
            return __assign(__assign({}, entries), (_a = {}, _a[key] = (jsxs("div", { children: [jsxs("span", __assign({ "data-testid": "tooltip-label", style: { color: validPayload.color } }, { children: [validPayload.name, ":"] })), ' ', jsx("span", __assign({ "data-testid": "tooltip-value" }, { children: validPayload.payload[key] })), ' ', jsx("br", {})] }, key)), _a));
        }, {});
        return __assign(__assign({}, p), list);
    }, {}));
    if (!data.length) {
        return null;
    }
    return (jsxs("div", __assign({ style: { color: 'white', padding: '1rem' } }, { children: [data, jsxs("strong", { children: [timestamp, " ", jsx("br", {})] })] })));
};

var DataTypes;
(function (DataTypes) {
    DataTypes[DataTypes["circle"] = 0] = "circle";
    DataTypes[DataTypes["line"] = 1] = "line";
    DataTypes[DataTypes["bar"] = 2] = "bar";
    DataTypes[DataTypes["flag"] = 3] = "flag";
    DataTypes[DataTypes["area"] = 4] = "area";
    DataTypes[DataTypes["none"] = 5] = "none";
})(DataTypes || (DataTypes = {}));

var useXAxisConfig = function (chart, options) {
    var xAxisConfig = useMemo(function () {
        var _a, _b, _c, _d;
        var startPoint = (_a = chart[0]) === null || _a === void 0 ? void 0 : _a.timestamp;
        var endPoint = (_b = chart[chart.length - 1]) === null || _b === void 0 ? void 0 : _b.timestamp;
        if (options) {
            // NOTE: To avoid conflict between ranges, below restricts to one option, range or start/end
            if (options.range) {
                switch (options.range.from) {
                    case 'start':
                        endPoint = moment(startPoint).add(options.range.interval).valueOf();
                        break;
                    case 'end':
                        startPoint = moment(endPoint)
                            .subtract(options.range.interval)
                            .valueOf();
                        break;
                    default:
                        startPoint = moment(options.range.from.valueOf());
                        endPoint = moment(startPoint).add(options.range.interval);
                }
            }
            else {
                if (options.start) {
                    startPoint = moment(options.start).valueOf();
                }
                if (options.end) {
                    endPoint = moment(options.end).valueOf();
                }
            }
        }
        var domain = [
            startPoint ? startPoint : (_c = xAxisConfig === null || xAxisConfig === void 0 ? void 0 : xAxisConfig.domain) === null || _c === void 0 ? void 0 : _c[0],
            endPoint ? endPoint : (_d = xAxisConfig === null || xAxisConfig === void 0 ? void 0 : xAxisConfig.domain) === null || _d === void 0 ? void 0 : _d[1]
        ];
        var domainTime = scaleTime().domain(domain);
        var timeDiff = moment(endPoint).diff(startPoint, 'days');
        var ticks = timeMonth.every(1);
        var formatter = function (tick) { return moment(tick).format('MMM YYYY'); };
        if (timeDiff > 3 && timeDiff <= 120) {
            ticks = timeDay.every(1);
            formatter = function (tick) {
                return moment(tick).diff(moment(tick).startOf('month'), 'days') === 0
                    ? moment(tick).format('MMM YYYY')
                    : moment(tick).format('MMM DD');
            };
        }
        if (timeDiff > 1 && timeDiff <= 3) {
            ticks = timeHour.every(8);
            formatter = function (tick) {
                return moment(tick).diff(moment(tick).startOf('day'), 'hours') === 0
                    ? moment(tick).format('MMM DD')
                    : moment(tick).format('HH:mm');
            };
        }
        if (timeDiff === 1) {
            ticks = timeHour.every(4);
            formatter = function (tick) {
                return moment(tick).diff(moment(tick).startOf('day'), 'hours') === 0
                    ? moment(tick).format('MMM DD')
                    : moment(tick).format('HH:mm');
            };
        }
        if (timeDiff === 0) {
            timeDiff = moment(startPoint).diff(endPoint, 'minutes');
            if (timeDiff > 1440 / 2) {
                ticks = timeHour.every(2);
            }
            else if (timeDiff > 120) {
                ticks = timeHour.every(1);
            }
            else if (timeDiff > 60) {
                ticks = timeMinute.every(30);
            }
            else if (timeDiff > 30) {
                ticks = timeMinute.every(15);
            }
            else {
                ticks = timeMinute.every(1);
            }
            formatter = function (tick) {
                return moment(tick).diff(moment(tick).startOf('day'), 'minutes') === 0
                    ? moment(tick).format('MMM DD')
                    : moment(tick).format('HH:mm');
            };
        }
        return {
            domain: domain,
            domainTime: domainTime,
            ticks: ticks
                ? domainTime.ticks(ticks).map(function (t) { return t.getTime(); })
                : undefined,
            tickFormatter: function (tick) { return formatter(tick); },
            labelFormatter: function (time) {
                return moment(time).format('YYYY-MM-DD HH:mm:ss');
            }
        };
    }, [chart, options === null || options === void 0 ? void 0 : options.range]);
    return xAxisConfig;
};

var useZoom = function (onZoom, setLineRef) {
    var _a = useState({
        userSelect: 'initial',
        allowDataOverflow: false,
        onMouseUp: function (_e) { },
        onMouseDown: function (_e) { },
        onMouseMove: function (_e) { }
    }), zoomConfig = _a[0], setZoomConfig = _a[1];
    var _b = useState({
        refAreaLeft: null,
        refAreaRight: null
    }), zoomRef = _b[0], setZoomRef = _b[1];
    useEffect(function () {
        if (onZoom === undefined) {
            return setZoomConfig({
                userSelect: 'initial',
                allowDataOverflow: false,
                onMouseUp: function () { },
                onMouseDown: function () { },
                onMouseMove: function () { }
            });
        }
        setZoomConfig({
            userSelect: 'none',
            allowDataOverflow: true,
            onMouseDown: function (e) { return setZoomRef(__assign(__assign({}, zoomRef), { refAreaLeft: e })); },
            onMouseMove: function (e) {
                setLineRef(e);
                if (!zoomRef.refAreaLeft) {
                    return;
                }
                setZoomRef(__assign(__assign({}, zoomRef), { refAreaRight: e }));
            },
            onMouseUp: function () {
                if (zoomRef.refAreaLeft !== zoomRef.refAreaRight &&
                    zoomRef.refAreaRight &&
                    zoomRef.refAreaLeft) {
                    if (zoomRef.refAreaLeft > zoomRef.refAreaRight) {
                        onZoom && onZoom([zoomRef.refAreaRight, zoomRef.refAreaLeft]);
                    }
                    else {
                        onZoom && onZoom([zoomRef.refAreaLeft, zoomRef.refAreaRight]);
                    }
                }
                setZoomRef({ refAreaLeft: null, refAreaRight: null });
            }
        });
    }, [onZoom, zoomRef.refAreaLeft, zoomRef.refAreaRight]);
    return { zoomRef: zoomRef, zoomConfig: zoomConfig };
};

var Graph = function (_a) {
    var _b, _c;
    var _d = _a.datasets, datasets = _d === void 0 ? [] : _d, tags = _a.tags, hideTooltip = _a.hideTooltip, labels = _a.labels, hideLabels = _a.hideLabels, hideData = _a.hideData, mutexLabels = _a.mutexLabels, hideAxis = _a.hideAxis, hideLines = _a.hideLines, hideGrid = _a.hideGrid, _e = _a.options, options = _e === void 0 ? {} : _e, _f = _a.highlights, highlights = _f === void 0 ? [] : _f, onZoom = _a.onZoom, onClick = _a.onClick, onDataClick = _a.onDataClick, onTagClick = _a.onTagClick;
    var _g = useState([]), graph = _g[0], setGraph = _g[1];
    var _h = useState(), lineRef = _h[0], setLineRef = _h[1];
    var _j = useZoom(onZoom, setLineRef), zoomConfig = _j.zoomConfig, zoomRef = _j.zoomRef;
    var chartData = useMemo(function () {
        var data = datasets
            .filter(function (ds) { return ds.data.length; })
            .reduce(function (p, c) {
            // reduce data by timestamp
            c.data.forEach(function (cc) {
                var _a;
                var timestamp = moment(cc.timestamp).valueOf();
                p[timestamp] = __assign(__assign({}, p[timestamp]), (_a = {}, _a["".concat(c.key, "-data")] = cc, _a.timestamp = timestamp, _a));
                p[timestamp][c.key] = cc.value;
                if (cc.path)
                    p[timestamp]["".concat(c.key, "-point")] = cc.value;
            });
            return p;
        }, {});
        return Object.keys(data)
            .sort(function (a, b) { return parseInt(a) - parseInt(b); }) // sort by timestamp
            .map(function (key) { return data[key]; });
    }, [datasets]);
    var xAxisConfig = useXAxisConfig(chartData, options);
    useEffect(function () {
        configureGraph();
    }, [datasets]);
    function configureGraph() {
        var graphTypes = datasets
            .filter(function (ds) { return ds.data.length; })
            .map(function (dataset, i) {
            var _a, _b;
            var label = dataset.label || "".concat(i, " ");
            var key = dataset.key || label;
            return {
                key: key,
                label: label,
                curveType: dataset.curveType,
                type: dataset.type,
                unit: dataset.unit,
                yAxidId: dataset.yAxisId || key,
                dash: (_a = dataset.dash) === null || _a === void 0 ? void 0 : _a.join(', '),
                colour: dataset.color || '#53A2B5',
                opacity: dataset.opacity || 1,
                hidden: !!((_b = graph.find(function (g) { return g.key === dataset.key; })) === null || _b === void 0 ? void 0 : _b.hidden),
                strokeWidth: dataset.strokeWidth,
                hideAxis: dataset.hideAxis,
                hideLegend: dataset.hideLegend,
                range: dataset.range
            };
        });
        setGraph(ensureMutexLabels(graphTypes.sort(function (a, b) { return DataTypes[b.type] - DataTypes[a.type]; })));
    }
    function xPositionToTime(e) {
        if (!e) {
            return;
        }
        var time = xAxisConfig.domainTime.invert(e.chartX);
        var formatTime = moment(time).valueOf();
        return formatTime;
    }
    function handleClick(_a) {
        var dataKey = _a.dataKey, payload = _a.payload;
        if (!onClick) {
            return;
        }
        var data = payload["".concat(dataKey, "-data")];
        if (!data) {
            return;
        }
        onClick(__assign({ key: dataKey }, data));
    }
    function handleDataClick(data, key) {
        onDataClick === null || onDataClick === void 0 ? void 0 : onDataClick({ data: data["".concat(key, "-data")], key: key });
    }
    function toggleLabel(indexToBeToggled) {
        setGraph(function (graph) {
            return graph.map(function (node, index) {
                return index === indexToBeToggled ? __assign(__assign({}, node), { hidden: !node.hidden }) : node;
            });
        });
    }
    function ensureMutexLabels(graph) {
        var newGraph = JSON.parse(JSON.stringify(graph));
        var mutexLabelsIndexes = newGraph.reduce(function (acc, v, index) {
            return (mutexLabels === null || mutexLabels === void 0 ? void 0 : mutexLabels.includes(v.key)) ? __spreadArray(__spreadArray([], acc, true), [index], false) : acc;
        }, []);
        var showingLabels = mutexLabelsIndexes.filter(function (i) { return !newGraph[i].hidden; });
        if (showingLabels.length > 1) {
            mutexLabelsIndexes.forEach(function (labelIndex, i) {
                // Only show the first one
                newGraph[labelIndex].hidden = i !== 0;
            });
        }
        return newGraph;
    }
    function toggleMutexLabel(key, index) {
        var mutexLabelsIndexes = graph.reduce(function (acc, v, index) {
            return (mutexLabels === null || mutexLabels === void 0 ? void 0 : mutexLabels.includes(v.key)) && v.key !== key ? __spreadArray(__spreadArray([], acc, true), [index], false) : acc;
        }, []);
        var newGraph = JSON.parse(JSON.stringify(graph));
        var isHidden = graph[index].hidden;
        if (isHidden) {
            // Hide all
            mutexLabelsIndexes.forEach(function (i) {
                newGraph[i] = __assign(__assign({}, newGraph[i]), { hidden: true });
            });
            newGraph[index].hidden = false;
            setGraph(newGraph);
        }
        else {
            toggleLabel(index);
        }
    }
    var hideChartData = function (key) {
        var index = graph.findIndex(function (v) { return v.key === key; });
        if (index === -1) {
            console.error('Item should exist in array');
            return;
        }
        var isMutexLabel = mutexLabels === null || mutexLabels === void 0 ? void 0 : mutexLabels.includes(key);
        if (isMutexLabel) {
            toggleMutexLabel(key, index);
        }
        else {
            toggleLabel(index);
        }
    };
    var longestYAxisLabelWidth = useMemo(function () {
        var _a, _b, _c;
        var longestLabelKey = (_a = graph.find(function (g) { return !g.hidden; })) === null || _a === void 0 ? void 0 : _a.key;
        var longestLabelUnit = (_b = graph.find(function (g) { return !g.hidden; })) === null || _b === void 0 ? void 0 : _b.unit;
        var highestValue = ((_c = datasets
            .find(function (d) { return d.key === longestLabelKey; })) === null || _c === void 0 ? void 0 : _c.data.reduce(function (acc, v) {
            return v.value > acc ? v.value : acc;
        }, 0)) || 0;
        var width = (String(highestValue).length + (longestLabelUnit || '').length) * 11;
        // Set a minimum width of 45px
        return Math.max(width, 45);
    }, [graph, datasets]);
    return (jsx(Box, __assign({ className: style({ width: '100%', height: '100%', position: 'relative' }), "data-testid": "graph" }, { children: jsx(Box, __assign({ className: style({
                width: '100%',
                height: '100%',
                position: 'absolute',
                top: 0,
                left: 0
            }) }, { children: jsx(ResponsiveContainer, __assign({ className: style({ fontFamily: fontFamily }) }, { children: jsxs(ComposedChart, __assign({ style: { userSelect: zoomConfig.userSelect }, margin: { top: 0, left: 0, right: 0, bottom: 0 }, data: chartData, onMouseUp: function (e) {
                        return lineRef && zoomConfig.onMouseUp(xPositionToTime(e));
                    }, onMouseDown: function (e) {
                        return lineRef && zoomConfig.onMouseDown(xPositionToTime(e));
                    }, onMouseMove: function (e) { return zoomConfig.onMouseMove(xPositionToTime(e)); }, onMouseLeave: function () { return setLineRef(undefined); }, barGap: 0, barSize: 10, maxBarSize: 10 }, { children: [jsx(XAxis, { type: "number", dataKey: "timestamp", stroke: Colours.textLight, allowDataOverflow: true, domain: xAxisConfig.domain, ticks: xAxisConfig.ticks, scale: xAxisConfig.domainTime, tickFormatter: xAxisConfig.tickFormatter, hide: typeof hideAxis === 'object'
                                ? hideAxis.x && !hideAxis.showFirst
                                : hideAxis }), jsx(YAxis, { width: longestYAxisLabelWidth, yAxisId: "left", axisLine: false, tickLine: false, orientation: "left", unit: (_b = graph.find(function (g) { return !g.hidden; })) === null || _b === void 0 ? void 0 : _b.unit, stroke: Colours.textLight, hide: typeof hideAxis === 'object'
                                ? hideAxis.y && !hideAxis.showFirst
                                : hideAxis, domain: ((_c = graph.find(function (g) { return !g.hidden; })) === null || _c === void 0 ? void 0 : _c.range) || [
                                0,
                                function (dataMax) { return Math.ceil(dataMax * 1.1) || 1; }
                            ] }), !hideGrid && (jsx(CartesianGrid, { horizontal: false, stroke: (options === null || options === void 0 ? void 0 : options.gridColor) || Colours.blue })), (typeof hideAxis === 'object' ? hideAxis.x : hideAxis) && (jsx(ReferenceLine, { y: 0, yAxisId: "left", ifOverflow: "extendDomain", stroke: (options === null || options === void 0 ? void 0 : options.gridColor) || Colours.blue })), !hideLines && (jsx(ReferenceLine, { yAxisId: "left", x: lineRef, strokeOpacity: 1, stroke: Colours.blue })), !hideTooltip && (jsx(Tooltip, { cursor: false, filterNull: true, content: function (p) { return (jsx(TooltipContent, __assign({}, p, { hiddenKeys: graph
                                    .filter(function (g) { return g.hideAxis && g.hideLegend; })
                                    .map(function (g) { return g.key; }) }))); }, wrapperStyle: { background: Colours.blue }, labelFormatter: xAxisConfig.labelFormatter })), !hideLabels && (jsx(Legend, { wrapperStyle: { paddingBottom: 10 }, verticalAlign: "top", formatter: function (value) { return (jsx("span", __assign({ style: { color: Colours.textLight } }, { children: value }))); }, content: function (p) { return (jsx(LegendContent, __assign({}, p, { onClick: hideChartData, graph: graph, labels: labels }))); } })), RightYAxis({
                            graph: graph,
                            hideAxis: hideAxis
                        }), AreaDatapoints({
                            graph: graph,
                            handleClick: handleClick,
                            handleDataClick: handleDataClick,
                            hide: hideData
                        }), highlights &&
                            Highlights({
                                highlights: highlights
                            }), LineDatapoints({
                            graph: graph,
                            hide: hideData,
                            handleClick: handleClick,
                            handleDataClick: handleDataClick
                        }), CircleDatapoints({
                            graph: graph,
                            hide: hideData,
                            handleDataClick: handleDataClick
                        }), FlagDatapoints({
                            graph: graph,
                            hide: hideData,
                            handleDataClick: handleDataClick
                        }), BarDatapoints({
                            graph: graph,
                            hide: hideData,
                            handleDataClick: handleDataClick
                        }), 
                        // Workaround. Recharts doesn't support component wrapping
                        tags &&
                            TagsList({
                                tags: tags,
                                onClick: onTagClick
                            }), zoomRef.refAreaLeft && zoomRef.refAreaRight && (jsx(ReferenceArea, { yAxisId: "left", x1: zoomRef.refAreaLeft, x2: zoomRef.refAreaRight, fill: Colours.primary, strokeOpacity: 0.3 }))] })) })) })) })));
};

var AlertGroupGraph = function (_a) {
    var data = _a.data, startDate = _a.startDate, endDate = _a.endDate;
    return (jsx(Stretch, __assign({ sizing: 3, height: percent(100), padding: rem(1), className: style({
            border: "2px solid ".concat(Colours.blue),
            boxSizing: 'border-box'
        }), "data-testid": "alert-groups-graph" }, { children: jsx(Graph, { datasets: data, options: { start: startDate, end: endDate } }) })));
};

var format = {
    timeAmPm: 'h:mma',
    time: 'HH:mm',
    date: 'YYYY-MM-DD',
    datetime: 'YYYY-MM-DD HH:mm:ss',
    wordedDate: 'Do MMM YYYY'
};
var name = {
    cage: {
        singular: 'Unit',
        plural: 'Units'
    }
};
var config = {
    format: format,
    name: name
};

var PercentageBar = function (_a) {
    var percentage = _a.percentage;
    var color = percentageToAlertColor(percentage * 100);
    return (jsx(Horizontal, __assign({ height: px(16), width: percent(100), className: style({
            border: "1px solid ".concat(color),
            boxSizing: 'border-box'
        }), "data-testid": "percentage-bar" }, { children: jsx(Box, { height: percent(100), width: percent(percentage * 100), className: style({
                backgroundColor: color,
                transition: 'all ease 0.3s'
            }) }) })));
};
var percentageToAlertColor = function (percentage) {
    var colors = [
        Colours.green,
        Colours.primary,
        Colours.yellow,
        Colours.orange,
        Colours.red
    ];
    if (percentage === 100)
        return colors[colors.length - 1];
    var index = Math.floor(percentage / (100 / colors.length));
    return colors[index];
};

var AlertGroupsList = function (_a) {
    var groups = _a.groups, selectedGroup = _a.selectedGroup, onSelect = _a.onSelect;
    var t = useTranslation().t;
    return (jsx(Vertical, __assign({ spacing: rem(0.5), height: percent(100), sizing: 1, scroll: "vertical", "data-testid": "alert-groups-list" }, { children: groups.map(function (group, i) {
            var timeRange = "".concat(moment(group.range.start).format(config.format.timeAmPm), " - ").concat(moment(group.range.end).format(config.format.timeAmPm));
            return (jsxs(Vertical, __assign({ spacing: px(10), padding: rem(0.5), className: classes(alertGroup, selectedGroup === i && 'selected'), onClick: function () { return onSelect(i); }, "data-testid": "alert-group" }, { children: [jsxs(Grid, __assign({ spacing: [rem(0.5), 0], padding: [0, rem(0.5)], "data-testid": "alert-group-title" }, { children: [jsxs(Content, { children: [t('Group'), " ", i + 1] }), jsx(StretchSpacer, {}), jsx(Content, __assign({ className: style({
                                    fontSize: rem(0.85)
                                }) }, { children: timeRange }))] })), jsx(PercentageBar, { percentage: group.averagePercentage })] }), "alert-group-".concat(i)));
        }) })));
};
var alertGroup = style({
    cursor: 'pointer',
    backgroundColor: Colours.darkerBlue,
    color: Colours.textLight,
    fontFamily: fontFamily,
    fontSize: Sizes.fontSize2,
    boxSizing: 'content-box',
    border: "2px solid ".concat(Colours.blue),
    $nest: {
        '&.selected': {
            border: "1px solid ".concat(Colours.primary)
        }
    }
});

var AlertGroupUnits = function (_a) {
    var video = _a.video;
    var t = useTranslation().t;
    return (jsxs(Horizontal, __assign({ horizontalAlign: "center", padding: rem(0.5), className: style({
            fontFamily: fontFamily,
            border: "2px solid ".concat(Colours.blue)
        }) }, { children: [jsxs(Horizontal, __assign({ sizing: "stretch", horizontalAlign: "center", verticalAlign: "baseline", spacing: rem(0.5), "data-testid": "alert-group-unit-unit" }, { children: [jsx("span", __assign({ className: styles$g.label }, { children: t('Unit') })), jsx("span", __assign({ className: styles$g.value }, { children: video.cageId }))] })), jsxs(Horizontal, __assign({ sizing: "stretch", horizontalAlign: "center", spacing: rem(0.5), "data-testid": "alert-group-unit-pellets" }, { children: [jsx("span", __assign({ className: styles$g.label }, { children: t('Pellets') })), jsx("span", __assign({ className: styles$g.value }, { children: video.noPellets }))] })), jsxs(Horizontal, __assign({ sizing: "stretch", horizontalAlign: "center", spacing: rem(0.5), "data-testid": "alert-group-unit-activity" }, { children: [jsx("span", __assign({ className: styles$g.label }, { children: t('Activity') })), jsxs("span", __assign({ className: styles$g.value }, { children: [Math.round(video.activity * 100), "%"] }))] })), jsxs(Horizontal, __assign({ sizing: "stretch", horizontalAlign: "center", spacing: rem(0.5), "data-testid": "alert-group-unit-depth" }, { children: [jsx("span", __assign({ className: styles$g.label }, { children: t('Depth') })), jsxs("span", __assign({ className: styles$g.value }, { children: [video.depth, "m"] }))] }))] })));
};
var styles$g = stylesheet({
    label: {
        color: Colours.textDark,
        fontSize: Sizes.fontSize2
    },
    value: {
        color: Colours.textLight,
        fontSize: Sizes.fontSize2
    }
});

var videoExtensions = ['.mpg', '.mp2', '.mpeg', '.mpe', '.mpv', '.mp4']; //you can add more extensions
var isVideo = function (src) {
    return videoExtensions.some(function (e) { return src.includes(e); });
};

var Icon = function (_a) {
    var icon = _a.icon, color = _a.color, className = _a.className;
    return (jsx(FontAwesomeIcon, { icon: icon, color: color, className: classes(style({ height: '17px' }), className), "data-testid": "icon" }));
};

var VideoSlider = function (_a) {
    var video = _a.video, onNext = _a.onNext, onPrevious = _a.onPrevious, hasNext = _a.hasNext, hasPrevious = _a.hasPrevious;
    var videoRef = useRef(null);
    var srcIsVideo = (video === null || video === void 0 ? void 0 : video.url) && isVideo(video === null || video === void 0 ? void 0 : video.url);
    useEffect(function () {
        var _a, _b;
        (_b = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.load) === null || _b === void 0 ? void 0 : _b.call(_a);
    }, [video]);
    return (jsxs(Horizontal, __assign({ padding: [rem(1), rem(0.5)], spacing: 10, className: style({
            position: 'relative',
            boxSizing: 'border-box'
        }), verticalAlign: "center", sizing: "stretch", width: percent(100) }, { children: [jsx(Box, __assign({ "data-testid": "alert-group-video-previous", onClick: function () { return hasPrevious && onPrevious(); } }, { children: jsx(Icon, { className: classes(styles$f.icon, !hasPrevious && 'disabled'), icon: faCaretLeft }) })), jsxs(Stretch, __assign({ height: percent(100), width: percent(100), className: style({ position: 'relative' }) }, { children: [srcIsVideo ? (jsx("video", __assign({ "data-testid": "alert-group-video", ref: videoRef, autoPlay: true, loop: true, className: styles$f.media }, { children: jsx("source", { src: video === null || video === void 0 ? void 0 : video.url }) }))) : (jsx("img", { "data-testid": "alert-group-image", className: styles$f.media, src: video === null || video === void 0 ? void 0 : video.url })), (video === null || video === void 0 ? void 0 : video.timestamp) && video.timestamp.length && (jsx(Content, __assign({ width: percent(100), horizontalAlign: "center", className: styles$f.timeStamp, "data-testid": "alert-group-video-timestamp" }, { children: jsx(Box, __assign({ className: style({
                                background: color('#000').fade(0.5).toString(),
                                fontSize: Sizes.fontSize2,
                                fontFamily: fontFamily
                            }), padding: [rem(0.25), rem(0.5)] }, { children: moment(video === null || video === void 0 ? void 0 : video.timestamp).format(config.format.datetime) })) })))] })), jsx(Box, __assign({ "data-testid": "alert-group-video-next", onClick: function () { return hasNext && onNext(); } }, { children: jsx(Icon, { className: classes(styles$f.icon, !hasNext && 'disabled', style({ right: 0 })), icon: faCaretRight }) }))] })));
};
var styles$f = stylesheet({
    icon: {
        cursor: 'pointer',
        width: important(px(32)),
        height: important(px(50)),
        transition: 'color ease .2s',
        color: Colours.textDark,
        $nest: {
            '&:hover': {
                color: Colours.textLight
            },
            '&.disabled': {
                color: 'transparent',
                cursor: 'default'
            }
        }
    },
    media: {
        width: percent(100),
        height: percent(100),
        position: 'absolute',
        inset: px(0),
        margin: 'auto',
        display: 'block'
    },
    timeStamp: {
        position: 'absolute',
        top: rem(0.5),
        color: '#ccc'
    }
});

var AlertGroupVideos = function (_a) {
    var group = _a.group, onVideoChange = _a.onVideoChange;
    var _b = useState(0), currentVideoIndex = _b[0], setCurrentVideoIndex = _b[1];
    useEffect(function () {
        setCurrentVideoIndex(0);
    }, [group]);
    var currentVideo = useMemo(function () {
        return group === null || group === void 0 ? void 0 : group.videos[currentVideoIndex];
    }, [currentVideoIndex, group]);
    var hasNext = useMemo(function () {
        return (group &&
            group.videos.length > 1 &&
            currentVideoIndex !== group.videos.length - 1);
    }, [currentVideo, group]);
    var hasPrevious = useMemo(function () {
        return group && group.videos.length > 1 && currentVideoIndex !== 0;
    }, [currentVideo, group]);
    var handleOnPrevious = function () {
        var index = currentVideoIndex - 1;
        setCurrentVideoIndex(index);
        onVideoChange(index);
    };
    var handleOnNext = function () {
        var index = currentVideoIndex + 1;
        setCurrentVideoIndex(index);
        onVideoChange(index);
    };
    return (jsxs(Vertical, __assign({ sizing: "stretch", height: percent(100), spacing: rem(1), "data-testid": "alert-group-videos" }, { children: [currentVideo && jsx(PercentageBar, { percentage: currentVideo.percentage }), jsx(VideoSlider, { video: currentVideo, onPrevious: handleOnPrevious, onNext: handleOnNext, hasNext: hasNext, hasPrevious: hasPrevious }), currentVideo && jsx(AlertGroupUnits, { video: currentVideo })] })));
};

var AlertGroups = function (_a) {
    var groups = _a.groups, graphData = _a.graphData, loading = _a.loading, startDate = _a.startDate, endDate = _a.endDate, selectedGroupIndex = _a.selectedGroupIndex, onSelectGroup = _a.onSelectGroup, onVideoChange = _a.onVideoChange;
    var selectedGroup = useMemo(function () { return groups[selectedGroupIndex]; }, [groups, selectedGroupIndex]);
    var handleSelectGroup = function (index) {
        onSelectGroup(index);
    };
    return (jsxs(Horizontal, __assign({ height: percent(100), width: percent(100), className: style({
            overflow: 'hidden',
            boxSizing: 'border-box'
        }), padding: rem(1) }, { children: [jsxs(Vertical, __assign({ sizing: 3, spacing: rem(0.5), className: style({ overflow: 'hidden' }) }, { children: [jsx(AlertGroupVideos, { group: selectedGroup, onVideoChange: onVideoChange }), jsx(Horizontal, __assign({ spacing: rem(1), sizing: 'stretch', maxHeight: percent(40) }, { children: loading ? (jsx(Loader, {})) : (jsxs(Fragment, { children: [jsx(AlertGroupGraph, { startDate: startDate, endDate: endDate, data: graphData }, 'graph-' + selectedGroupIndex), jsx(AlertGroupFarmers, { farmers: selectedGroup === null || selectedGroup === void 0 ? void 0 : selectedGroup.farmers }, 'farmers-' + selectedGroupIndex)] })) }), selectedGroupIndex)] })), jsx(AlertGroupsList, { groups: groups, onSelect: handleSelectGroup, selectedGroup: selectedGroupIndex })] })));
};

var Button = function (_a) {
    var icon = _a.icon, _b = _a.iconPosition, iconPosition = _b === void 0 ? 'left' : _b, onClick = _a.onClick, content = _a.content, _c = _a.appearance, appearance = _c === void 0 ? 'transparent' : _c, disabled = _a.disabled, fullWidth = _a.fullWidth, _d = _a.size, size = _d === void 0 ? 'normal' : _d, _e = _a.iconColor, iconColor = _e === void 0 ? Colours.textLight : _e, type = _a.type, loading = _a.loading, dataTestId = _a["data-testid"];
    var isDisabled = disabled || loading;
    return (jsxs("button", __assign({ disabled: isDisabled, className: classes(styles$e.button, content && styles$e.withContent, !isDisabled && styles$e[appearance], fullWidth && 'full-width', styles$e[size]), onClick: onClick, type: type, "data-testid": dataTestId || 'button' }, { children: [jsxs(Horizontal, __assign({ spacing: rem(0.5), verticalAlign: "center", horizontalAlign: fullWidth || (icon && !content) ? 'center' : 'left' }, { children: [icon && iconPosition === 'left' && (jsx(Icon, { icon: icon, color: iconColor, className: styles$e.icon })), content && (jsx(Content, __assign({ className: style({
                            visibility: loading ? 'hidden' : 'visible'
                        }) }, { children: content }))), icon && iconPosition === 'right' && (jsx(Icon, { icon: icon, color: iconColor, className: styles$e.icon }))] })), loading && (jsx(Stretch, __assign({ className: style({
                    position: 'absolute',
                    top: percent(50),
                    left: percent(50),
                    transform: 'translate(-50%, -50%)'
                }), verticalAlign: "center", horizontalAlign: "center" }, { children: jsx(Loader, {}) })))] })));
};
var styles$e = stylesheet({
    button: {
        minWidth: px(40),
        padding: padding(0, rem(0.5)),
        cursor: 'pointer',
        color: Colours.textLight,
        border: 'none',
        borderRadius: px(5),
        boxSizing: 'border-box',
        outline: 'none',
        position: 'relative',
        $nest: {
            '&.transparent': {
                backgroundColor: 'transparent'
            },
            '&:active': {
                backgroundColor: color(Colours.blue).fadeOut(0.9, true).toHexString()
            },
            '&:disabled': {
                border: "1px solid ".concat(Colours.darkerBlue),
                color: Colours.textDark,
                backgroundColor: 'transparent',
                cursor: 'default'
            },
            '&.full-width': {
                width: percent(100)
            }
        }
    },
    small: {
        height: rem(2)
    },
    normal: {
        height: rem(2.5)
    },
    large: {
        height: rem(3.5)
    },
    transparent: {
        background: 'transparent'
    },
    dark: {
        background: Colours.darkBlue,
        border: "1px solid ".concat(Colours.blue)
    },
    blue: {
        background: Colours.primary,
        color: important('white'),
        fontWeight: 600,
        $nest: {
            '&:active': {
                backgroundColor: important(color(Colours.primary).lighten(0.1).toHexString())
            }
        }
    },
    red: {
        background: Colours.red,
        color: important('white'),
        fontWeight: 600,
        $nest: {
            '&:active': {
                backgroundColor: important(color(Colours.red).lighten(0.1).toHexString())
            }
        }
    },
    green: {
        background: Colours.green,
        color: important('white'),
        fontWeight: 600,
        $nest: {
            '&:active': {
                backgroundColor: important(color(Colours.green).lighten(0.1).toHexString())
            }
        }
    },
    hollow: {
        border: "1px solid ".concat(Colours.blue),
        backgroundColor: 'transparent'
    },
    'hollow-blue': {
        border: "1px solid ".concat(Colours.primary),
        backgroundColor: 'transparent'
    },
    'hollow-red': {
        border: "1px solid ".concat(Colours.red),
        backgroundColor: 'transparent'
    },
    'hollow-green': {
        border: "1px solid ".concat(Colours.green),
        backgroundColor: 'transparent'
    },
    icon: {
        height: rem(1),
        width: rem(1)
    },
    withContent: {
        padding: important(padding(0, rem(1)))
    }
});

var IconButton = function (_a) {
    var icon = _a.icon, onClick = _a.onClick;
    return (jsx("div", __assign({ onClick: onClick, className: iconButton, "data-testid": "icon-button" }, { children: jsx(Icon, { icon: icon }) })));
};
var iconButton = style({
    cursor: 'pointer',
    width: px(36),
    height: px(36),
    borderRadius: px(2),
    display: 'grid',
    placeItems: 'center'
});

var events = {exports: {}};

var R = typeof Reflect === 'object' ? Reflect : null;
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  };

var ReflectOwnKeys;
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys;
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
};

function EventEmitter() {
  EventEmitter.init.call(this);
}
events.exports = EventEmitter;
events.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    }
    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}

var LONG_PRESS_DURATION_IN_MS = 420;
var DataAttributes;
(function (DataAttributes) {
    DataAttributes["MenuId"] = "data-contextmenu-menu-id";
    DataAttributes["DataId"] = "data-contextmenu-data-id";
})(DataAttributes || (DataAttributes = {}));
var isTouchEvent = function (event) {
    return !!event.targetTouches;
};
var createMenuEvent = function (event, data) {
    var clientX;
    var clientY;
    if (isTouchEvent(event)) {
        var touch = event.targetTouches[0];
        clientX = touch.clientX;
        clientY = touch.clientY;
    }
    else {
        clientX = event.clientX;
        clientY = event.clientY;
    }
    return {
        clientX: clientX,
        clientY: clientY,
        data: data
    };
};
var getData = function (target) {
    var data = undefined;
    if (target) {
        var dataId = target.getAttribute(DataAttributes.DataId);
        data = dataId ? fetchHandlerData(dataId) : undefined;
    }
    return data;
};
var GenericHandlers = {
    handleContextMenu: function (event, target) {
        // When menus are triggered using Ctrl + Right Click, we bring up the native context menu.
        if (event.ctrlKey)
            return;
        var menuId = target ? target.getAttribute(DataAttributes.MenuId) : null;
        var handler = menuId
            ? getLocalMenuHandler(menuId)
            : getGlobalMenuHandler();
        if (!handler)
            return;
        event.preventDefault();
        event.stopPropagation();
        var data = getData(target);
        var menuEvent = createMenuEvent(event, data);
        hideAllMenus();
        handler(menuEvent);
    },
    handleTouchStart: function (event, target) {
        var menuId = target ? target.getAttribute(DataAttributes.MenuId) : null;
        var handler = menuId
            ? getLocalMenuHandler(menuId)
            : getGlobalMenuHandler();
        if (!handler || hasLongPressTimeout())
            return;
        var data = getData(target);
        var menuEvent = createMenuEvent(event, data);
        addLongPressTimeout(function () {
            clearLongPressTimeout();
            hideAllMenus();
            handler(menuEvent);
        }, LONG_PRESS_DURATION_IN_MS);
    },
    handleTouchCancel: function (_event, _target) {
        return clearLongPressTimeout();
    }
};
var GlobalHandlers = {
    handleContextMenu: function (e) {
        return GenericHandlers.handleContextMenu(e, null);
    },
    handleTouchStart: function (e) {
        return GenericHandlers.handleTouchStart(e, null);
    },
    handleTouchMove: function (e) {
        return GenericHandlers.handleTouchCancel(e, null);
    },
    handleTouchEnd: function (e) { return GenericHandlers.handleTouchCancel(e, null); },
    handleTouchCancel: function (e) {
        return GenericHandlers.handleTouchCancel(e, null);
    }
};
var LocalHandlers = {
    handleContextMenu: function (e) {
        return GenericHandlers.handleContextMenu(e, e.currentTarget);
    },
    handleTouchStart: function (e) {
        return GenericHandlers.handleTouchStart(e, e.currentTarget);
    },
    handleTouchMove: function (e) {
        return GenericHandlers.handleTouchCancel(e, e.currentTarget);
    },
    handleTouchEnd: function (e) {
        return GenericHandlers.handleTouchCancel(e, e.currentTarget);
    },
    handleTouchCancel: function (e) {
        return GenericHandlers.handleTouchCancel(e, e.currentTarget);
    }
};

/**
 * @author Timur Kuzhagaliyev <tim.kuzh@gmail.com>
 * @copyright 2020
 * @license MIT
 */
var warn = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var parts = ["[react-context-menu-wrapper]"].concat(args);
    console.warn.apply(null, parts);
};
var isMobileDevice = typeof window.orientation !== 'undefined' ||
    navigator.userAgent.indexOf('IEMobile') !== -1;
var determineMenuPlacement = function (clientX, clientY, menuWidth, menuHeight) {
    var left, top;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    if (isMobileDevice) {
        // On mobile devices, horizontally centre the menu on the tap, and place it above the tap
        var halfWidth = menuWidth / 2;
        left = clientX - halfWidth;
        top = clientY - menuHeight - 20;
    }
    else {
        // On desktop, mimic native context menu placement
        var placeToTheLeftOfCursor = windowWidth - clientX > menuWidth;
        var placeBelowCursor = windowHeight - clientY > menuHeight;
        left = placeToTheLeftOfCursor ? clientX : clientX - menuWidth;
        top = placeBelowCursor ? clientY : clientY - menuHeight;
    }
    // If menu overflows the page, try to nudge it in the correct direction, applying a small buffer
    var buffer = 5;
    var right = windowWidth - left - menuWidth;
    var bottom = windowHeight - top - menuHeight;
    if (right < 0)
        left += right - buffer;
    if (bottom < 0)
        top += bottom - buffer;
    if (left < 0)
        left = buffer;
    if (top < 0)
        top = buffer;
    return {
        left: left,
        top: top
    };
};

/**
 * @author Timur Kuzhagaliyev <tim.kuzh@gmail.com>
 * @copyright 2020
 * @license MIT
 */
var EventName;
(function (EventName) {
    EventName["RequestMenu"] = "request_menu";
    EventName["RequestGlobalMenu"] = "request_global_menu";
    EventName["CloseAllMenus"] = "close_all_menus";
})(EventName || (EventName = {}));
var HideReason;
(function (HideReason) {
    HideReason[HideReason["Manual"] = 0] = "Manual";
})(HideReason || (HideReason = {}));
var state;
var initWindowState = function () {
    state = {
        emitter: new events.exports.EventEmitter(),
        localMenuHandlers: {},
        globalMenuHandlers: [],
        longPressTimeout: null,
        handlerDataMap: {}
    };
    state.emitter.setMaxListeners(Infinity);
    window.__ReactContextMenuWrapper = state;
    document.body.addEventListener('contextmenu', GlobalHandlers.handleContextMenu);
    document.body.addEventListener('touchstart', GlobalHandlers.handleTouchStart);
    document.body.addEventListener('touchmove', GlobalHandlers.handleTouchMove);
    document.body.addEventListener('touchend', GlobalHandlers.handleTouchEnd);
    document.body.addEventListener('touchcancel', GlobalHandlers.handleTouchCancel);
};
var hideAllMenus = function () {
    state.emitter.emit(EventName.CloseAllMenus);
};
var addGenericListener = function (name, listener) {
    state.emitter.addListener(name, listener);
};
var removeGenericListener = function (name, listener) {
    state.emitter.removeListener(name, listener);
};
var addLocalMenuHandler = function (menuId, handler) {
    if (state.localMenuHandlers[menuId]) {
        warn("Detected duplicate menu id: ".concat(menuId, ". Only the last one will be used."));
    }
    state.localMenuHandlers[menuId] = handler;
};
var getLocalMenuHandler = function (menuId) {
    return state.localMenuHandlers[menuId];
};
var removeLocalMenuHandler = function (menuId) {
    delete state.localMenuHandlers[menuId];
};
var addGlobalMenuHandler = function (handler) {
    if (state.globalMenuHandlers.length > 0) {
        warn('You have defined multiple global menus. Only the last one will be used');
    }
    state.globalMenuHandlers.push(handler);
};
var getGlobalMenuHandler = function () {
    if (state.globalMenuHandlers.length <= 0)
        return undefined;
    return state.globalMenuHandlers[state.globalMenuHandlers.length - 1];
};
var removeGlobalMenuHandler = function (handler) {
    var handlerIndex = state.globalMenuHandlers.indexOf(handler);
    if (handlerIndex !== -1)
        state.globalMenuHandlers.splice(handlerIndex);
};
var addLongPressTimeout = function (callback, timeout) {
    state.longPressTimeout = setTimeout(callback, timeout);
};
var hasLongPressTimeout = function () {
    return typeof state.longPressTimeout === 'number';
};
var clearLongPressTimeout = function () {
    var timeoutId = state.longPressTimeout;
    if (timeoutId === null)
        return;
    state.longPressTimeout = null;
    clearTimeout(timeoutId);
};
var generateHandlerDataId = function () { return shortid.generate(); };
var saveHandlerData = function (dataId, data) {
    if (data === undefined)
        return;
    state.handlerDataMap[dataId] = data;
};
var fetchHandlerData = function (dataId) {
    return state.handlerDataMap[dataId];
};
var deleteHandlerData = function (dataId) {
    delete state.handlerDataMap[dataId];
};

/**
 * @author Timur Kuzhagaliyev <tim.kuzh@gmail.com>
 * @copyright 2020
 * @license MIT
 */
var UNINITIALIZED_SENTINEL = {};
var useLazyValue = function (factory) {
    var valueRef = useRef(UNINITIALIZED_SENTINEL);
    if (valueRef.current === UNINITIALIZED_SENTINEL)
        valueRef.current = factory();
    return valueRef.current;
};
var ContextMenuEventContext = createContext(null);
var useContextMenuEvent = function () {
    var context;
    try {
        context = useContext(ContextMenuEventContext);
    }
    catch (_a) {
        context = null;
    }
    return context;
};
var useContextMenuTrigger = function (parameters) {
    var menuId = parameters.menuId, data = parameters.data;
    // If user did not provide a ref, we simply generate a new one.
    var ref = parameters.ref ? parameters.ref : useRef(null);
    // Define data ID to be constant throughout the lifetime of the trigger.
    var dataId = useLazyValue(function () { return generateHandlerDataId(); });
    useEffect(function () {
        saveHandlerData(dataId, data);
        return function () { return deleteHandlerData(dataId); };
    }, [data]);
    useEffect(function () {
        var current = ref.current;
        if (!current)
            return;
        if (menuId)
            current.setAttribute(DataAttributes.MenuId, menuId);
        current.setAttribute(DataAttributes.DataId, dataId);
        current.addEventListener('contextmenu', LocalHandlers.handleContextMenu);
        current.addEventListener('touchstart', LocalHandlers.handleTouchStart);
        current.addEventListener('touchmove', LocalHandlers.handleTouchMove);
        current.addEventListener('touchend', LocalHandlers.handleTouchEnd);
        current.addEventListener('touchcancel', LocalHandlers.handleTouchCancel);
        return function () {
            current.removeAttribute(DataAttributes.MenuId);
            current.removeAttribute(DataAttributes.DataId);
            current.removeEventListener('contextmenu', LocalHandlers.handleContextMenu);
            current.removeEventListener('touchstart', LocalHandlers.handleTouchStart);
            current.removeEventListener('touchmove', LocalHandlers.handleTouchMove);
            current.removeEventListener('touchend', LocalHandlers.handleTouchEnd);
            current.removeEventListener('touchcancel', LocalHandlers.handleTouchCancel);
        };
    }, [ref.current]);
    return ref;
};
var useMenuToggleMethods = function (lastShowMenuEvent, setShowMenuEvent, onShow, onHide) {
    var showMenu = useCallback(function (event) {
        setShowMenuEvent(event);
        if (onShow)
            onShow(event);
    }, [setShowMenuEvent, onShow]);
    var hideMenu = useCallback(function () {
        if (lastShowMenuEvent === null)
            return;
        setShowMenuEvent(null);
        if (onHide)
            onHide();
    }, [lastShowMenuEvent, setShowMenuEvent, onHide]);
    return [showMenu, hideMenu];
};
var useMenuPlacementStyle = function (wrapperRef, lastShowMenuEvent, setMenuPlacementStyle) {
    useEffect(function () {
        if (lastShowMenuEvent) {
            var clientX = lastShowMenuEvent.clientX, clientY = lastShowMenuEvent.clientY;
            var menuWidth = 200;
            var menuHeight = 200;
            if (wrapperRef.current) {
                menuWidth = wrapperRef.current.offsetWidth;
                menuHeight = wrapperRef.current.offsetHeight;
            }
            setMenuPlacementStyle(determineMenuPlacement(clientX, clientY, menuWidth, menuHeight));
        }
        return function () { return setMenuPlacementStyle(null); };
    }, [lastShowMenuEvent, wrapperRef.current]);
};
var useInternalHandlers = function (wrapperRef, lastShowMenuEvent, showMenu, hideMenu, id, global, hideOnSelfClick, hideOnOutsideClick, hideOnEscape, hideOnScroll, hideOnWindowResize) {
    var isVisible = !!lastShowMenuEvent;
    var handleClick = useCallback(function (event) {
        var node = wrapperRef.current;
        if (!node || !isVisible)
            return;
        var wasOutside = event.target !== node && !node.contains(event.target);
        if (wasOutside && hideOnOutsideClick) {
            hideMenu();
        }
        else if (hideOnSelfClick) {
            if (event.touches)
                setTimeout(function () { return hideMenu(); }, 200);
            else
                hideMenu();
        }
    }, [
        hideMenu,
        isVisible,
        wrapperRef.current,
        hideOnSelfClick,
        hideOnOutsideClick
    ]);
    var handleKeydown = useCallback(function (event) {
        if (!isVisible)
            return;
        // Hide on escape
        if (event.key === 'Escape' || event.code === 'Escape')
            hideMenu();
    }, [hideMenu, isVisible]);
    useEffect(function () {
        document.addEventListener('click', handleClick);
        document.addEventListener('touchstart', handleClick);
        if (hideOnEscape)
            document.addEventListener('keydown', handleKeydown);
        if (hideOnScroll)
            document.addEventListener('scroll', hideMenu);
        if (hideOnWindowResize)
            window.addEventListener('resize', hideMenu);
        addGenericListener(EventName.CloseAllMenus, hideMenu);
        if (global)
            addGlobalMenuHandler(showMenu);
        else if (id)
            addLocalMenuHandler(id, showMenu);
        else
            warn('A menu should either be global or have an ID specified!');
        return function () {
            document.removeEventListener('click', handleClick);
            document.removeEventListener('touchstart', handleClick);
            if (hideOnEscape)
                document.removeEventListener('keydown', handleKeydown);
            if (hideOnScroll)
                document.removeEventListener('scroll', hideMenu);
            if (hideOnWindowResize)
                window.removeEventListener('resize', hideMenu);
            removeGenericListener(EventName.CloseAllMenus, hideMenu);
            if (global)
                removeGlobalMenuHandler(showMenu);
            else if (id)
                removeLocalMenuHandler(id);
        };
    }, [
        showMenu,
        hideMenu,
        id,
        global,
        handleClick,
        handleKeydown,
        hideOnEscape,
        hideOnScroll,
        hideOnWindowResize
    ]);
};

var ContextMenuWrapper$1 = React__default.memo(function (_a) {
    var id = _a.id, global = _a.global, children = _a.children, onShow = _a.onShow, onHide = _a.onHide, hideOnSelfClick = _a.hideOnSelfClick, hideOnOutsideClick = _a.hideOnOutsideClick, hideOnEscape = _a.hideOnEscape, hideOnScroll = _a.hideOnScroll, hideOnWindowResize = _a.hideOnWindowResize;
    var wrapperRef = useRef();
    var _b = useState(null), lastShowMenuEvent = _b[0], setShowMenuEvent = _b[1];
    var _c = useState(null), placementStyle = _c[0], setMenuPlacementStyle = _c[1];
    var _d = useMenuToggleMethods(lastShowMenuEvent, setShowMenuEvent, onShow, onHide), showMenu = _d[0], hideMenu = _d[1];
    useInternalHandlers(wrapperRef, lastShowMenuEvent, showMenu, hideMenu, id, global, hideOnSelfClick, hideOnOutsideClick, hideOnEscape, hideOnScroll, hideOnWindowResize);
    useMenuPlacementStyle(wrapperRef, lastShowMenuEvent, setMenuPlacementStyle);
    if (!lastShowMenuEvent)
        return null;
    var style = __assign({ position: 'fixed', left: -9999, top: -9999, zIndex: 999 }, placementStyle);
    return (jsx("div", __assign({ ref: wrapperRef, style: style }, { children: jsx(ContextMenuEventContext.Provider, __assign({ value: {
                lastShowMenuEvent: lastShowMenuEvent,
                hideMenu: hideMenu
            } }, { children: children })) })));
});
ContextMenuWrapper$1.defaultProps = {
    id: undefined,
    global: false,
    onShow: undefined,
    onHide: undefined,
    hideOnSelfClick: true,
    hideOnOutsideClick: true,
    hideOnEscape: true,
    hideOnScroll: true,
    hideOnWindowResize: true
};

initWindowState();

var ContextMenuWrapper = React__default.memo(function (_a) {
    var children = _a.children, menu = _a.menu, fitContainer = _a.fitContainer;
    var contextMenuId = useMemo(function () { return shortid(); }, []);
    var trigger = useContextMenuTrigger({
        menuId: contextMenuId,
        data: {}
    });
    return (jsxs(Content, __assign({ "data-testid": CONTEXT_MENU_WRAPPER_TEST_ID, className: classes(fitContainer && style({ width: percent(100), height: percent(100) })) }, { children: [jsx(Content, __assign({ width: percent(100), height: percent(100), ref: trigger }, { children: children })), jsx(ContextMenuWrapper$1, __assign({ hideOnSelfClick: false, id: contextMenuId }, { children: menu }))] })));
});
var CONTEXT_MENU_WRAPPER_TEST_ID = 'context-menu-wrapper';

var MenuItemIcon = function (_a) {
    var icon = _a.icon, className = _a.className;
    var isDefinition = !!icon.icon;
    if (isDefinition) {
        return jsx(Icon, { icon: icon, className: className });
    }
    else {
        var Icon_1 = icon;
        return jsx(Icon_1, { width: 20, height: 20, className: className });
    }
};

var menuItem = style({
    color: Colours.textLight,
    background: Colours.darkBlue,
    padding: padding(5, 10),
    cursor: 'pointer',
    textTransform: 'none',
    $nest: {
        '&:hover': {
            background: Colours.primary,
            color: '#16181D'
        },
        '&.disabled': {
            background: Colours.darkerBlue,
            color: Colours.textDisabled,
            cursor: 'default',
            textDecoration: 'line-through'
        },
        '&.alt': {
            padding: padding(8, 16),
            $nest: {
                '&:hover': {
                    background: Colours.blue,
                    $nest: {
                        '&:not(.selected)': {
                            color: Colours.textLight
                        }
                    }
                }
            }
        },
        '&.selected': {
            color: Colours.white
        },
        '&.has-submenu': {
            cursor: 'default'
        }
    }
});
var menuList = style({
    display: important('block'),
    minWidth: 'max-content',
    cursor: 'pointer',
    boxShadow: boxShadow,
    fontFamily: fontFamily
});

var MenuScrollItem = function (_a) {
    var alt = _a.alt, direction = _a.direction, disabled = _a.disabled, width = _a.width, onClick = _a.onClick;
    return (jsx(Horizontal$1, __assign({ spacing: 10, verticalAlign: "center", horizontalAlign: "center", className: classes(menuItem, style({ boxSizing: 'border-box', overflow: 'hidden', boxShadow: 'none' }), disabled && 'disabled', alt && 'alt'), width: width, onClick: onClick, "data-testid": "menu-item" }, { children: jsx(Icon, { icon: direction === 'up' ? faAngleUp : faAngleDown }) })));
};

var SubMenu = function (_a) {
    var _b, _c;
    var title = _a.title, groups = _a.groups, _d = _a.accIndex, accIndex = _d === void 0 ? 0 : _d, alt = _a.alt, onClick = _a.onClick, hasParent = _a.hasParent, selectedItem = _a.selectedItem, keepOpenOnSelect = _a.keepOpenOnSelect;
    var ref = useRef(null);
    var _e = useState(true), isAtTheTop = _e[0], setIsAtTheTop = _e[1];
    var _f = useState(false), isAtTheBottom = _f[0], setIsAtTheBottom = _f[1];
    var contextMenu = useContextMenuEvent();
    useEffect(function () {
        var _a;
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', onScroll);
        return function () { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('scroll', onScroll); };
    }, [ref]);
    var handleScrollClick = function (e, direction) {
        var _a, _b, _c;
        e.stopPropagation();
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scroll({
            behavior: 'smooth',
            top: direction === 'up'
                ? (((_b = ref.current) === null || _b === void 0 ? void 0 : _b.scrollTop) || 0) - 100
                : (((_c = ref.current) === null || _c === void 0 ? void 0 : _c.scrollTop) || 0) + 100
        });
    };
    var onScroll = function () {
        var _a, _b, _c, _d, _e;
        setIsAtTheTop(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollTop) === 0);
        setIsAtTheBottom(((_b = ref.current) === null || _b === void 0 ? void 0 : _b.clientHeight)
            ? ((_c = ref.current) === null || _c === void 0 ? void 0 : _c.scrollHeight) - ((_d = ref.current) === null || _d === void 0 ? void 0 : _d.scrollTop) ===
                ((_e = ref.current) === null || _e === void 0 ? void 0 : _e.clientHeight)
            : false);
    };
    var overflows = useMemo(function () { return groups.flat().length > 10; }, [groups]);
    return (jsxs(MenuList$1, { children: [overflows && (jsx(MenuScrollItem, { alt: alt, direction: "up", disabled: isAtTheTop, width: (_b = ref.current) === null || _b === void 0 ? void 0 : _b.offsetWidth, onClick: function (e) { return handleScrollClick(e, 'up'); } })), jsxs("div", __assign({ className: classes(menuContainer, alt && 'alt', alt && hasParent && 'alt-submenu'), ref: ref }, { children: [title && (jsx(Content, __assign({ className: classes(menuTitle, alt && 'alt') }, { children: title }))), groups.map(function (group, index) { return (jsxs(Box, __assign({ tag: "div", className: classes(menuList), "data-testid": "menu-item-list" }, { children: [index !== 0 && (jsx(Stretch, __assign({ verticalAlign: "center", horizontalAlign: "center", height: 8, className: dividerContainer }, { children: jsx(Box, { className: divider }) }), "".concat(accIndex, "-").concat(index))), group.map(function (item, i) {
                                var _a;
                                return ((_a = item.subGroups) === null || _a === void 0 ? void 0 : _a.length) ? (jsx("div", __assign({ onClick: function (e) {
                                        var _a;
                                        !item.disabled && ((_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item));
                                        !keepOpenOnSelect && (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.hideMenu());
                                        onClick === null || onClick === void 0 ? void 0 : onClick();
                                        e.stopPropagation();
                                    } }, { children: jsx(SubMenuItem, __assign({ menuZIndex: 999, positionOptions: {
                                            vAlign: 'top',
                                            position: 'right',
                                            leftBuffer: alt ? 2 : 0
                                        }, className: classes(menuItem, alt && 'alt', item.disabled && 'disabled', 'has-submenu'), menu: jsx("div", __assign({ "data-testid": CONTEXT_MENU_SUBMENU_TEST_ID, id: String(accIndex + 1 + index + i), className: style({
                                                boxShadow: boxShadow,
                                                borderRadius: alt ? Sizes.borderRadius : 0,
                                                overflow: 'hidden'
                                            }), onClick: function (e) { return e.stopPropagation(); } }, { children: jsx(SubMenu, { hasParent: true, alt: alt, groups: item.subGroups, accIndex: accIndex + 1 + index + i, onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(); }, selectedItem: selectedItem, keepOpenOnSelect: keepOpenOnSelect }) })), onItemChosen: function (e) {
                                            var _a;
                                            !item.disabled && ((_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item));
                                            !keepOpenOnSelect && (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.hideMenu());
                                            onClick === null || onClick === void 0 ? void 0 : onClick();
                                            e.stopPropagation();
                                        } }, { children: jsxs(Horizontal, __assign({ spacing: 10, verticalAlign: "center", className: classes(selectedItem !== undefined &&
                                                selectedItem === item.key &&
                                                'selected', style({
                                                color: selectedItem === item.key
                                                    ? Colours.white
                                                    : 'inherit'
                                            })) }, { children: [item.icon && jsx(MenuItemIcon, { icon: item.icon }), jsx(Content, { children: item.text }), jsx(Icon, { icon: faCaretRight })] })) }), "".concat(accIndex, "-").concat(index, "-").concat(i)) }), "".concat(accIndex, "-").concat(index, "-").concat(i))) : (jsx(MenuItem, __assign({ onItemChosen: function (e) {
                                        var _a;
                                        !item.disabled && ((_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item));
                                        !keepOpenOnSelect && (contextMenu === null || contextMenu === void 0 ? void 0 : contextMenu.hideMenu());
                                        onClick === null || onClick === void 0 ? void 0 : onClick();
                                    } }, { children: jsxs(Horizontal, __assign({ spacing: 10, verticalAlign: "center", className: classes(menuItem, item.disabled && 'disabled', alt && 'alt', selectedItem !== undefined &&
                                            selectedItem === item.key &&
                                            'selected') }, { children: [item.icon && (jsx(Content, { children: jsx(MenuItemIcon, { icon: item.icon }) })), item.withCheckbox && (jsx(Content, { children: jsx(CheckboxInput, { fullHeight: false, size: "sm", value: item.selected, label: item.text, onChange: function () {
                                                        item.onClick
                                                            ? function () {
                                                                var _a;
                                                                (_a = item.onClick) === null || _a === void 0 ? void 0 : _a.call(item);
                                                                onClick === null || onClick === void 0 ? void 0 : onClick();
                                                            }
                                                            : undefined;
                                                    } }) })), !item.withCheckbox && jsx(Content, { children: item.text }), jsx(StretchSpacer, { width: 0 }), jsx(Content, __assign({ padding: [0, 0, px(1), rem(0.5)], width: rem(1) }, { children: ((alt &&
                                                    selectedItem !== undefined &&
                                                    selectedItem === item.key) ||
                                                    (item.selected && !item.withCheckbox)) && (jsx(MenuItemIcon, { icon: faCheck, className: style({
                                                        $nest: {
                                                            svg: {
                                                                height: rem(1),
                                                                paddingBottom: px(2)
                                                            }
                                                        }
                                                    }) })) }))] })) }), "".concat(accIndex, "-").concat(index, "-").concat(i)));
                            })] }), "menu-list--" + index)); })] })), overflows && (jsx(MenuScrollItem, { alt: alt, direction: "down", disabled: isAtTheBottom, width: (_c = ref.current) === null || _c === void 0 ? void 0 : _c.offsetWidth, onClick: function (e) { return handleScrollClick(e, 'down'); } }))] }));
};
var divider = style({
    width: percent(100),
    height: px(1),
    background: Colours.lighterBlue
});
var dividerContainer = style({
    background: Colours.darkBlue,
    padding: padding(0, 10)
});
var menuContainer = style({
    fontFamily: fontFamily,
    textTransform: 'uppercase',
    maxHeight: px(336),
    overflowY: 'auto',
    '-ms-overflow-style': 'none',
    scrollbarWidth: 'none',
    $nest: {
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        '&.alt:not(.alt-submenu)': {
            border: "1px solid ".concat(Colours.lighterBlue),
            borderRadius: Sizes.borderRadius
        },
        '&.alt': {
            background: Colours.darkBlue
        }
    }
});
var menuTitle = style({
    color: Colours.textLight,
    background: Colours.darkBlue,
    padding: padding(8, 10),
    fontSize: Sizes.fontSize2,
    fontWeight: 600,
    $nest: {
        '&.alt': {
            padding: padding(14, 16)
        }
    }
});

var ContextMenu = function (_a) {
    var groups = _a.groups, children = _a.children, fitContainer = _a.fitContainer;
    return (jsx(ContextMenuWrapper, __assign({ fitContainer: fitContainer, menu: jsx(SubMenu, { groups: groups }) }, { children: children })));
};
var CONTEXT_MENU_LIST_TEST_ID = 'context-menu-list';
var CONTEXT_MENU_SUBMENU_TEST_ID = 'context-menu-submenu';

var Drawer = function (_a) {
    var onDismiss = _a.onDismiss, open = _a.open, children = _a.children, _b = _a.width, width = _b === void 0 ? modalContentWidth : _b, disableBackground = _a.disableBackground, contained = _a.contained, maxWidth = _a.maxWidth, dataTestId = _a["data-testid"];
    var _c = useState(false), visible = _c[0], setVisible = _c[1];
    useEffect(function () {
        if (open) {
            setVisible(true);
            return;
        }
        var hideTimeout = setTimeout(function () { return setVisible(false); }, animationDurationInSeg$1 * 1000);
        return function () { return clearTimeout(hideTimeout); };
    }, [open]);
    return (jsxs(Horizontal, __assign({ className: classes(classNames$a.modal, style({
            position: contained ? 'absolute' : 'fixed',
            pointerEvents: open ? 'all' : 'none'
        }), !visible && 'hidden'), "data-testid": "drawer-container" }, { children: [!disableBackground && (jsx(Stretch, { className: classes(classNames$a.modalBackground, open && 'open'), onClick: function () { return onDismiss(); }, "data-testid": "drawer-background" })), jsx("div", __assign({ className: classes(classNames$a.modalContent, open && 'open', contained && 'contained', style({
                    width: width,
                    maxWidth: maxWidth
                })), "data-testid": dataTestId || 'drawer-content' }, { children: children }))] })));
};
var modalContentWidth = '800px';
var animationDurationInSeg$1 = 0.3;
var modalBackgroundOpacity = 0.35;
var classNames$a = stylesheet({
    modal: {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1000,
        $nest: {
            '&.hidden': {
                zIndex: -1
            }
        }
    },
    modalBackground: {
        left: 0,
        height: '100%',
        transition: "opacity ease ".concat(animationDurationInSeg$1, "s"),
        opacity: 0,
        background: '#000',
        $nest: {
            '&.open': {
                opacity: modalBackgroundOpacity
            }
        }
    },
    modalContent: {
        position: 'absolute',
        top: 0,
        right: viewWidth(-100),
        paddingRight: 0,
        width: modalContentWidth,
        height: '100vh',
        background: Colours.darkerBlue,
        boxShadow: boxShadow,
        transition: "all ease ".concat(animationDurationInSeg$1, "s"),
        $nest: {
            '&.open': {
                right: 0
            },
            '&.contained': {
                height: percent(100)
            }
        }
    }
});

var useOnClickOutside = function (handler) {
    var ref = useRef(null);
    var escapeListener = useCallback(function (e) {
        if (e.key === 'Escape') {
            handler();
        }
    }, [handler]);
    var clickListener = useCallback(function (e) {
        var _a;
        if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            handler === null || handler === void 0 ? void 0 : handler();
        }
    }, [ref.current, handler]);
    useEffect(function () {
        document.addEventListener('click', clickListener);
        document.addEventListener('keyup', escapeListener);
        return function () {
            document.removeEventListener('click', clickListener);
            document.removeEventListener('keyup', escapeListener);
        };
    }, [handler, clickListener, escapeListener]);
    return ref;
};

var DropdownWrapper = function (_a) {
    var _b;
    var title = _a.title, children = _a.children, options = _a.options, _c = _a.direction, direction = _c === void 0 ? 'right' : _c, disabled = _a.disabled, alt = _a.alt, selectedItem = _a.selectedItem, keepOpenOnSelect = _a.keepOpenOnSelect;
    var _d = useState(false), showMenu = _d[0], setShowMenu = _d[1];
    var _e = useState(false), openAbove = _e[0], setOpenAbove = _e[1];
    var ref = useOnClickOutside(function () { return setShowMenu(false); });
    var handleOnOpen = function () {
        !disabled && setShowMenu(true);
    };
    useLayoutEffect(function () {
        var _a;
        var bounds = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        setOpenAbove(bounds
            ? bounds.y + bounds.height + 300 >=
                (window.innerHeight || document.documentElement.clientHeight)
            : false);
    }, [setOpenAbove, ref, showMenu]);
    return (jsxs("div", __assign({ className: style({
            display: 'inline-block',
            position: 'relative'
        }), ref: ref, "data-testid": "dropdown-wrapper" }, { children: [jsx("div", __assign({ onClick: handleOnOpen }, { children: children })), jsx(Box, __assign({ className: style((_b = {
                        position: 'absolute',
                        zIndex: zIndex.highest
                    },
                    _b[direction === 'left' ? 'right' : 'left'] = 0,
                    _b.bottom = openAbove ? 0 : 'auto',
                    _b.boxShadow = boxShadow,
                    _b.borderRadius = alt ? Sizes.borderRadius : 0,
                    _b)), "data-testid": "dropdown-menu-list" }, { children: showMenu && (jsx(SubMenu, { title: title, selectedItem: selectedItem, alt: alt, groups: options, onClick: function () {
                        !keepOpenOnSelect && setShowMenu(false);
                    }, keepOpenOnSelect: keepOpenOnSelect })) }))] })));
};

var getHeadingBySize = function (size) {
    if (size === void 0) { size = 1; }
    var headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    return headings[size - 1] || 'h1';
};
var Heading = function (props) {
    var _a = props.color, color = _a === void 0 ? Colours.textLight : _a, className = props.className;
    var heading = getHeadingBySize(props.size);
    return (jsx(Horizontal, __assign({}, props, { tag: heading, className: classes(style({
            color: color,
            margin: 0,
            fontFamily: fontFamily,
            overflow: 'hidden',
            whiteSpace: 'nowrap'
        }), className) })));
};

var InputErrors = function (_a) {
    var errors = _a.errors, isDirty = _a.isDirty;
    return (jsx(Fragment, { children: isDirty !== false &&
            (errors || []).map(function (error, index) { return (jsxs("p", __assign({ className: classNames$9.error }, { children: ["\u00B7 ", error] }), index)); }) }));
};
var classNames$9 = stylesheet({
    error: {
        color: Colours.red,
        fontSize: Sizes.fontSize1,
        margin: '0.35rem 0 0 0',
        fontFamily: fontFamily
    }
});

var InputLabel = function (_a) {
    var label = _a.label, isRequired = _a.isRequired, size = _a.size;
    return (jsx(Fragment, { children: label && (jsxs("label", __assign({ className: classes(classNames$8.label, style({
                fontSize: size === 'md' ? px(16) : undefined,
                lineHeight: size === 'md' ? px(17) : undefined
            })) }, { children: [label, isRequired && '*'] }))) }));
};
var classNames$8 = stylesheet({
    label: {
        color: Colours.textLight,
        fontSize: Sizes.fontSize1,
        fontFamily: fontFamily,
        height: em(1)
    }
});

var InputLayout = function (_a) {
    var children = _a.children, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'top' : _b, required = _a.required, errors = _a.errors, value = _a.value, counter = _a.counter, maxLength = _a.maxLength, hideErrors = _a.hideErrors, _c = _a.withSpacer, withSpacer = _c === void 0 ? true : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d, fullHeight = _a.fullHeight, fullWidth = _a.fullWidth;
    return (jsxs(Vertical, __assign({ width: percent(100), spacing: rem(0.25), sizing: "stretch", className: style({
            alignSelf: 'stretch'
        }) }, { children: [(labelPosition === 'top' || (counter && maxLength)) && (jsxs(Horizontal, __assign({ spacing: 0 }, { children: [labelPosition === 'top' && (jsx(InputLabel, { label: label, isRequired: required, size: size })), counter && maxLength && (jsxs(Fragment, { children: [jsx(StretchSpacer, {}), jsxs(Content, __assign({ className: style({
                                    fontFamily: fontFamily,
                                    color: Colours.textDark,
                                    fontSize: Sizes.fontSize1
                                }) }, { children: [(value === null || value === void 0 ? void 0 : value.length) || 0, " / ", maxLength] }))] }))] }))), jsxs(Horizontal, __assign({ spacing: rem(0.5), verticalAlign: "center", padding: labelPosition !== 'top' && withSpacer
                    ? [rem((fullHeight && 1) || 0), 0, 0, 0]
                    : undefined }, { children: [labelPosition === 'left' && (jsxs(Fragment, { children: [jsx(InputLabel, { label: label, isRequired: required, size: size }), fullWidth && jsx(StretchSpacer, {})] })), children, labelPosition === 'right' && (jsxs(Fragment, { children: [fullWidth && jsx(StretchSpacer, {}), jsx(InputLabel, { label: label, isRequired: required, size: size })] }))] })), !hideErrors && jsx(InputErrors, { errors: errors })] })));
};

var inputStyles = stylesheet({
    container: {
        boxSizing: 'border-box',
        padding: padding(0, rem(0.5)),
        backgroundColor: Colours.darkBlue,
        border: "1px solid ".concat(Colours.blue),
        borderRadius: px(5),
        borderBottomWidth: px(1),
        minHeight: px(36),
        $nest: {
            '&.disabled': {
                cursor: 'default',
                border: 'none'
            }
        }
    },
    input: {
        height: px(34),
        width: percent(100),
        boxSizing: 'border-box',
        color: Colours.textLight,
        background: 'transparent',
        border: 'none',
        fontSize: Sizes.fontSize2,
        caretColor: Colours.textLight,
        fontFamily: fontFamily,
        $nest: {
            '&:focus': {
                outline: 'none'
            },
            '&:disabled': {
                color: Colours.textDisabled
            },
            '&.readonly': {
                color: Colours.textLight
            },
            '&:-webkit-autofill, textarea:-webkit-autofill': {
                '-webkit-box-shadow': "0 0 0 1000px ".concat(Colours.darkBlue, " inset !important"),
                '-webkit-text-fill-color': important('white')
            },
            '&::-webkit-calendar-picker-indicator': {
                filter: 'invert(1)',
                opacity: 0.5,
                cursor: 'pointer'
            },
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                '-webkit-appearance': 'none',
                margin: 0
            },
            '&[type=number]': {
                '-moz-appearance': 'textfield'
            }
        }
    },
    suffix: {
        fontFamily: fontFamily,
        fontSize: Sizes.fontSize2,
        color: Colours.textLight,
        pointerEvents: 'none',
        textAlign: 'right',
        $nest: {
            '&.disabled': {
                color: Colours.textDisabled
            }
        }
    }
});

var TextInput = function (_a) {
    var id = _a.id, value = _a.value, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'top' : _b, name = _a.name, password = _a.password, disabled = _a.disabled, required = _a.required, readonly = _a.readonly, placeholder = _a.placeholder, maxLength = _a.maxLength, onBlur = _a.onBlur, onChange = _a.onChange, errors = _a.errors, transparent = _a.transparent, suffix = _a.suffix, hideErrors = _a.hideErrors, labelSize = _a.labelSize;
    return (jsx(InputLayout, __assign({ label: label, errors: errors, required: required, labelPosition: labelPosition, hideErrors: hideErrors, size: labelSize }, { children: jsxs(Horizontal, __assign({ sizing: "stretch", spacing: px(5), className: classes(transparent &&
                style({
                    borderColor: important('transparent'),
                    background: important('transparent')
                }), inputStyles.container, hideErrors &&
                ((errors === null || errors === void 0 ? void 0 : errors.length) || 0) > 0 &&
                style({
                    borderColor: Colours.red
                })) }, { children: [jsx("input", { id: id, maxLength: maxLength, disabled: disabled || readonly, type: password ? 'password' : 'text', value: value !== null && value !== void 0 ? value : '', onBlur: onBlur, onChange: function (_a) {
                        var target = _a.target;
                        return onChange(target.value);
                    }, className: classes(inputStyles.input, readonly && 'readonly'), placeholder: placeholder, name: name, required: required, "data-testid": id }), suffix && (jsx(Content, __assign({ verticalAlign: "center", className: inputStyles.suffix }, { children: suffix })))] })) })));
};

var NumberInput = function (_a) {
    // const [internalValue, setInternalValue] = useState<string | undefined>(
    //   value === undefined ? undefined : String(value)
    // );
    var id = _a.id, value = _a.value, name = _a.name, label = _a.label, labelPosition = _a.labelPosition, disabled = _a.disabled, required = _a.required, placeholder = _a.placeholder, suffix = _a.suffix, max = _a.max, min = _a.min, hideControls = _a.hideControls, errors = _a.errors, autoFocus = _a.autoFocus, hideErrors = _a.hideErrors, readonly = _a.readonly, transparent = _a.transparent, labelSize = _a.labelSize, _b = _a.allowDecimals, allowDecimals = _b === void 0 ? true : _b, onBlur = _a.onBlur, onChange = _a.onChange;
    var _c = useState('99'), internalValue = _c[0], setInternalValue = _c[1];
    useEffect(function () {
        setInternalValue(value === undefined ? undefined : String(value));
    }, [value]);
    // debounce the change event and enforce the min/max range
    var debounced = useDebouncedCallback(
    // function
    useCallback(function (value) {
        onChange(value);
    }, [onChange]), 
    // delay in ms
    500);
    var handleChange = function (value) {
        var v = String(value);
        setInternalValue(v);
        // onChange(v === '' ? undefined : ((v as unknown) as number));
        var newValue = v === ''
            ? undefined
            : Math.min(Math.max(Number(v), min || Number.MIN_SAFE_INTEGER), max || Number.MAX_SAFE_INTEGER);
        //call onChange with the value as a number and ensure it is within the min/max range
        if (min || max) {
            debounced(newValue);
        }
        else {
            onChange(newValue);
        }
    };
    return (jsx(InputLayout, __assign({ label: label, labelPosition: labelPosition, size: labelSize, errors: errors, required: required, hideErrors: hideErrors }, { children: jsxs(Horizontal, __assign({ sizing: "stretch", spacing: px(5), className: classes(transparent &&
                style({
                    borderColor: important('transparent'),
                    background: important('transparent')
                }), inputStyles.container, hideErrors &&
                ((errors === null || errors === void 0 ? void 0 : errors.length) || 0) > 0 &&
                style({
                    borderColor: Colours.red
                })) }, { children: [jsx("input", { onKeyDown: function (e) {
                        if (e.key === '+' || e.key === 'e') {
                            e.preventDefault();
                        }
                    }, max: max, min: min, disabled: disabled, type: 'number', name: name, value: String(internalValue), onBlur: onBlur, onChange: function (_a) {
                        var target = _a.target;
                        return handleChange(target.value);
                    }, className: classes(inputStyles.input, hideControls && hideControlsStyle, readonly && 'readonly'), placeholder: placeholder, "data-testid": id, step: "any", autoFocus: autoFocus, readOnly: readonly, onKeyDownCapture: function (e) {
                        if (!allowDecimals && e.key === '.') {
                            e.preventDefault();
                        }
                    } }), suffix && (jsx(Content, __assign({ verticalAlign: "center", className: inputStyles.suffix, "data-testid": "number-input-suffix" }, { children: suffix })))] })) })));
};
var hideControlsStyle = style({
    $nest: {
        '&::-webkit-inner-spin-button, &::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    }
});

var SelectInput = function (_a) {
    var _b;
    var transparent = _a.transparent, label = _a.label, options = _a.options, isMultiple = _a.isMultiple, name = _a.name, value = _a.value, required = _a.required, errors = _a.errors, _c = _a.placeholder, placeholder = _c === void 0 ? 'Select...' : _c, disabled = _a.disabled, readonly = _a.readonly, labelPosition = _a.labelPosition, menuPlacement = _a.menuPlacement, maxMenuHeight = _a.maxMenuHeight, isCreatable = _a.isCreatable, labelSize = _a.labelSize, onChange = _a.onChange, onBlur = _a.onBlur, dataTestId = _a["data-testid"];
    var selectedValues = useMemo(function () { return (options === null || options === void 0 ? void 0 : options.filter(function (opt) { return value === null || value === void 0 ? void 0 : value.includes(opt.value); })) || []; }, [options, value]);
    var selectedValuesNamesOrPlaceholder = (value === null || value === void 0 ? void 0 : value.every(function (v) { return v == undefined; })) || !value
        ? placeholder
        : (_b = selectedValues === null || selectedValues === void 0 ? void 0 : selectedValues.map(function (v) { return v.label; })) === null || _b === void 0 ? void 0 : _b.join('; ');
    return !disabled && !readonly ? (jsx("div", __assign({ "data-testid": dataTestId }, { children: jsx(InputLayout, __assign({ label: label, errors: errors, required: required, labelPosition: labelPosition, size: labelSize }, { children: isCreatable ? (jsx(CreatableSelect, { menuPortalTarget: document.querySelector('body'), closeMenuOnSelect: !isMultiple, isDisabled: disabled, name: name, options: options, isMulti: isMultiple, className: classes(transparent && classNames$7.transparent, classNames$7.input, style({ minWidth: '100%' })), isClearable: false, defaultValue: selectedValues, value: selectedValues, classNamePrefix: "select", placeholder: placeholder, maxMenuHeight: maxMenuHeight, theme: function (theme) { return ({
                    borderRadius: Sizes.borderRadius,
                    spacing: __assign(__assign({}, theme.spacing), { baseUnit: 4, controlHeight: 0, menuGutter: 1 }),
                    colors: __assign(__assign({}, theme.colors), { neutral10: Colours.lighterBlue, neutral20: Colours.lightBlue, neutral60: Colours.darkBlue, neutral80: Colours.textLight, primary25: Colours.darkerBlue })
                }); }, onBlur: onBlur, onChange: onChange, menuPlacement: menuPlacement })) : (jsx(Select, { menuPortalTarget: document.querySelector('body'), styles: {
                    menuPortal: function (base) { return (__assign(__assign({}, base), { zIndex: 9999 })); },
                    menu: function (base) { return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: Sizes.fontSize2, background: Colours.darkBlue, color: Colours.textLight, margin: 0 })); },
                    menuList: function (base) { return (__assign(__assign({}, base), { padding: 0 })); },
                    control: function (base, _a) {
                        var menuIsOpen = _a.menuIsOpen;
                        return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: Sizes.fontSize2, background: Colours.darkBlue, color: Colours.textLight, cursor: 'pointer', minHeight: px(36), border: "1px solid ".concat(Colours.blue), boxShadow: menuIsOpen ? boxShadow : 'none' }));
                    },
                    option: function (base, _a) {
                        var isFocused = _a.isFocused, isSelected = _a.isSelected;
                        return (__assign(__assign({}, base), { fontFamily: fontFamily, fontSize: Sizes.fontSize2, background: isSelected
                                ? Colours.primary
                                : isFocused
                                    ? Colours.blue
                                    : Colours.darkBlue, color: isSelected ? Colours.darkestBlue : Colours.textLight, cursor: 'pointer', '&:hover': {
                                background: isSelected ? Colours.primary : Colours.blue
                            } }));
                    }
                }, menuPosition: "fixed", closeMenuOnSelect: !isMultiple, isDisabled: disabled, name: name, options: options, isMulti: isMultiple, className: classes(transparent && classNames$7.transparent, classNames$7.input, style({ minWidth: '100%' })), isClearable: false, defaultValue: selectedValues, value: selectedValues, classNamePrefix: "select", placeholder: placeholder, maxMenuHeight: maxMenuHeight, onBlur: onBlur, onChange: onChange, menuPlacement: menuPlacement, theme: function (theme) { return ({
                    borderRadius: Sizes.borderRadius,
                    spacing: __assign(__assign({}, theme.spacing), { baseUnit: 4, controlHeight: 0, menuGutter: 1 }),
                    colors: __assign(__assign({}, theme.colors), { neutral10: Colours.lighterBlue, neutral20: Colours.lightBlue, neutral60: Colours.darkBlue, neutral80: Colours.textLight, primary25: Colours.darkerBlue })
                }); } })) })) }))) : (jsx(TextInput, { readonly: readonly, disabled: disabled, label: label, value: selectedValuesNamesOrPlaceholder, onChange: function () { }, placeholder: selectedValuesNamesOrPlaceholder, transparent: transparent }));
};
var classNames$7 = stylesheet({
    transparent: {
        $nest: {
            '.select__control:not(.select__control--menu-is-open):not(:hover)': {
                background: important('transparent'),
                borderColor: important('transparent')
            }
        }
    },
    input: {
        fontSize: Sizes.fontSize2,
        fontFamily: fontFamily,
        $nest: {
            'select__indicator-separator': {
                height: 'auto'
            },
            '.select__placeholder': {
                color: Colours.textLight
            },
            '.select__control': {
                color: Colours.textLight,
                background: Colours.darkBlue,
                cursor: 'pointer',
                border: "1px solid ".concat(Colours.blue),
                minHeight: px(36)
            },
            '.select__control--menu-is-open': {
                boxShadow: boxShadow
            },
            '.select__option': {
                background: Colours.darkBlue,
                color: Colours.textLight,
                cursor: 'pointer'
            },
            '.select__menu-notice--no-options': {
                background: Colours.darkerBlue
            },
            '.select__option--is-focused': {
                background: Colours.blue
            },
            '.select__option--is-selected': {
                background: Colours.primary,
                color: Colours.darkerBlue
            },
            '.select__menu': {
                color: Colours.textLight,
                boxShadow: boxShadow,
                margin: 0
            },
            '.select__menu-list': {
                padding: 0
            },
            '.select__single-value': {
                height: rem(1.1),
                lineHeight: rem(1.1)
            }
        }
    }
});

var SC_HEIGHT_MD = 24;
var SC_WIDTH_MD = 42;
var S_HEIGHT_MD = 16;
var S_WIDTH_MD = 16;
var SC_HEIGHT_SM = 20;
var SC_WIDTH_SM = 36;
var S_HEIGHT_SM = 14;
var S_WIDTH_SM = 14;
var S_LEFT_SM = 4;
var S_LEFT_MD = 5;
var S_BOTTOM_SM = 3;
var S_BOTTOM_MD = 4;
var Switch = function (_a) {
    var onChange = _a.onChange, checked = _a.checked, disabled = _a.disabled, _b = _a.size, size = _b === void 0 ? 'md' : _b;
    return (jsx(Box, __assign({ className: classes(classNames$6.container, 'switch') }, { children: jsx("div", __assign({ className: classes(classNames$6.sliderContainer, style({
                cursor: disabled ? 'default' : 'pointer',
                width: size === 'sm' ? SC_WIDTH_SM : SC_WIDTH_MD,
                height: size === 'sm' ? SC_HEIGHT_SM : SC_HEIGHT_MD
            })), onClick: function () {
                !disabled && (onChange === null || onChange === void 0 ? void 0 : onChange(!checked));
            }, "data-testid": "switch" }, { children: jsx("span", { "data-testid": SWITCH_SLIDER_TEST_ID, className: classes(classNames$6.slider, checked && 'checked', disabled && 'disabled', style({
                    $nest: {
                        '&::before': {
                            height: size === 'sm' ? S_HEIGHT_SM : S_HEIGHT_MD,
                            width: size === 'sm' ? S_WIDTH_SM : S_WIDTH_MD,
                            left: size === 'sm' ? S_LEFT_SM : S_LEFT_MD,
                            bottom: size === 'sm' ? S_BOTTOM_SM : S_BOTTOM_MD
                        }
                    }
                })) }) })) })));
};
var classNames$6 = stylesheet({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        $nest: {
            '&.fullWidth': {
                flex: 1
            }
        }
    },
    sliderContainer: {
        position: 'relative',
        display: 'inline-block',
        width: 42,
        height: 24
    },
    slider: {
        position: 'absolute',
        cursor: 'pointer',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: Colours.lightestBlue,
        transition: '.4s',
        borderRadius: 34,
        $nest: {
            '&::before': {
                position: 'absolute',
                content: 'close-quote',
                height: 16,
                width: 16,
                left: 5,
                bottom: 4,
                background: 'white',
                transition: '.4s',
                borderRadius: '50%'
            },
            '&.checked': {
                backgroundColor: Colours.primary,
                $nest: {
                    '&:before': {
                        transform: 'translateX(16px)'
                    }
                }
            },
            '&.disabled': {
                cursor: 'default',
                background: Colours.lighterBlue,
                $nest: {
                    '&:before': {
                        background: Colours.darkBlue
                    }
                }
            }
        }
    }
});
var SWITCH_SLIDER_TEST_ID = 'switch_slider';

var SwitchInput = function (props) {
    return (jsx(InputLayout, __assign({ label: props.label, errors: props.errors, required: props.required, labelPosition: props.labelPosition, size: props.labelSize, fullWidth: props.fullWidth }, { children: jsx(Switch, { size: props.size, checked: !!props.value, onChange: props.onChange, disabled: props.disabled }) })));
};

var TextAreaInput = function (_a) {
    var id = _a.id, value = _a.value, label = _a.label, _b = _a.labelPosition, labelPosition = _b === void 0 ? 'top' : _b, name = _a.name, disabled = _a.disabled, required = _a.required, readonly = _a.readonly, placeholder = _a.placeholder, maxLength = _a.maxLength, onBlur = _a.onBlur, onChange = _a.onChange, errors = _a.errors, transparent = _a.transparent, _c = _a.resizable, resizable = _c === void 0 ? false : _c, rows = _a.rows, counter = _a.counter;
    return (jsx(InputLayout, __assign({ label: label, errors: errors, required: required, labelPosition: labelPosition, value: value, counter: counter, maxLength: maxLength }, { children: jsx(Horizontal, __assign({ sizing: "stretch", spacing: px(5), className: classes(transparent &&
                style({
                    borderColor: important('transparent'),
                    background: important('transparent')
                }), inputStyles.container) }, { children: jsx("textarea", { id: id, maxLength: maxLength, disabled: disabled || readonly, value: value !== null && value !== void 0 ? value : '', onBlur: onBlur, onChange: function (_a) {
                    var target = _a.target;
                    return onChange(target.value);
                }, className: classes(inputStyles.input, readonly && 'readonly', style({ resize: resizable ? 'both' : 'none', height: '100%' })), placeholder: placeholder, name: name, required: required, "data-testid": id, rows: rows }) })) })));
};

var TimeInput = function (props) {
    var _a;
    return (jsx(InputLayout, __assign({ label: props.label, errors: props.errors, required: props.required, labelPosition: props.labelPosition }, { children: jsx(Horizontal, __assign({ spacing: px(5), className: classes(props.transparent && style({ borderColor: important('transparent') }), inputStyles.container) }, { children: jsx("input", { id: props.id, min: props.min, max: props.max, disabled: props.disabled || props.readonly, type: "time", value: (_a = props.value) !== null && _a !== void 0 ? _a : '', onBlur: props.onBlur, onChange: function (_a) {
                    var target = _a.target;
                    return props.onChange(target.value);
                }, className: classes(inputStyles.input, props.readonly && 'readonly', picker), placeholder: props.placeholder, name: props.name, required: props.required, "data-testid": props.id }) })) })));
};
var picker = style({
    $nest: {}
});

var sizes$1 = {
    sm: rem(1),
    md: rem(1.25),
    lg: rem(1.5)
};
var CheckboxInput = function (props) {
    var fullHeight = props.fullHeight === undefined ? true : props.fullHeight;
    return (jsx(InputLayout, __assign({ label: props.label, errors: props.errors, required: props.required, labelPosition: props.labelPosition || 'right', withSpacer: props.withSpacer, size: "md", fullHeight: fullHeight }, { children: jsx(Content$1, __assign({ height: props.fullHeight ? px(36) : undefined, verticalAlign: "center" }, { children: jsx(Box$1, __assign({ className: classes(styles$d.checkbox, style({
                    width: sizes$1[props.size || 'md'],
                    height: sizes$1[props.size || 'md'],
                    border: "1px solid ".concat(props.value ? Colours.primary : Colours.textDark)
                })), onClick: function () {
                    props.onChange(!props.value);
                }, verticalAlign: "center", horizontalAlign: "center" }, { children: props.value && (jsx(Icon, { icon: faCheck, className: style({
                        width: important(props.size === 'lg' ? rem(1) : rem(0.7))
                    }) })) })) })) })));
};
var styles$d = stylesheet({
    checkbox: {
        color: Colours.primary,
        borderRadius: '0.25rem',
        appearance: 'none',
        outline: 'none',
        cursor: 'pointer',
        fontSize: '1.25rem',
        userSelect: 'none'
    }
});

var timeTypeList = [
    { label: 'second(s)', value: 1 },
    { label: 'minute(s)', value: 60 },
    { label: 'hour(s)', value: 3600 },
    { label: 'day(s)', value: 86400 }
];
function useTimeConverter(seconds) {
    var _a = useState(timeTypeList[0]), timeType = _a[0], setTimeType = _a[1];
    var _b = useState(seconds / timeType.value), time = _b[0], setTime = _b[1];
    useEffect(function () {
        convertTime();
    }, [seconds]);
    function convertTime() {
        var data = {
            time: 0,
            timeType: timeType
        };
        if (seconds == null) {
            return setTime(null), setTimeType(data.timeType);
        }
        if (seconds === 0) {
            return setTime(data.time), setTimeType(data.timeType);
        }
        data = timeTypeList.reduce(function (prev, curr) {
            if (seconds % curr.value || prev.time > seconds * curr.value) {
                return prev;
            }
            return {
                time: seconds / curr.value,
                timeType: curr
            };
        }, data);
        setTime(data.time);
        setTimeType(data.timeType);
    }
    return [
        {
            time: time == null ? null : time,
            type: {
                value: timeType.value,
                label: time != 1
                    ? timeType.label.slice(0, timeType.label.length - 3) + 's'
                    : "".concat(timeType.label.slice(0, timeType.label.length - 3))
            },
            timeTypeList: timeTypeList
        },
        function (value) {
            var type = timeTypeList.find(function (timeType) { return timeType.value === value; });
            if (!type) {
                return;
            }
            setTimeType(type);
        }
    ];
}
var convertTime = function (seconds) {
    return timeTypeList.reduce(function (prev, curr) {
        if (seconds % curr.value || prev.time > seconds * curr.value) {
            return prev;
        }
        return {
            time: seconds / curr.value,
            timeType: curr
        };
    }, { time: 0, timeType: timeTypeList[0] });
};

var TimeDropDown = function (_a) {
    var seconds = _a.seconds, disabled = _a.disabled, onChange = _a.onChange;
    var _b = useTimeConverter(seconds), _c = _b[0], time = _c.time, type = _c.type, timeTypeList = _c.timeTypeList, setTimeType = _b[1];
    function handleTimeChange(data) {
        var value = Number(data);
        onChange((Number(value) || 0) * type.value);
    }
    function handleTimeTypeChange(option) {
        if (seconds != null) {
            onChange((seconds / type.value) * option.value);
        }
        setTimeType(option.value);
    }
    if (Number.isNaN(time)) {
        return null;
    }
    return (jsxs(Horizontal, __assign({ width: px(200), spacing: 0, "data-testid": "time-dropdown-container" }, { children: [jsx(Content, __assign({ width: 70 }, { children: jsx(NumberInput, { id: "time-dropdown", disabled: disabled, value: time, onChange: handleTimeChange }) })), "\u00A0\u00A0", jsx(Stretch, { children: jsx(SelectInput, { name: "time-type", value: [type.value], disabled: disabled, options: timeTypeList, onChange: function (o) { return handleTimeTypeChange(o); } }, type.value) })] })));
};

var BarColours = [Colours.red, Colours.primary, Colours.green];
var ColourGradient = tinygradient(BarColours);
var AppetiteFactorSettings = function (props) {
    var t = useTranslation().t;
    var bar = props.bar, disabled = props.disabled, readonly = props.readonly, isEmergency = props.isEmergency, onChange = props.onChange;
    var factors = useMemo(function () {
        if (!bar || !bar.configurations) {
            return {};
        }
        var colors = ColourGradient.rgb(Math.max(bar.configurations.length, BarColours.length));
        var factors = bar.configurations
            .slice()
            .sort(function (a, b) {
            return Number(a.signalKey.split('_')[1]) - Number(b.signalKey.split('_')[1]);
        })
            .reduce(function (prev, curr, idx) {
            var _a;
            var max = curr.signalKey.split('_')[1];
            return {
                value: Number(max),
                data: __assign(__assign({}, prev.data), (_a = {}, _a[curr.signalKey] = {
                    max: Number(max),
                    key: curr.signalKey,
                    value: curr.signalValue,
                    color: "#".concat(colors[idx].toHex()),
                    display_name: curr.signalDisplayName,
                    min: Math.floor(prev.value + (idx === 0 ? 0 : 1))
                }, _a))
            };
        }, { value: 0, data: {} });
        return factors.data;
    }, [bar]);
    var values = useMemo(function () {
        return Object.keys(factors).reduce(function (prev, curr) {
            var _a;
            return __assign(__assign({}, prev), (_a = {}, _a[curr] = factors[curr].value, _a));
        }, {});
    }, [factors]);
    var handleWaitTimeChange = function (v) {
        onChange({
            id: bar.groupingId,
            data: __assign(__assign({}, bar), { barWaitTimeSec: v })
        });
    };
    var handleFactorChange = function (key, value) {
        var data = bar.configurations.map(function (c) {
            if (c.signalKey === key) {
                return __assign(__assign({}, c), { signalValue: value });
            }
            return c;
        });
        onChange({
            id: bar.groupingId,
            data: __assign(__assign({}, bar), { configurations: data })
        });
    };
    return (jsxs(Vertical, __assign({ spacing: rem(1), className: styles$c.container }, { children: [jsx(Horizontal, __assign({ spacing: 0 }, { children: Object.keys(factors).map(function (key, index) {
                    var factor = factors[key];
                    return (jsxs(Vertical, __assign({ horizontalAlign: "center", sizing: "stretch", spacing: rem(0.5) }, { children: [jsxs(Content, { children: [factor.min, " - ", factor.max] }), jsx(Content, __assign({ size: 1, className: styles$c.factor, style: {
                                    backgroundColor: Object.keys(values).length === 1 && !isEmergency
                                        ? Colours.primary
                                        : factor.color
                                }, width: percent(100), height: rem(4), verticalAlign: "center", horizontalAlign: "center" }, { children: jsx(Content, __assign({ height: rem(2.5), width: rem(4.5) }, { children: jsx(NumberInput, { id: 'bar-' + index, max: 5, disabled: disabled || readonly, value: values[key], onChange: function (v) { return handleFactorChange(key, v || 0); } }) })) }))] }), key + index));
                }) })), jsx(Horizontal, __assign({ verticalAlign: "bottom" }, { children: jsxs(Vertical, __assign({ spacing: rem(0.5) }, { children: [jsxs("strong", __assign({ className: style({ fontFamily: fontFamily }) }, { children: [t('Reactive time'), ":"] })), jsx(TimeDropDown, { disabled: disabled || readonly, seconds: bar.barWaitTimeSec, onChange: handleWaitTimeChange })] })) }))] })));
};
var styles$c = stylesheet({
    container: {
        fontFamily: fontFamily,
        color: Colours.textLight,
        padding: padding(0, rem(0)),
        borderRadius: px(5)
    },
    factor: {
        $nest: {
            '*:first-child > &': {
                borderTopLeftRadius: px(5),
                borderBottomLeftRadius: px(5)
            },
            '*:last-child > &': {
                borderTopRightRadius: px(5),
                borderBottomRightRadius: px(5)
            }
        }
    }
});

var reducer = function (state, action) {
    switch (action.type) {
        case 'start':
            return __assign(__assign({}, state), { isNew: false, groupBeingEdited: action.payload });
        case 'create':
            return __assign(__assign({}, state), { isNew: true, groupBeingEdited: state.groups.length, groups: __spreadArray(__spreadArray([], state.groups, true), [
                    {
                        allowedNumberEvents: 0,
                        allowedTimeDifferenceSec: 0,
                        groupingId: -1,
                        configurations: []
                    }
                ], false) });
        case 'save': {
            state.groups[state.groupBeingEdited] = action.payload;
            var newState = __assign(__assign({}, state), { isNew: false, groupBeingEdited: null, groups: __spreadArray([], state.groups, true) });
            action.cb(newState.groups);
            return newState;
        }
        case 'delete': {
            state.groups.splice(action.payload, 1);
            var newState = __assign(__assign({}, state), { isNew: false, groups: __spreadArray([], state.groups, true) });
            action.cb(newState.groups);
            return newState;
        }
        case 'cancel':
            return __assign(__assign({}, state), { groupBeingEdited: null, groups: state.isNew
                    ? state.groups.splice(0, state.groups.length - 1)
                    : __spreadArray([], state.groups, true), isNew: false });
    }
};
var useExitCondition = function (args) {
    var conditions = args.conditions, onChange = args.onChange, onScenarioChange = args.onScenarioChange;
    var _a = useReducer(reducer, {
        groups: conditions,
        isNew: false,
        groupBeingEdited: null
    }), _b = _a[0], groupBeingEdited = _b.groupBeingEdited, groups = _b.groups, dispatch = _a[1];
    return {
        groups: groups,
        groupBeingEdited: groupBeingEdited,
        changeScenario: onScenarioChange,
        startEditingGroup: function (index) {
            return dispatch({ type: 'start', payload: index });
        },
        cancelEditingGroup: function () { return dispatch({ type: 'cancel' }); },
        create: function () { return dispatch({ type: 'create' }); },
        change: function (data) {
            return dispatch({ type: 'save', payload: data, cb: onChange });
        },
        remove: function (index) {
            return dispatch({ type: 'delete', payload: index, cb: onChange });
        }
    };
};

var TimePicker = function (_a) {
    var className = _a.className, value = _a.value, onChange = _a.onChange;
    return (jsx(ReactTimePicker, { value: value, showSecond: false, onChange: onChange, className: className, popupClassName: className }));
};

var placeholder$1 = '__________';
var WordedCondition = function (_a) {
    var readonly = _a.readonly, _b = _a.signals, signals = _b === void 0 ? [] : _b, selectedSignal = _a.selectedSignal, onChange = _a.onChange;
    var t = useTranslation().t;
    var selectedItem = useMemo(function () {
        return signals.find(function (metric) { return metric.signalKey === (selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalKey); });
    }, [signals, selectedSignal]);
    var metricsOptions = useMemo(function () {
        return signals.map(function (l) { return ({
            value: l.signalKey,
            label: l.signalDisplayName
        }); });
    }, [signals]);
    var relationshipOptions = useMemo(function () {
        return ((selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalPossibleRelationships.map(function (relationship) { return ({
            value: relationship,
            label: relationship
        }); })) || []);
    }, [selectedItem]);
    var unit = selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.unit;
    function handleSignalKeyChange(opt) {
        onChange({ signalKey: opt.value, signalDisplayName: opt.label });
    }
    var handleRelationshipChange = function (opt) {
        var relationship = relationshipOptions === null || relationshipOptions === void 0 ? void 0 : relationshipOptions.find(function (o) { return o.value == opt.value; });
        relationship && onChange({ signalRelationship: relationship.value });
    };
    function handleTimeChange(t) {
        onChange({ signalValue: t ? t.format(config.format.time) : t });
    }
    function handleSignalValueChange(value) {
        onChange({ signalValue: value });
    }
    if (readonly) {
        return (jsx(ReadonlyStatement, { displayName: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalDisplayName, signalRelationship: selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalRelationship, signalValue: String(selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalValue), signalValueOptions: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalValueOptions, unit: unit }));
    }
    return (jsx(Content, __assign({ className: container$1, "data-testid": "worded-if-statement" }, { children: jsxs(Horizontal, __assign({ spacing: rem(0.5), verticalAlign: "center" }, { children: [jsx(Box, __assign({ minWidth: rem(12), "data-testid": "worded-if-statement-signal" }, { children: jsx(SelectInput, { options: metricsOptions, value: [selectedSignal], placeholder: (selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalDisplayName) || placeholder$1, onChange: function (o) { return handleSignalKeyChange(o); } }) })), jsx("span", { children: t('is') }), !(selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalValueOptions) && (jsx(Box, __assign({ minWidth: rem(5), maxWidth: rem(8), "data-testid": "worded-if-statement-relationship" }, { children: jsx(SelectInput, { options: relationshipOptions, value: (selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalRelationship)
                            ? [selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalRelationship]
                            : undefined, disabled: !(relationshipOptions === null || relationshipOptions === void 0 ? void 0 : relationshipOptions.length), onChange: function (o) { return handleRelationshipChange(o); } }) }))), (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalValueOptions) ? (jsx(Box, __assign({ width: rem(9), "data-testid": "worded-if-statement-value" }, { children: jsx(SelectInput, { options: selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalValueOptions, value: [Number(selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalValue)], onChange: function (o) {
                            onChange({
                                signalValue: o.value,
                                signalRelationship: '='
                            });
                        } }) }))) : (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.signalKey) === 'time_stamp' ? (jsx(TimePicker, { value: moment(selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalValue, 'HH:mm'), onChange: handleTimeChange })) : (jsx(Box, __assign({ width: rem(7), "data-testid": "worded-if-statement-value" }, { children: jsx(NumberInput, { min: 0, suffix: unit, value: Number(selectedSignal === null || selectedSignal === void 0 ? void 0 : selectedSignal.signalValue), onChange: function (value) { return handleSignalValueChange(value); } }) })))] })) })));
};
var ReadonlyStatement = function (_a) {
    var _b;
    var displayName = _a.displayName, signalRelationship = _a.signalRelationship, signalValue = _a.signalValue, signalValueOptions = _a.signalValueOptions, unit = _a.unit;
    var t = useTranslation().t;
    return (jsxs(Horizontal, __assign({ spacing: rem(0.5), verticalAlign: "center", "data-testid": "worded-if-statement-readonly" }, { children: [jsx("strong", __assign({ style: { color: 'white' } }, { children: displayName || placeholder$1 })), jsx("span", { children: t('is') }), !(signalValueOptions === null || signalValueOptions === void 0 ? void 0 : signalValueOptions.length) ? (jsxs(Fragment, { children: [jsx("strong", __assign({ style: { color: 'white' } }, { children: signalRelationship || placeholder$1 })), jsxs("strong", __assign({ style: { color: 'white' } }, { children: [signalValue, " ", "".concat(unit || '')] }))] })) : (jsx(Fragment, { children: jsx("strong", __assign({ style: { color: 'white' } }, { children: (_b = signalValueOptions === null || signalValueOptions === void 0 ? void 0 : signalValueOptions.find(function (o) { return o.value === Number(signalValue); })) === null || _b === void 0 ? void 0 : _b.label })) }))] })));
};
var container$1 = style({
    $nest: {
        '& .input': {
            $nest: {
                '& > input, & > .label': {
                    maxWidth: rem(4),
                    color: important(Colours.textLight),
                    background: important(Colours.darkerBlue)
                },
                '&> .label': {
                    paddingLeft: 0
                }
            }
        }
    }
});

var placeholder = '__________';
var WordedFrequencyStatement = function (_a) {
    var allowedNumberEvents = _a.allowedNumberEvents, _b = _a.allowedTimeDifferenceSec, allowedTimeDifferenceSec = _b === void 0 ? 0 : _b, readonly = _a.readonly, _c = _a.onChange, onChange = _c === void 0 ? function () { } : _c;
    var t = useTranslation().t;
    var _d = useTimeConverter(allowedTimeDifferenceSec)[0], time = _d.time, type = _d.type;
    function handleFrequencyChange(v) {
        onChange({
            allowedNumberEvents: (v || 0) / 5
        });
    }
    function setTime(seconds) {
        onChange({ allowedTimeDifferenceSec: seconds });
    }
    var _e = useState(Number(allowedNumberEvents) === 1 && allowedTimeDifferenceSec === 60 * 10), happensOnce = _e[0], setHappensOnce = _e[1];
    return (jsx(Horizontal, __assign({ maxWidth: percent(100), padding: [rem(0.5), 0], spacing: rem(0.5), verticalAlign: "center", "data-testid": "worded-statement-frequency", className: style({
            flexWrap: 'wrap'
        }) }, { children: readonly ? (jsxs(Fragment, { children: [jsx(Content, { children: t('and this occured') }), happensOnce ? (jsx("strong", __assign({ style: { color: 'white' } }, { children: t('once') }))) : (jsxs(Fragment, { children: [jsx(Content, { children: t('for') }), jsxs("strong", __assign({ style: { color: 'white' } }, { children: [allowedNumberEvents != null
                                    ? allowedNumberEvents * 5
                                    : placeholder, ' ', "seconds"] }))] })), !happensOnce && (jsxs(Fragment, { children: [jsx(Content, { children: t('times within a span of', {
                                count: Number(allowedNumberEvents)
                            }) }), jsxs("strong", __assign({ style: { color: 'white' } }, { children: [time !== null && time !== void 0 ? time : placeholder, " ", t(type.label)] }))] }))] })) : (jsxs(Fragment, { children: [jsx(Content, { children: t('and this occured') }), jsx(Content, __assign({ width: rem(happensOnce ? 7 : 10) }, { children: jsx(SelectInput, { options: [
                            {
                                label: t('once'),
                                value: 1
                            },
                            {
                                label: t('for more than'),
                                value: 0
                            }
                        ], value: [Number(happensOnce)], onChange: function (v) {
                            setHappensOnce(!!v.value);
                            onChange({
                                allowedNumberEvents: 1,
                                allowedTimeDifferenceSec: 60 * 10
                            });
                        } }) })), !happensOnce && (jsxs(Fragment, { children: [jsx(TimeDropDown, { seconds: (allowedNumberEvents || 0) * 5, onChange: handleFrequencyChange }), jsxs(Horizontal, __assign({ verticalAlign: "center", spacing: rem(0.5) }, { children: [jsx(Content, { children: t('times within a span of', {
                                        count: Number(allowedNumberEvents)
                                    }) }), jsx(TimeDropDown, { seconds: allowedTimeDifferenceSec, onChange: setTime })] }))] }))] })) })));
};

var useWordedStatement = function (_a) {
    var group = _a.group, options = _a.options, onSave = _a.onSave; _a.onEdit; var onCancel = _a.onCancel; _a.onDelete;
    var t = useTranslation().t;
    var _b = useState(), error = _b[0], setError = _b[1];
    var _c = useState(initialiseStatement(group)), statement = _c[0], setStatement = _c[1];
    useEffect(function () {
        initialiseStatement(group);
    }, [options]);
    function initialiseStatement(group) {
        return {
            groupingId: group.groupingId,
            allowedTimeDifferenceSec: group.allowedTimeDifferenceSec,
            allowedNumberEvents: group.allowedNumberEvents,
            configurations: !group.configurations || !group.configurations.length
                ? [{}]
                : group.configurations.map(function (config) { return (__assign({}, config)); })
        };
    }
    function handleStatementAdd(index) {
        var newConfigurations = __spreadArray([], (statement.configurations || []), true);
        newConfigurations.splice(index + 1, 0, {});
        setStatement(__assign(__assign({}, statement), { configurations: newConfigurations }));
    }
    function handleStatementDelete(index) {
        var newConfigurations = __spreadArray([], (statement.configurations || []), true);
        newConfigurations.splice(index, 1);
        setStatement(__assign(__assign({}, statement), { configurations: newConfigurations }));
    }
    function handleStatementFrequencyChange(data) {
        setStatement(__assign(__assign(__assign({}, statement), data), { error: false }));
        setError(null);
    }
    function handleStatementConfigurationChange(configurationIndex, data) {
        var newConfigurations = __spreadArray([], (statement.configurations || []), true);
        newConfigurations[configurationIndex] = data.signalKey
            ? __assign({}, data) : __assign(__assign({}, newConfigurations[configurationIndex]), data);
        setStatement(function (statement) { return (__assign(__assign({}, statement), { configurations: newConfigurations })); });
        setError(null);
    }
    function handleSave() {
        var _a;
        if (!group) {
            return;
        }
        var throwError = function () {
            throw new Error(t('All fields are required and must be filled out'));
        };
        try {
            if (statement.allowedNumberEvents == null ||
                statement.allowedTimeDifferenceSec == null) {
                throwError();
            }
            (statement.configurations || []).forEach(function (item) {
                if (item.signalKey == null ||
                    item.signalRelationship == null ||
                    item.signalValue === null) {
                    throwError();
                }
            });
            var configurations = (_a = statement.configurations) === null || _a === void 0 ? void 0 : _a.map(function (config) { return (__assign(__assign({}, config), { error: undefined })); });
            console.log({
                allowedNumberEvents: statement.allowedNumberEvents
            });
            var allowedNumberEventsFixed = Math.ceil(statement.allowedNumberEvents || 0);
            var savedStatement = __assign(__assign({}, statement), { configurations: configurations, allowedNumberEvents: allowedNumberEventsFixed, allowedTimeDifferenceSec: (statement.allowedNumberEvents || 0) * 5 >
                    (statement.allowedTimeDifferenceSec || 0)
                    ? (statement.allowedNumberEvents || 0) * 5
                    : statement.allowedTimeDifferenceSec || 0 });
            setStatement(savedStatement);
            onSave(savedStatement);
        }
        catch (err) {
            setError(err.message);
        }
    }
    function handleCancel() {
        onCancel();
        setStatement(initialiseStatement(group));
    }
    return {
        statement: statement,
        error: error,
        handleStatementAdd: handleStatementAdd,
        handleStatementDelete: handleStatementDelete,
        handleStatementFrequencyChange: handleStatementFrequencyChange,
        handleStatementConfigurationChange: handleStatementConfigurationChange,
        handleSave: handleSave,
        handleCancel: handleCancel
    };
};

var WordedStatement = function (_a) {
    var isEditing = _a.isEditing, canEdit = _a.canEdit, readonly = _a.readonly, options = _a.options, group = _a.group, onSave = _a.onSave, onEdit = _a.onEdit, onCancel = _a.onCancel, onDelete = _a.onDelete;
    var t = useTranslation().t;
    var _b = useWordedStatement({
        group: group,
        options: options,
        onSave: onSave,
        onEdit: onEdit,
        onCancel: onCancel,
        onDelete: onDelete
    }), statement = _b.statement, error = _b.error, handleStatementFrequencyChange = _b.handleStatementFrequencyChange, handleStatementConfigurationChange = _b.handleStatementConfigurationChange, handleStatementDelete = _b.handleStatementDelete, handleStatementAdd = _b.handleStatementAdd, handleCancel = _b.handleCancel, handleSave = _b.handleSave;
    return (jsxs(Vertical, __assign({ spacing: rem(1), "data-testid": "worded-statement" }, { children: [jsxs(Horizontal, __assign({ className: styles$b.statements, spacing: 0, padding: [0, rem(1)] }, { children: [jsxs(Grid, __assign({ spacing: [0, rem(0.5)], sizing: "stretch" }, { children: [(statement.configurations || []).map(function (item, configurationIndex, arr) {
                                return (jsxs(Horizontal, __assign({ verticalAlign: "center", padding: [rem(isEditing ? 0.5 : 1), 0], spacing: rem(0.5) }, { children: [jsx(Content, __assign({ verticalAlign: "center", horizontalAlign: "left" }, { children: t(configurationIndex === 0 ? 'If' : 'and') })), jsx(WordedCondition, { signals: options, readonly: !!readonly || !isEditing, selectedSignal: item, onChange: function (data) {
                                                return handleStatementConfigurationChange(configurationIndex, data);
                                            } }), isEditing && (jsx(Fragment, { children: jsxs(Horizontal, __assign({ spacing: 0 }, { children: [configurationIndex === arr.length - 1 && (jsx(IconButton, { icon: faPlus, onClick: function () {
                                                            return handleStatementAdd(configurationIndex);
                                                        } })), (statement.configurations || []).length > 1 && (jsx(IconButton, { icon: faTrash, onClick: function () {
                                                            return handleStatementDelete(configurationIndex);
                                                        } }))] })) }))] }), configurationIndex));
                            }), jsx(WordedFrequencyStatement, { readonly: !isEditing || readonly, error: statement.error, allowedNumberEvents: statement.allowedNumberEvents, allowedTimeDifferenceSec: statement.allowedTimeDifferenceSec, onChange: function (data) {
                                    return handleStatementFrequencyChange(__assign(__assign({}, statement), data));
                                } })] })), canEdit && !isEditing && !readonly && (jsx(Content, __assign({ padding: [rem(1), 0] }, { children: jsx(DropdownWrapper, __assign({ direction: "left", options: [
                                [
                                    {
                                        text: t('Edit'),
                                        onClick: onEdit
                                    },
                                    {
                                        text: t('Delete'),
                                        onClick: onDelete
                                    }
                                ]
                            ] }, { children: jsx(Icon, { icon: faCog }) })) })))] })), isEditing && !readonly && (jsxs(Horizontal, { children: [jsx(Stretch, { children: error && jsx("p", __assign({ className: styles$b.error }, { children: error })) }), jsxs(Horizontal, __assign({ spacing: rem(0.5) }, { children: [jsx(Button, { appearance: "dark", content: t('Cancel'), onClick: handleCancel }), jsx(Button, { appearance: "blue", content: t('Save'), onClick: handleSave })] }))] }))] })));
};
var styles$b = stylesheet({
    statements: {
        backgroundColor: Colours.blue,
        flexWrap: 'wrap',
        borderRadius: 5,
        color: Colours.textLight,
        fontFamily: fontFamily
    },
    error: {
        color: Colours.red,
        fontFamily: fontFamily,
        margin: 0
    }
});

var ExitConditions = function (_a) {
    var title = _a.title, nextScenario = _a.nextScenario, scenarioList = _a.scenarioList, conditions = _a.conditions, signals = _a.signals, readonly = _a.readonly, onChange = _a.onChange, onScenarioChange = _a.onScenarioChange;
    var _b = useExitCondition({
        conditions: conditions,
        onChange: onChange,
        onScenarioChange: onScenarioChange
    }), groups = _b.groups, groupBeingEdited = _b.groupBeingEdited, create = _b.create, change = _b.change, remove = _b.remove, changeScenario = _b.changeScenario, startEditingGroup = _b.startEditingGroup, cancelEditingGroup = _b.cancelEditingGroup;
    return (jsxs(Vertical, __assign({ spacing: rem(1), width: percent(100), "data-testid": "scenario-configurations-exit-conditions" }, { children: [jsxs(Horizontal, __assign({ verticalAlign: "center" }, { children: [jsx(Heading, __assign({ size: 4 }, { children: title })), scenarioList && (jsx(Box, __assign({ minWidth: rem(10) }, { children: jsx(SelectInput, { disabled: readonly, name: "next-scenario", value: [nextScenario], options: scenarioList, onChange: function (v) { return changeScenario === null || changeScenario === void 0 ? void 0 : changeScenario(v.value); } }, nextScenario) }))), !readonly && (jsxs(Fragment, { children: [jsx(StretchSpacer, {}), jsx(Button, { "data-testid": "exit-conditions-add-statement", appearance: "hollow", onClick: create, icon: faPlus, disabled: !!groupBeingEdited, content: t('Add statement') })] }))] })), groups.map(function (group, index) { return (jsx(WordedStatement, { group: group, options: signals, isEditing: !readonly && index === groupBeingEdited, canEdit: !readonly && (!groupBeingEdited || index === groupBeingEdited), onEdit: function () { return startEditingGroup(index); }, onCancel: function () { return cancelEditingGroup(); }, onSave: function (statement) { return change(statement); }, onDelete: function () { return remove(index); } }, "statement-".concat(JSON.stringify(group)))); })] })));
};

var ConfigurationType = {
    Bar: 0,
    Positive: 1,
    Negative: 2,
    Emergency: 3
};
var FeedStrategiesScenarioConfigurations = function (_a) {
    var scenarioList = _a.scenarioList, scenario = _a.scenario, _b = _a.signals, signals = _b === void 0 ? [] : _b, barList = _a.barList, stopList = _a.stopList, positiveList = _a.positiveList, negativeList = _a.negativeList, readonly = _a.readonly, onExitGroupChange = _a.onExitGroupChange, onAppetiteFactorChange = _a.onAppetiteFactorChange, onScenarioUpdate = _a.onScenarioUpdate;
    var t = useTranslation().t;
    var handleAppetiteFactorChange = function (data) {
        onAppetiteFactorChange(data);
    };
    var handleSaveExitGroup = function (type, conditions) {
        onExitGroupChange === null || onExitGroupChange === void 0 ? void 0 : onExitGroupChange(type, conditions);
    };
    var options = useMemo(function () {
        return (scenarioList || []).map(function (o) { return ({
            value: o.id,
            label: o.name
        }); });
    }, [scenarioList]);
    return (jsxs(Vertical, __assign({ spacing: rem(3), sizing: "stretch", width: percent(100), padding: [0, rem(1)], className: style({ boxSizing: 'border-box' }), "data-testid": "scenario-configurations" }, { children: [jsxs(Vertical, __assign({ spacing: rem(1), width: percent(100) }, { children: [jsx(Heading, __assign({ size: 2 }, { children: t('Appetite Factor') })), jsx(AppetiteFactorSettings, { isEmergency: scenario.isEmergencyScenario, bar: barList[0], disabled: scenario.isEmergencyScenario, readonly: readonly, onChange: handleAppetiteFactorChange })] })), jsxs(Vertical, __assign({ spacing: rem(1), width: percent(100), sizing: "stretch" }, { children: [jsx(Heading, __assign({ size: 2 }, { children: t('Configurations') })), jsxs(Vertical, __assign({ spacing: rem(3), padding: [rem(1), 0, 0, 0], sizing: "stretch", scroll: "vertical" }, { children: [jsx(ExitConditions, { readonly: readonly, title: "Exit Good", nextScenario: scenario.feedPositiveId, scenarioList: options, signals: signals, conditions: positiveList, onChange: function (data) {
                                    return handleSaveExitGroup(ConfigurationType.Positive, data);
                                }, onScenarioChange: function (v) {
                                    return onScenarioUpdate === null || onScenarioUpdate === void 0 ? void 0 : onScenarioUpdate({ id: scenario.id, feedPositiveId: v });
                                } }), !scenario.isEmergencyScenario && (jsx(ExitConditions, { readonly: readonly, title: t('Exit Bad'), nextScenario: scenario.feedNegativeId, scenarioList: options, signals: signals, conditions: negativeList, onChange: function (data) {
                                    return handleSaveExitGroup(ConfigurationType.Negative, data);
                                }, onScenarioChange: function (v) {
                                    return onScenarioUpdate === null || onScenarioUpdate === void 0 ? void 0 : onScenarioUpdate({ id: scenario.id, feedNegativeId: v });
                                } })), !scenario.isEmergencyScenario && (jsx(ExitConditions, { readonly: readonly, title: "Stop", nextScenario: null, conditions: stopList, signals: signals, onChange: function (data) {
                                    return handleSaveExitGroup(ConfigurationType.Emergency, data);
                                } }))] }))] }))] })));
};

var Card = function (_a) {
    var children = _a.children, _b = _a.sizing, sizing = _b === void 0 ? 'stretch' : _b, _c = _a.onClick, onClick = _c === void 0 ? function () { } : _c, active = _a.active;
    return (jsx(Box, __assign({ sizing: sizing, padding: rem(0.5), className: classes(styles$a.container, active && 'active'), onClick: function () { return onClick(); }, "data-testid": "card" }, { children: children })));
};
var styles$a = stylesheet({
    container: {
        fontFamily: fontFamily,
        cursor: 'pointer',
        position: 'relative',
        backgroundColor: Colours.blue,
        borderRadius: px(5),
        $nest: {
            '&.active': {
                $nest: {
                    '&::after': {
                        content: "''",
                        position: 'absolute',
                        width: percent(100),
                        height: percent(100),
                        display: 'block',
                        top: 0,
                        left: 0,
                        border: "2px solid ".concat(Colours.primary),
                        borderRadius: px(5),
                        pointerEvents: 'none',
                        boxSizing: 'border-box'
                    }
                }
            }
        }
    }
});

var ScenarioCard$1 = function (_a) {
    var scenario = _a.scenario, active = _a.active, locked = _a.locked, readonly = _a.readonly, options = _a.options, onDelete = _a.onDelete, onEdit = _a.onEdit, onSelect = _a.onSelect, onUpdate = _a.onUpdate;
    var name = scenario.name;
    var _b = useState(false), isEditing = _b[0], setIsEditing = _b[1];
    var _c = useState(name), newName = _c[0], setNewName = _c[1];
    var handleEdit = function () {
        onEdit(__assign(__assign({}, scenario), { name: newName }));
        setIsEditing(false);
    };
    var handleCancel = function () {
        setIsEditing(false);
        setNewName(name);
    };
    var handleUpdate = function (scenario) {
        onUpdate(scenario);
    };
    return (jsx(Card, __assign({ sizing: "content", active: active, onClick: function () { return onSelect(scenario); } }, { children: isEditing ? (jsxs(Vertical, __assign({ "data-testid": "scenario-card", spacing: rem(1), padding: [0, isEditing ? 0 : rem(0.5)], width: percent(100) }, { children: [jsx(TextInput, { value: newName, onChange: setNewName }), jsxs(Horizontal, __assign({ spacing: rem(0.5) }, { children: [jsx(Button, { content: "Save", appearance: "blue", fullWidth: true, onClick: handleEdit }), jsx(Button, { content: "Cancel", appearance: "blue", fullWidth: true, onClick: handleCancel })] }))] }))) : (jsxs(Vertical, __assign({ "data-testid": "scenario-card", spacing: rem(1), width: percent(100) }, { children: [jsxs(Horizontal, __assign({ verticalAlign: "center", spacing: rem(0.5), padding: [0, rem(0.5)] }, { children: [jsx(Box, __assign({ verticalAlign: "center", height: rem(2.5) }, { children: jsx(Heading, __assign({ size: 3 }, { children: name })) })), !locked && !readonly && (jsxs(Fragment, { children: [jsx(StretchSpacer, {}), jsx(DropdownWrapper, __assign({ direction: "left", options: [
                                        [
                                            {
                                                text: 'Edit',
                                                onClick: function () { return setIsEditing(true); }
                                            },
                                            {
                                                text: 'Delete',
                                                onClick: function () { return onDelete(scenario); }
                                            }
                                        ]
                                    ] }, { children: jsx(Box, __assign({ width: px(40), horizontalAlign: "center" }, { children: jsx(Icon, { icon: faCog, className: style({ color: Colours.textLight }) }) })) }))] }))] })), jsxs(Vertical, __assign({ sizing: "stretch", padding: [0, rem(0.5), rem(0.5), rem(0.5)] }, { children: [jsxs(Horizontal, __assign({ sizing: "stretch" }, { children: [jsx(SelectInput, { disabled: readonly, name: "exit-good", options: options, placeholder: "Exit Good...", value: [scenario.feedPositiveId], onChange: function (v) {
                                        handleUpdate({
                                            id: scenario.id,
                                            feedPositiveId: Number(v.value) || null
                                        });
                                    } }), jsx("div", __assign({ className: classes(styles$9.icon, styles$9.plus) }, { children: jsx(Icon, { color: "black", icon: faPlus }) }))] })), !scenario.isEmergencyScenario ? (jsxs(Horizontal, __assign({ sizing: "stretch" }, { children: [jsx(SelectInput, { disabled: readonly, name: "exit-bad", options: options, placeholder: "Exit Bad...", value: [scenario.feedNegativeId], onChange: function (v) {
                                        return handleUpdate({
                                            id: scenario.id,
                                            feedNegativeId: Number(v.value) || null
                                        });
                                    } }), jsx("div", __assign({ className: classes(styles$9.icon, styles$9.minus) }, { children: jsx(Icon, { color: "black", icon: faMinus }) }))] }))) : null] }))] }))) })));
};
var styles$9 = stylesheet({
    icon: {
        width: px(36),
        height: px(36),
        borderRadius: px(2),
        display: 'grid',
        placeItems: 'center'
    },
    plus: {
        backgroundColor: Colours.green
    },
    minus: {
        backgroundColor: Colours.red
    }
});

var CreateCard = function (_a) {
    var disabled = _a.disabled, placeholder = _a.placeholder, onCreate = _a.onCreate;
    var _b = useState(), value = _b[0], setValue = _b[1];
    return (jsx(Card, { children: jsxs(Vertical, __assign({ spacing: rem(1), width: percent(100), "data-testid": "create-card" }, { children: [jsx(TextInput, { disabled: disabled, value: value, placeholder: placeholder, onChange: setValue }), jsx(Button, { appearance: "blue", content: "Create", disabled: disabled, fullWidth: true, onClick: function () {
                        value && onCreate(value);
                        setValue(undefined);
                    } })] })) }));
};

var ScenarioList = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, idSelected = _a.idSelected, readonly = _a.readonly, onCreate = _a.onCreate, onDelete = _a.onDelete, onSelect = _a.onSelect, onUpdate = _a.onUpdate;
    var scenarios = useMemo(function () {
        return list
            .filter(function (e) { return !e.isPauseScenario; })
            .reduce(function (a, b) {
            return b.isEmergencyScenario
                ? __spreadArray(__spreadArray([], a, true), [b], false) : b.isStartingScenario
                ? __spreadArray([b], a, true) : __spreadArray(__spreadArray(__spreadArray([], a.slice(0, 1), true), [b], false), a.slice(1), true);
        }, []);
    }, [list]);
    var options = useMemo(function () {
        return scenarios.map(function (item) { return ({
            label: item.name,
            value: item.id
        }); });
    }, [scenarios]);
    var handleSelect = function (scenario) {
        onSelect(scenario);
    };
    var handleCreate = function (scenario) {
        onCreate(scenario);
    };
    var handleUpdate = function (scenario) {
        onUpdate(scenario);
    };
    var handleDelete = function (scenario) {
        onDelete(scenario.id);
    };
    return (jsxs(Vertical, __assign({ width: 290, height: percent(100), "data-testid": "scenarios-list" }, { children: [jsxs(Heading, __assign({ size: 2 }, { children: ["Scenarios ( ", list.length, " )"] })), jsx(Stretch, __assign({ scroll: "vertical" }, { children: jsx(Vertical, __assign({ width: percent(100) }, { children: scenarios.map(function (scenario) {
                        return (jsx(ScenarioCard$1, { scenario: scenario, active: scenario.id === idSelected, readonly: readonly, locked: scenario.isEmergencyScenario || scenario.isStartingScenario, onSelect: handleSelect, onDelete: handleDelete, onEdit: handleUpdate, onUpdate: handleUpdate, options: options }, 'scenario-' + JSON.stringify(scenario)));
                    }) })) })), !readonly && (jsx("div", __assign({ className: "item-container create" }, { children: jsx(CreateCard, { placeholder: "Scenario Name", onCreate: function (v) { return handleCreate({ name: v }); } }) })))] })));
};

var deepEqual = function (x, y) {
    if (x === y) {
        return true;
    }
    else if (typeof x == 'object' &&
        x != null &&
        typeof y == 'object' &&
        y != null) {
        if (Object.keys(x).length != Object.keys(y).length)
            return false;
        for (var prop in x) {
            if (y.hasOwnProperty(prop)) {
                if (!deepEqual(x[prop], y[prop]))
                    return false;
            }
            else
                return false;
        }
        return true;
    }
    else
        return false;
};

var StrategyCard = function (_a) {
    var strategy = _a.strategy, disabled = _a.disabled, active = _a.active, readonly = _a.readonly, onToggle = _a.onToggle, onDelete = _a.onDelete, onEdit = _a.onEdit, onSelect = _a.onSelect;
    var name = strategy.name, evaluateDaily = strategy.evaluateDaily;
    var _b = useState(false), isEditing = _b[0], setIsEditing = _b[1];
    var _c = useState(name), newName = _c[0], setNewName = _c[1];
    var handleEdit = function () {
        onEdit(__assign(__assign({}, strategy), { name: newName }));
        setIsEditing(false);
    };
    var handleCancel = function () {
        setIsEditing(false);
        setNewName(name);
    };
    return (jsx(Card, __assign({ sizing: "content", active: active, onClick: function () { return onSelect(strategy); }, "data-testid": "strategy-card" }, { children: isEditing ? (jsxs(Vertical, __assign({ spacing: rem(1), padding: [0, isEditing ? 0 : rem(0.5)], width: percent(100), "data-testid": "strategy-card-editing" }, { children: [jsx(TextInput, { value: newName, onChange: setNewName }), jsxs(Horizontal, __assign({ spacing: rem(0.5) }, { children: [jsx(Button, { content: "Save", appearance: "blue", fullWidth: true, onClick: handleEdit }), jsx(Button, { content: "Cancel", appearance: "blue", fullWidth: true, onClick: handleCancel })] }))] }))) : (jsxs(Horizontal, __assign({ verticalAlign: "center", width: percent(100), minHeight: px(30), spacing: rem(0.5), className: style({ boxSizing: 'border-box' }), padding: [0, rem(0.5)], "data-testid": "strategy-card" }, { children: [jsx(Box, __assign({ maxWidth: rem(10), "data-testid": "strategy-card-name" }, { children: jsx(Heading, __assign({ size: 3 }, { children: name })) })), jsx(StretchSpacer, {}), jsxs(Horizontal, __assign({ verticalAlign: "center", spacing: rem(1) }, { children: [jsx(Switch, { checked: !!evaluateDaily, disabled: disabled || readonly, onChange: function () {
                                onToggle(!evaluateDaily);
                            } }), !readonly && (jsx(DropdownWrapper, __assign({ options: [
                                [
                                    {
                                        text: 'Edit',
                                        onClick: function () { return setIsEditing(true); }
                                    },
                                    {
                                        text: 'Delete',
                                        onClick: function () { return onDelete(strategy); }
                                    }
                                ]
                            ] }, { children: jsx(Icon, { icon: faCog, className: style({ color: Colours.textLight }) }) })))] }))] }))) })));
};

var StrategyList = function (_a) {
    var _b = _a.list, list = _b === void 0 ? [] : _b, idSelected = _a.idSelected, readonly = _a.readonly, onSelect = _a.onSelect, onDelete = _a.onDelete, onCreate = _a.onCreate, onUpdate = _a.onUpdate;
    var limit = 3;
    var defaultLimit = 1;
    var countDefault = useMemo(function () {
        return list.reduce(function (a, b) { return (b.evaluateDaily ? __spreadArray(__spreadArray([], a, true), [b], false) : a); }, []);
    }, [list]);
    var _c = useState(countDefault), defaults = _c[0], setDefaults = _c[1];
    useEffect(function () {
        setDefaults(function (prevList) {
            return deepEqual(prevList, list) ? prevList : countDefault;
        });
    }, [setDefaults, countDefault]);
    var handleSelect = function (strategy) {
        onSelect(strategy);
    };
    var handleCreate = function (strategy) {
        if (list.length >= limit) {
            return;
        }
        onCreate === null || onCreate === void 0 ? void 0 : onCreate(__assign(__assign({}, strategy), { evaluateDaily: false }));
    };
    var handleUpdate = function (strategy) {
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(strategy);
    };
    var handleDelete = function (strategy) {
        onDelete === null || onDelete === void 0 ? void 0 : onDelete(strategy.id);
    };
    return (jsxs(Vertical, __assign({ width: px(290), height: percent(100) }, { children: [jsxs(Heading, __assign({ size: 2 }, { children: ["Strategies ( ", list.length, !readonly && "/".concat(limit), " )"] })), jsx(Vertical, __assign({ sizing: "stretch", "data-testid": "strategy-list" }, { children: list.map(function (strategy) { return (jsx(StrategyCard, { strategy: strategy, active: strategy.id === idSelected, disabled: !strategy.evaluateDaily && defaults.length >= defaultLimit, readonly: readonly, onToggle: function (checked) {
                        return handleUpdate(__assign(__assign({}, strategy), { evaluateDaily: checked }));
                    }, onEdit: handleUpdate, onDelete: handleDelete, onSelect: handleSelect }, 'strategy-' + strategy.id)); }) })), !readonly && (jsx("div", __assign({ className: "item-container create" }, { children: jsx(CreateCard, { disabled: list.length >= limit, placeholder: "Strategy Name", onCreate: function (v) { return handleCreate({ name: v }); } }) })))] })));
};

var ActionEdge = function (_a) {
    var id = _a.id, sourceX = _a.sourceX, sourceY = _a.sourceY, targetX = _a.targetX, targetY = _a.targetY, data = _a.data, sourcePosition = _a.sourcePosition, targetPosition = _a.targetPosition, style$1 = _a.style;
    var t = useTranslation().t;
    var pausedSeconds = (data === null || data === void 0 ? void 0 : data.pause) || 0;
    var isPaused = data && (data === null || data === void 0 ? void 0 : data.pause) > 0;
    var edgePath = getSmoothStepPath({
        sourceX: sourceX,
        sourceY: sourceY,
        targetX: targetX,
        targetY: targetY,
        sourcePosition: sourcePosition,
        targetPosition: targetPosition,
        centerX: targetX - (targetX - sourceX) / 2 + ((data === null || data === void 0 ? void 0 : data.isPositive) ? 5 : 0)
    })[0];
    var formattedPause = pausedSeconds > 60
        ? "".concat(String(Math.floor(pausedSeconds / 60)).padStart(2, '0'), "m ").concat(pausedSeconds % 60, "s")
        : "".concat(pausedSeconds, "s");
    return (jsxs(Fragment, { children: [jsx(BaseEdge, { id: id, path: edgePath, style: style$1 }), jsx(EdgeLabelRenderer, { children: jsx("div", __assign({ style: {
                        display: (data === null || data === void 0 ? void 0 : data.selected) || isPaused ? 'block' : 'none',
                        position: 'absolute',
                        transform: "translate(0, -50%) translate(".concat(sourceX + 20, "px,").concat(sourceY, "px)"),
                        cursor: 'pointer',
                        backgroundColor: Colours.darkBlue,
                        borderRadius: Sizes.borderRadius,
                        border: (data === null || data === void 0 ? void 0 : data.selected) ? "2px solid ".concat(Colours.primary) : 'none',
                        padding: rem(0.5),
                        fontFamily: fontFamily,
                        color: Colours.textLight
                    }, className: "nodrag nopan", onClick: function () { } }, { children: jsx(Vertical$1, __assign({ spacing: rem(0.5) }, { children: jsxs(Horizontal$1, __assign({ verticalAlign: "center", spacing: rem(0.5) }, { children: [jsx(Icon, { className: style({
                                        borderRadius: '50%',
                                        border: '1px solid',
                                        borderColor: Colours.textLight,
                                        height: '16px',
                                        width: '16px',
                                        padding: '2px'
                                    }), icon: isPaused ? faPauseCircle : faPlusCircle, color: Colours.textLight }), isPaused && jsx(Box$1, __assign({ height: percent(100) }, { children: formattedPause })), !isPaused && jsx(Heading, __assign({ size: 5 }, { children: t('Add Pause') }))] })) })) })) })] }));
};

var NODE_WIDTH = 350;
var NODE_HEIGHT = 350;
var GAP_SIZE_X = 300;
var GAP_SIZE_Y = 50;
// The depth field is always visible when enabled, so its height is always
// reserved in the row spacing.
var DEPTH_FIELD_HEIGHT = 50;
// Covers the selected-only camera-action readout: label + boxed value + the
// inter-row gap, with margin so an opened card never overlaps the row below.
var CAMERA_ACTION_FIELD_HEIGHT = 120;
var COLUMN_WIDTH = NODE_WIDTH + GAP_SIZE_X;
var COLUMN_HEIGHT = NODE_HEIGHT + GAP_SIZE_Y;
var generateFlowChart = function (scenarios, selectedNodeId, editable, onDisconnect, onDepthChange, onCameraActionChange) {
    var _a;
    var _b;
    if (editable === void 0) { editable = true; }
    scenarios = scenarios.map(function (s) { return (__assign(__assign({}, s), { pauses: { positive: -1, negative: -1, emergency: -1 } })); });
    // Get the pause scenarios out and link together paused scenarios
    var pauseScenarios = scenarios.filter(function (s) { return s.isPauseScenario; });
    var scenariosLessPauses = scenarios.filter(function (s) { return !s.isPauseScenario; });
    scenariosLessPauses.forEach(function (scenario) {
        // For each scenario that is linked to a pause scenario, turn that into a edge with time
        var keys = ['feedPositiveId', 'feedNegativeId'];
        var getWaitTimeInSeconds = function (s) {
            var positiveExit = s.configurations.statements.positive[0];
            return positiveExit.allowedNumberEvents * 5;
        };
        keys.forEach(function (key) {
            var linkedToPause = pauseScenarios.find(function (p) { return p.id === scenario[key]; });
            if (linkedToPause) {
                var time = getWaitTimeInSeconds(linkedToPause);
                var exitType = key
                    .replace('feed', '')
                    .replace('Id', '')
                    .toLowerCase();
                if (key === 'feedPositiveId')
                    scenario.feedPositiveId = linkedToPause.feedPositiveId;
                if (key === 'feedNegativeId')
                    scenario.feedNegativeId = linkedToPause.feedPositiveId;
                if (!scenario.pauses) {
                    scenario.pauses = { positive: -1, negative: -1, emergency: -1 };
                }
                scenario.pauses[exitType] = time;
            }
        });
    });
    // Base row spacing. The depth field is always visible when enabled, so it is
    // always reserved. The camera-action readout is selected-only, so its height
    // is reserved by `rowY` only for the rows BELOW the selected card (see below) —
    // this keeps unselected/FEED rows tight with no empty gap.
    var baseRowHeight = COLUMN_HEIGHT + (onDepthChange ? DEPTH_FIELD_HEIGHT : 0);
    var xMidpoints = {};
    var yMidpoints = {};
    var createPath = function (graph, source, target, type) {
        var _a;
        if (!target || !source)
            return { nodes: [], edges: [] };
        var scenario = scenarios.find(function (s) { return s.id === source.id; });
        var targetCoordinate = graph[Number(target.id)];
        var sourceCoordinate = graph[Number(source.id)];
        if (!targetCoordinate || !sourceCoordinate)
            return { nodes: [], edges: [] };
        var nodeIsSelected = String(source.id) === selectedNodeId;
        var pause = ((scenario === null || scenario === void 0 ? void 0 : scenario.pauses) &&
            ((_a = scenario === null || scenario === void 0 ? void 0 : scenario.pauses) === null || _a === void 0 ? void 0 : _a[type === 'positive' ? 'positive' : 'negative'])) ||
            -1;
        var isEmergencyScenario = scenario === null || scenario === void 0 ? void 0 : scenario.isEmergencyScenario;
        var directExit = sourceCoordinate.x + 1 === targetCoordinate.x;
        var exitAheadCurrent = sourceCoordinate.x < targetCoordinate.x;
        var exitAboveCurrent = sourceCoordinate.y > targetCoordinate.y;
        var sourceMidpointId = "mp1-".concat(source.id, "-").concat(target.id, "-").concat(type);
        var targetMidpointId = "mp2-".concat(source.id, "-").concat(target.id, "-").concat(type);
        if (directExit) {
            return {
                nodes: [],
                edges: [
                    newConnection({
                        id: "e".concat(source.id, "-").concat(target.id, "-").concat(type),
                        source: String(source.id),
                        target: String(target.id),
                        selected: nodeIsSelected,
                        type: type,
                        firstPathInLink: true,
                        pause: pause,
                        editable: editable
                    })
                ]
            };
        }
        else {
            if (yMidpoints[targetCoordinate.y] === undefined) {
                yMidpoints[targetCoordinate.y] = 0;
            }
            else {
                yMidpoints[targetCoordinate.y] = yMidpoints[targetCoordinate.y] + 3;
            }
            if (xMidpoints[targetCoordinate.x] === undefined) {
                xMidpoints[targetCoordinate.x] = 0;
            }
            else {
                xMidpoints[targetCoordinate.x] = xMidpoints[targetCoordinate.x] + 10;
            }
            var midYOffset = yMidpoints[targetCoordinate.y];
            var midXOffset = xMidpoints[targetCoordinate.x];
            var midpointY = type === 'negative'
                ? rowY(exitAboveCurrent ? sourceCoordinate.y : targetCoordinate.y) +
                    baseRowHeight -
                    25 +
                    midYOffset
                : rowY(targetCoordinate.y) - 25 + midYOffset;
            var sourceX = sourceCoordinate.x * COLUMN_WIDTH + 100 + COLUMN_WIDTH / 2 + midXOffset;
            var targetX = targetCoordinate.x * COLUMN_WIDTH - 100 - midXOffset;
            return {
                nodes: [
                    newMidpoint({
                        id: sourceMidpointId,
                        position: {
                            x: sourceX,
                            y: midpointY
                        },
                        targetPosition: type === 'negative' ? Position.Top : Position.Bottom,
                        sourcePosition: exitAheadCurrent ? Position.Right : Position.Left
                    }),
                    newMidpoint({
                        id: targetMidpointId,
                        position: {
                            x: targetX,
                            y: midpointY
                        },
                        sourcePosition: type === 'negative' ? Position.Top : Position.Bottom,
                        targetPosition: exitAheadCurrent ? Position.Left : Position.Right
                    })
                ],
                edges: [
                    newConnection({
                        id: "e1".concat(source.id, "-").concat(sourceMidpointId),
                        source: String(source.id),
                        target: sourceMidpointId,
                        selected: nodeIsSelected,
                        type: type,
                        firstPathInLink: !isEmergencyScenario,
                        pause: pause,
                        editable: editable
                    }),
                    newConnection({
                        id: "e2".concat(sourceMidpointId, "-").concat(targetMidpointId),
                        source: sourceMidpointId,
                        target: targetMidpointId,
                        selected: nodeIsSelected,
                        type: type,
                        firstPathInLink: false,
                        editable: editable
                    }),
                    newConnection({
                        id: "e3".concat(targetMidpointId, "-").concat(target.id),
                        source: targetMidpointId,
                        target: String(target.id),
                        selected: nodeIsSelected,
                        type: type,
                        firstPathInLink: false,
                        editable: editable
                    })
                ]
            };
        }
    };
    var getAverageAF = function (scenario) {
        var barConfigs = scenario.configurations.bar.configurations;
        var middleAppetiteFactor = barConfigs.sort(function (a, b) {
            return Number(a.signalKey.replace('BAR_', '')) -
                Number(b.signalKey.replace('BAR_', ''));
        });
        //Just in case the barConfigs are empty or undefined
        if (!(middleAppetiteFactor === null || middleAppetiteFactor === void 0 ? void 0 : middleAppetiteFactor.length))
            return 0;
        if (middleAppetiteFactor.length !== 3)
            return Number(middleAppetiteFactor[0].signalValue);
        return Number(middleAppetiteFactor[1].signalValue);
    };
    // Recursively create all the positive jumps, then all the negative jumps afterwards.
    // This will create nice feed profile curve.
    var startScenario = scenariosLessPauses.find(function (e) { return e.isStartingScenario; });
    var emergencyScenario = scenariosLessPauses.find(function (e) { return e.isEmergencyScenario; });
    var recurseGraph = function (scenario, graph, row, col) {
        if (!scenario || graph[scenario.id])
            return graph;
        var positiveScenario = scenariosLessPauses.find(function (e) { return e.id === scenario.feedPositiveId; });
        var negativeScenario = scenariosLessPauses.find(function (e) { return e.id === scenario.feedNegativeId; });
        // Sort by AF:
        var afs = {
            pos: (positiveScenario && getAverageAF(positiveScenario)) || 0,
            neg: (negativeScenario && getAverageAF(negativeScenario)) || 0,
            cur: getAverageAF(scenario)
        };
        graph[scenario.id] = { x: col, y: row, af: afs.cur };
        var ordering = Object.keys(afs).sort(function (a, b) {
            var isSame = Number(afs[a]) === Number(afs[b]);
            if (isSame) {
                if (a === 'pos' && b === 'neg')
                    return -1;
                if (a === 'neg' && b === 'pos')
                    return 1;
                return -1;
            }
            return Number(afs[a]) - Number(afs[b]);
        });
        var indexOfCur = ordering.indexOf('cur');
        var indexOfPos = ordering.indexOf('pos');
        var indexOfneg = ordering.indexOf('neg');
        var equalPos = afs['cur'] === afs['pos'] ? -1 : 0;
        var equalNeg = afs['cur'] === afs['neg'] ? -1 : 0;
        var rowAddPos = indexOfPos - indexOfCur + equalPos + equalNeg;
        var rowAddNeg = indexOfneg - indexOfCur + equalPos + equalNeg;
        if (positiveScenario)
            graph = recurseGraph(positiveScenario, graph, row - rowAddPos, col + 1);
        if (negativeScenario)
            graph = recurseGraph(negativeScenario, graph, row - rowAddNeg, col + 1);
        return graph;
    };
    var graph = recurseGraph(startScenario, emergencyScenario
        ? (_a = {},
            _a[emergencyScenario.id] = { x: 0, y: 1, af: 0 },
            _a) : {}, 0, 0);
    var lonelyScenarios = scenariosLessPauses.filter(function (_a) {
        var id = _a.id;
        return !Object.keys(graph).map(Number).includes(id);
    });
    var graphValues = Object.values(graph);
    var maxRow = Math.max.apply(Math, (graphValues ? graphValues.map(function (e) { return e.y; }) : [-100]));
    var maxColumn = Math.max.apply(Math, (graphValues ? graphValues.map(function (e) { return e.x; }) : [-100]));
    // Add lonely scenarios to the graph
    lonelyScenarios.forEach(function (scenario, x) {
        graph[scenario.id] = { x: maxColumn + 1, y: x, af: getAverageAF(scenario) };
    });
    // Normalize the graph so that the highest point has y value 0
    var normalizedGraph = Object.entries(graph).reduce(function (acc, _a) {
        var _b;
        var key = _a[0], value = _a[1];
        var normalizedY = value.y - maxRow;
        return __assign(__assign({}, acc), (_b = {}, _b[key] = __assign(__assign({}, value), { y: normalizedY }), _b));
    }, {});
    var matrixGraph = Object.entries(normalizedGraph).reduce(function (acc, _a) {
        var key = _a[0], value = _a[1];
        var x = value.x, y = value.y;
        var currentY = y;
        if (!acc[x])
            acc[x] = {};
        //If there is an existing value, shift everything around based on the AF
        if (acc[x][y]) {
            var unplaced = Number(key);
            while (acc[x][currentY]) {
                var current = Number(acc[x][y]);
                var placedAf = normalizedGraph[current].af;
                var newAf = normalizedGraph[unplaced].af;
                acc[x][currentY] = placedAf > newAf ? unplaced : current;
                unplaced = placedAf < newAf ? current : unplaced;
                currentY -= 1;
            }
            acc[x][currentY] = unplaced;
        }
        acc[x][currentY] = Number(key);
        return acc;
    }, {});
    var finalGraph = Object.keys(matrixGraph).reduce(function (acc, x) {
        var row = matrixGraph[Number(x)];
        Object.keys(row).forEach(function (y) {
            var key = row[Number(y)];
            acc[key] = { x: Number(x), y: Number(y), af: normalizedGraph[key].af };
        });
        return acc;
    }, {});
    // Selected-card row: the camera-action readout only renders on the selected
    // card, so reserve its height only for the rows below it — opening space under
    // the opened card without adding a gap to unselected/FEED rows.
    var selectedRow = selectedNodeId != null ? (_b = finalGraph[Number(selectedNodeId)]) === null || _b === void 0 ? void 0 : _b.y : undefined;
    var rowY = function (row) {
        return row * baseRowHeight +
            (onCameraActionChange && selectedRow !== undefined && row > selectedRow
                ? CAMERA_ACTION_FIELD_HEIGHT
                : 0);
    };
    var edges = [];
    var nodes = [];
    Object.entries(finalGraph).forEach(function (_a) {
        var scenarioId = _a[0], position = _a[1];
        var scenario = scenariosLessPauses.find(function (e) { return e.id === Number(scenarioId); });
        var positiveExit = scenariosLessPauses.find(function (s) { return s.id === (scenario === null || scenario === void 0 ? void 0 : scenario.feedPositiveId); });
        var negativeExit = scenariosLessPauses.find(function (s) { return s.id === (scenario === null || scenario === void 0 ? void 0 : scenario.feedNegativeId); });
        var positiveLink = createPath(finalGraph, scenario, positiveExit, 'positive');
        var negativeLink = createPath(finalGraph, scenario, negativeExit, 'negative');
        nodes = nodes.concat(__spreadArray(__spreadArray(__spreadArray([], positiveLink.nodes, true), negativeLink.nodes, true), [
            {
                id: String(scenarioId),
                type: 'scenario',
                position: {
                    x: position.x * COLUMN_WIDTH,
                    y: rowY(position.y)
                },
                data: __assign(__assign({}, scenario), { onDisconnect: onDisconnect, onDepthChange: onDepthChange, onCameraActionChange: onCameraActionChange, isSelected: String(scenarioId) === selectedNodeId })
            }
        ], false));
        edges = edges.concat(__spreadArray(__spreadArray([], positiveLink.edges, true), negativeLink.edges, true));
    });
    // //remove duplicate nodes by id
    // nodes = nodes.filter(
    //   (node, index, self) => index === self.findIndex((t) => t.id === node.id)
    // );
    // //remove duplicate edges by id
    // edges = edges.filter(
    //   (edge, index, self) => index === self.findIndex((t) => t.id === edge.id)
    // );
    return { nodes: nodes, edges: edges };
};
var newConnection = function (_a) {
    var id = _a.id, type = _a.type, target = _a.target, source = _a.source, selected = _a.selected, firstPathInLink = _a.firstPathInLink, pause = _a.pause, editable = _a.editable;
    return ({
        id: id,
        sourceHandle: type,
        target: target,
        source: source,
        type: firstPathInLink && (editable || Number(pause) > 0) ? 'action' : 'step',
        style: {
            strokeWidth: selected ? 4 : 1,
            stroke: selected
                ? type === 'positive'
                    ? Colours.green
                    : Colours.red
                : Colours.lighterBlue
        },
        data: {
            pause: pause,
            isPositive: type === 'positive',
            selected: selected
        }
    });
};
var newMidpoint = function (_a) {
    var id = _a.id, position = _a.position, targetPosition = _a.targetPosition, sourcePosition = _a.sourcePosition;
    return ({
        id: id,
        type: 'midpoint',
        position: position,
        data: {
            midpoint: true
        },
        targetPosition: targetPosition,
        sourcePosition: sourcePosition
    });
};

var Midpoint = memo(function (_a) {
    var targetPosition = _a.targetPosition, sourcePosition = _a.sourcePosition;
    return (jsxs(Horizontal, __assign({ spacing: 0, width: 1, height: 1 }, { children: [jsx(Handle, { type: "target", position: targetPosition || Position.Top, style: {
                    opacity: 0
                } }), jsx(Handle, { type: "source", position: sourcePosition || Position.Bottom, style: {
                    opacity: 0
                } })] })));
});

var useToastNotifications = function () {
    var addToast = useToasts().addToast;
    return {
        addToast: function (message, appearance) {
            addToast(message, {
                appearance: appearance,
                id: typeof message === 'string' ? message : v4()
            });
        }
    };
};

var appetiteFactorColours = [Colours.red, Colours.primary, Colours.green];
var AppetiteFactor = function (_a) {
    var bar = _a.bar;
    var t = useTranslation().t;
    var configurations = useMemo(function () {
        return bar.configurations
            .slice()
            .sort(function (a, b) {
            return Number(a.signalKey.split('_')[1]) - Number(b.signalKey.split('_')[1]);
        });
    }, [bar]);
    var _b = useTimeConverter(bar.barWaitTimeSec)[0], time = _b.time, timeType = _b.type;
    return (jsxs(Vertical, __assign({ spacing: px(15), "data-testid": "flow-chart-scenario-appetite-factor" }, { children: [jsxs(Horizontal, { children: [jsx("span", __assign({ className: style({ color: Colours.textLight }) }, { children: t('Appetite Factor') })), jsx(StretchSpacer, {}), jsxs("span", __assign({ className: style({ color: Colours.textLight }), "data-testid": "flow-chart-scenario-appetite-factor-time" }, { children: [time, " ", t(timeType.label)] }))] }), jsx(Horizontal, __assign({ spacing: 0, height: px(32) }, { children: configurations.map(function (config, index) { return (jsxs(Vertical, __assign({ sizing: "stretch", spacing: px(10) }, { children: [jsx(Horizontal, __assign({ spacing: 0 }, { children: jsx(Stretch, { height: px(5), className: style({
                                    backgroundColor: appetiteFactorColours[index]
                                }) }) })), jsx(Stretch, __assign({ horizontalAlign: "center", className: style({
                                color: Colours.textLight,
                                fontSize: Sizes.fontSize2
                            }), "data-testid": 'bar-' + index }, { children: config.signalValue }))] }), config.signalDisplayName + index)); }) }))] })));
};

var ReadonlyValueBox = function (_a) {
    var value = _a.value, dataTestId = _a["data-testid"];
    return (jsx(Horizontal, __assign({ minHeight: px(36), verticalAlign: "top", padding: [7, 8, 7, 15], spacing: rem(0.5), "data-testid": dataTestId, className: style({
            backgroundColor: Colours.darkBlue,
            borderRadius: Sizes.borderRadius
        }) }, { children: jsx("div", __assign({ className: style({
                color: Colours.textLight,
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                display: 'block',
                lineHeight: rem(2.2),
                width: percent(100)
            }) }, { children: value })) })));
};

var mapStatementToWordStatement = function (statement) {
    var _a, _b;
    if (!((_a = statement === null || statement === void 0 ? void 0 : statement.configurations) === null || _a === void 0 ? void 0 : _a.length))
        return null;
    var _c = convertTime(statement.allowedTimeDifferenceSec), time = _c.time, timeType = _c.timeType;
    var statements = (_b = statement === null || statement === void 0 ? void 0 : statement.configurations) === null || _b === void 0 ? void 0 : _b.map(function (config) {
        return "".concat(config.signalDisplayName, " ").concat(config.signalRelationship, " ").concat(config.signalValue);
    });
    var happensOnce = statement.allowedNumberEvents === 1 &&
        statement.allowedTimeDifferenceSec === 60 * 10;
    return "".concat(statements === null || statements === void 0 ? void 0 : statements.join(' & '), " ").concat(happensOnce
        ? "once"
        : "for ".concat((statement === null || statement === void 0 ? void 0 : statement.allowedNumberEvents) * 5, "s in ").concat(time).concat(timeType.label[0]));
};
var Statement = function (_a) {
    var type = _a.type, statements = _a.statements;
    var iconStyle = type === 'positive' ? styles$8.plus : styles$8.minus;
    return (jsxs(Horizontal, __assign({ minHeight: px(36), verticalAlign: "top", padding: [7, 8, 7, 15], className: style({
            backgroundColor: Colours.darkBlue,
            borderRadius: Sizes.borderRadius
        }), spacing: rem(0.5) }, { children: [jsx("div", __assign({ "data-testid": "statements", className: style({
                    color: Colours.textLight,
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    overflow: 'hidden',
                    display: 'block',
                    lineHeight: rem(2.2),
                    width: percent(100)
                }), title: statements.map(function (s) { return mapStatementToWordStatement(s); }).join('; ') }, { children: mapStatementToWordStatement(statements[0]) })), jsxs(Box, __assign({ horizontalAlign: "center", verticalAlign: "center", className: classes(styles$8.icon, iconStyle) }, { children: [type !== 'emergency' && (jsx(Icon, { color: "black", icon: type === 'positive' ? faPlus : faMinus })), type === 'emergency' && (jsx(Box, { "data-testid": "emergency-icon", width: px(15), height: px(15), className: style({ backgroundColor: 'black' }) }))] }))] })));
};
var styles$8 = stylesheet({
    icon: {
        width: px(36),
        height: px(36),
        borderRadius: px(2),
        display: 'grid',
        placeItems: 'center'
    },
    plus: {
        backgroundColor: Colours.green
    },
    minus: {
        backgroundColor: Colours.red
    }
});

var ScenarioCard = memo(function (_a) {
    var _b, _c;
    var data = _a.data;
    var t = useTranslation().t;
    var _d = useState(data.depth), pendingDepth = _d[0], setPendingDepth = _d[1];
    useEffect(function () {
        setPendingDepth(data.depth);
    }, [data.depth]);
    return (jsxs(Horizontal, __assign({ spacing: 0, width: "300", "data-testid": "flow-chart-scenario-card" }, { children: [jsx(Card, __assign({ active: data.isSelected }, { children: jsxs(Vertical, __assign({ width: px(300), padding: [px(5), px(10), px(10), px(10)], spacing: 10 }, { children: [jsxs(Horizontal, __assign({ verticalAlign: "center", height: data.onDepthChange ? px(DEPTH_INPUT_HEIGHT) : rem(2), spacing: rem(1) }, { children: [jsx(Stretch, __assign({ scroll: "hidden" }, { children: jsx(Heading, __assign({ size: 3, "data-testid": "flow-chart-scenario-name" }, { children: data.name })) })), data.onDepthChange && (jsxs(Horizontal, __assign({ verticalAlign: "center", spacing: px(5), "data-testid": "flow-chart-scenario-depth", className: "nodrag" }, { children: [jsx(Icon, { icon: faCamera, color: Colours.textLight }), jsx(Box, __assign({ width: px(96) }, { children: jsx(NumberInput, { value: pendingDepth !== null && pendingDepth !== void 0 ? pendingDepth : '', min: MIN_CAMERA_DEPTH_M, max: MAX_CAMERA_DEPTH_M, suffix: "m", onChange: function () { return undefined; }, onBlur: function (e) {
                                                    var _a;
                                                    var raw = e.target.value;
                                                    var v = raw === ''
                                                        ? undefined
                                                        : Math.min(MAX_CAMERA_DEPTH_M, Math.max(MIN_CAMERA_DEPTH_M, Number(raw)));
                                                    setPendingDepth(v);
                                                    (_a = data.onDepthChange) === null || _a === void 0 ? void 0 : _a.call(data, data.id, v);
                                                } }) }))] }))), data.isEmergencyScenario && (jsx(Icon, { color: Colours.red, icon: faExclamationTriangle }))] })), jsxs(Vertical, { children: [jsx(AppetiteFactor, { bar: data.configurations.bar }), data.isSelected && (jsxs(Vertical, __assign({ "data-testid": "feed_statements" }, { children: [jsx(Statement, { type: "positive", statements: data.configurations.statements.positive }), !data.isEmergencyScenario && (jsxs(Fragment, { children: [jsx(Statement, { type: "negative", statements: data.configurations.statements.negative }), jsx(Statement, { type: "emergency", statements: data.configurations.statements.emergency })] }))] }))), data.isSelected && data.onCameraActionChange && (jsxs(Vertical, __assign({ spacing: px(4) }, { children: [jsx(Heading, __assign({ size: 3 }, { children: t('Camera Action') })), jsx(ReadonlyValueBox, { "data-testid": "flow-chart-scenario-camera-action", value: t((_c = (_b = CAMERA_ACTIONS.find(function (a) { var _a; return a.value === ((_a = data.cameraAction) !== null && _a !== void 0 ? _a : DEFAULT_CAMERA_ACTION); })) === null || _b === void 0 ? void 0 : _b.label) !== null && _c !== void 0 ? _c : '') })] })))] })] })) })), jsx(Handle, { type: "target", position: Position.Left, style: __assign(__assign({}, handle), targetHandle) }), jsx(Handle, __assign({ type: "source", position: Position.Right, id: "positive", className: classes(handleClass, style({
                    $nest: {
                        '&.react-flow__handle': {
                            top: data.isSelected ? 170 : data.isEmergencyScenario ? 64 : 40,
                            width: px(14),
                            height: px(14),
                            right: -7.5,
                            background: Colours.blue,
                            $nest: {
                                '&.react-flow__handle .handle-icon': {
                                    display: 'none'
                                },
                                '&.react-flow__handle:hover': {
                                    right: -11.5,
                                    bottom: data.isSelected ? 160 : 80,
                                    width: px(24),
                                    height: px(24),
                                    backgroundColor: Colours.red,
                                    cursor: data.feedPositiveId !== data.id ? 'pointer' : 'crosshair',
                                    $nest: {
                                        '& .handle-icon': {
                                            display: 'flex'
                                        }
                                    }
                                }
                            }
                        }
                    }
                })), onClick: function (e) {
                    var _a;
                    (_a = data.onDisconnect) === null || _a === void 0 ? void 0 : _a.call(data, data.id, 'positive');
                    e.stopPropagation();
                } }, { children: jsx(HandleIcon, {}) })), !data.isEmergencyScenario && (jsx(Handle, __assign({ type: "source", position: Position.Right, id: "negative", className: classes(handleClass, style({
                    $nest: {
                        '&.react-flow__handle': {
                            top: data.isSelected ? 244 : 100,
                            width: px(14),
                            height: px(14),
                            right: -7.5,
                            background: Colours.blue,
                            $nest: {
                                '&.react-flow__handle .handle-icon': {
                                    display: 'none'
                                },
                                '&.react-flow__handle:hover': {
                                    right: -11.5,
                                    bottom: data.isSelected ? 80 : 40,
                                    width: px(24),
                                    height: px(24),
                                    backgroundColor: Colours.red,
                                    cursor: data.feedNegativeId !== data.id
                                        ? 'pointer'
                                        : 'crosshair',
                                    $nest: {
                                        '& .handle-icon': {
                                            display: 'flex'
                                        }
                                    }
                                }
                            }
                        }
                    }
                })), onClick: function (e) {
                    var _a;
                    (_a = data.onDisconnect) === null || _a === void 0 ? void 0 : _a.call(data, data.id, 'negative');
                    e.stopPropagation();
                } }, { children: jsx(HandleIcon, {}) })))] })));
});
var HandleIcon = function () { return (jsx(Box, __assign({ width: px(24), height: px(24), className: classes('handle-icon', style({ pointerEvents: 'none' })), horizontalAlign: "center", verticalAlign: "center" }, { children: jsx(Icon, { icon: faTrash, className: style({ height: px(12) }), color: 'white' }) }))); };
var DEPTH_INPUT_HEIGHT = 36;
var handle = {
    width: px(14),
    height: px(14)
};
var handleClass = style(__assign(__assign({}, handle), { $nest: {
        '&.react-flow__handle:hover': {
            width: px(17),
            height: px(17)
        }
    } }));
var targetHandle = {
    top: 65,
    left: -8,
    background: Colours.lightestBlue
};

var nodeTypes = {
    scenario: ScenarioCard,
    midpoint: Midpoint
};
var edgeTypes = {
    action: ActionEdge
};
var MIN_CAMERA_DEPTH_M = 0;
var MAX_CAMERA_DEPTH_M = 50;
var CAMERA_ACTIONS = [
    { value: 'hold_and_watch', label: 'Hold & watch' },
    { value: 'rotate_to_scan', label: 'Rotate to scan' }
];
// What a scenario means when it carries no camera action. Named rather than
// read off CAMERA_ACTIONS[0], so reordering the list cannot silently change it.
var DEFAULT_CAMERA_ACTION = 'hold_and_watch';
var FlowChart = function (_a) {
    var scenarios = _a.scenarios, hideControls = _a.hideControls, editable = _a.editable, onSelect = _a.onSelect, onConnect = _a.onConnect, onDisconnect = _a.onDisconnect, onDepthChange = _a.onDepthChange, onCameraActionChange = _a.onCameraActionChange, onPauseClicked = _a.onPauseClicked;
    var _b = useState(null), selectedNodeId = _b[0], setSelectedNodeId = _b[1];
    var _c = useNodesState([]), nodes = _c[0], setNodes = _c[1]; _c[2];
    var _d = useEdgesState([]), edges = _d[0], setEdges = _d[1]; _d[2];
    useEffect(function () {
        var x = generateFlowChart(scenarios, selectedNodeId, editable, onDisconnect, onDepthChange, onCameraActionChange);
        setNodes(x.nodes);
        setEdges(x.edges);
    }, [selectedNodeId, scenarios]);
    var handleConnectionChange = function (newConnection) {
        if (newConnection.source && newConnection.target) {
            onConnect === null || onConnect === void 0 ? void 0 : onConnect(newConnection.sourceHandle, newConnection.source, newConnection.target);
        }
    };
    var handleOnSelect = function (event, node) {
        var id = node === null || node === void 0 ? void 0 : node.id;
        console.log({
            node: node
        });
        if (id) {
            setSelectedNodeId(id);
            onSelect === null || onSelect === void 0 ? void 0 : onSelect(id);
        }
    };
    var handleEdgeClick = function (event, edge) {
        var midpointId = [edge.source, edge.target].find(function (id) {
            return id.includes('-');
        });
        var _a = (midpointId || '').split('-'), midpointSource = _a[1], midpointTarget = _a[2], midpointType = _a[3];
        var source = Number(midpointSource !== null && midpointSource !== void 0 ? midpointSource : edge.source);
        var target = Number(midpointTarget !== null && midpointTarget !== void 0 ? midpointTarget : edge.target);
        var type = (midpointType !== null && midpointType !== void 0 ? midpointType : edge.sourceHandle);
        var sourceScenario = scenarios.find(function (s) { return s.id === source; });
        var exitId = type === 'positive'
            ? sourceScenario === null || sourceScenario === void 0 ? void 0 : sourceScenario.feedPositiveId
            : sourceScenario === null || sourceScenario === void 0 ? void 0 : sourceScenario.feedNegativeId;
        var id = scenarios.some(function (s) { return s.isPauseScenario && s.id === exitId; })
            ? exitId
            : undefined;
        onPauseClicked === null || onPauseClicked === void 0 ? void 0 : onPauseClicked(id, source, target, type);
    };
    return (jsx(ReactFlow, __assign({ minZoom: 0.3, nodes: nodes, edges: edges, nodeTypes: nodeTypes, edgeTypes: edgeTypes, nodesDraggable: false, nodesConnectable: editable, onEdgeClick: handleEdgeClick, onNodeClick: handleOnSelect, onConnect: handleConnectionChange, "data-testid": "flow-chart", fitView: true, proOptions: {
            hideAttribution: true
        } }, { children: !hideControls && (jsx(Controls, { showInteractive: false, className: style({
                $nest: {
                    '& .react-flow__controls': {
                        boxShadow: "2px 0px 2px 1px rgb(0 0 0 / 25%)"
                    },
                    '& .react-flow__controls-button': {
                        background: Colours.lightBlue,
                        borderBottom: "2px solid ".concat(Colours.darkBlue)
                    },
                    '& .react-flow__controls-button:last-child': {
                        borderBottom: 'none'
                    },
                    '& .react-flow__controls-button svg': {
                        fill: Colours.textLight
                    },
                    '& .react-flow__panel .react-flow__attribution': {
                        display: 'none'
                    }
                }
            }) })) }), JSON.stringify(scenarios)));
};

var FormContext = createContext({});
var useFormContext = function () {
    return useContext(FormContext);
};
var Form = function (_a) {
    var initialState = _a.initialState, title = _a.title, children = _a.children, onSubmit = _a.onSubmit, onChange = _a.onChange, submitButtonText = _a.submitButtonText, submitButtonIsDisabled = _a.submitButtonIsDisabled, submitButtonIsLoading = _a.submitButtonIsLoading, clearButtonText = _a.clearButtonText, spacing = _a.spacing, stretch = _a.stretch;
    var formIsInitialized = useRef(false);
    var _b = useState(initialState || {}), formState = _b[0], setFormState = _b[1];
    var isValid = useMemo(function () {
        if (formIsInitialized.current) {
            return Object.values(formState).every(function (input) { return input.isValid && !(input.isRequired && input.value == null); });
        }
    }, [formState, formIsInitialized]);
    useEffect(function () {
        var someFieldIsDirty = Object.values(formState).some(function (input) { return input.isDirty; });
        if (someFieldIsDirty) {
            onChange === null || onChange === void 0 ? void 0 : onChange(formState);
        }
    }, [formState]);
    useEffect(function () {
        setFormState(__assign({}, formState));
        formIsInitialized.current = true;
    }, []);
    var clearFormState = function () {
        setFormState({});
    };
    return (jsx(FormContext.Provider, __assign({ value: [
            formState,
            useCallback(function (name, state) {
                if (!formIsInitialized.current) {
                    formState[name] = __assign(__assign({}, formState[name]), state);
                }
                else if (state) {
                    setFormState(function (formState) {
                        var _a;
                        return (__assign(__assign({}, formState), (_a = {}, _a[name] = __assign(__assign({}, formState[name]), state), _a)));
                    });
                }
                else {
                    setFormState(function (formState) {
                        delete formState[name];
                        return __assign({}, formState);
                    });
                }
            }, [formState, setFormState]),
            useCallback(function () { return !!isValid; }, [isValid])
        ] }, { children: jsx("form", __assign({ className: style({
                width: percent(100),
                height: stretch ? percent(100) : 'auto',
                boxSizing: 'border-box'
            }), onSubmit: function (event) {
                var sanitizedObj = JSON.parse(JSON.stringify(formState)); // Removes functions, Symbols, and non-serializable data
                event.preventDefault();
                isValid &&
                    !submitButtonIsDisabled &&
                    (onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(structuredClone(sanitizedObj)));
            } }, { children: jsxs(Vertical, __assign({ spacing: spacing, height: stretch ? percent(100) : 'auto' }, { children: [title && jsx(Stretch, __assign({ className: classNames$5.title }, { children: title })), children, (clearButtonText || submitButtonText) && (jsxs(Fragment, { children: [stretch && jsx(StretchSpacer, {}), jsxs(Horizontal, __assign({ horizontalAlign: "right" }, { children: [clearButtonText && (jsx(Content, __assign({ horizontalAlign: "right", "data-testid": "form-clear-button" }, { children: jsx(Button, { content: clearButtonText, onClick: function () {
                                                clearFormState();
                                            } }) }))), submitButtonText && (jsx(Content, __assign({ horizontalAlign: "right", "data-testid": "form-submit-button" }, { children: jsx(Button, { loading: submitButtonIsLoading, disabled: !isValid || submitButtonIsDisabled, content: submitButtonText, appearance: "blue", type: "submit" }) })))] }))] }))] })) })) })));
};
var classNames$5 = stylesheet({
    title: {
        fontSize: Sizes.fontSize3,
        color: Colours.textLight,
        fontFamily: fontFamily
    }
});

var getValidationErrors = function (validators) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    return (validators !== null && validators !== void 0 ? validators : [])
        .filter(function (validator) { return !validator.isValid.apply(validator, values); })
        .map(function (validator) { return validator.error; });
};

var isNil = function (value) {
    return value === null || value === undefined;
};
var isString = function (value) {
    return typeof value === 'string';
};

var isMandatory = {
    error: 'Field is mandatory',
    isValid: function (value) {
        return isString(value) ? value.length > 0 : !isNil(value);
    }
};

var useInput = function (_a) {
    var _b, _c, _d;
    var name = _a.name, validators = _a.validators, isRequired = _a.isRequired, initialValue = _a.initialValue, cleanStateOnUnmount = _a.cleanStateOnUnmount;
    var t = useTranslation().t;
    var _e = useContext(FormContext), formState = _e[0], setFormState = _e[1];
    var _f = useState(initialValue !== undefined ? initialValue : (_b = formState[name]) === null || _b === void 0 ? void 0 : _b.value), value = _f[0], setValue = _f[1];
    var setIsDirtyToTrueIfItHasChanged = function () {
        var _a;
        if (!((_a = formState[name]) === null || _a === void 0 ? void 0 : _a.isDirty)) {
            setFormState(name, __assign(__assign({}, formState[name]), { isDirty: true }));
        }
    };
    var isDirty = useMemo(function () {
        var _a;
        return (_a = formState[name]) === null || _a === void 0 ? void 0 : _a.isDirty;
    }, [formState]);
    var onBlurHandler = function () {
        setIsDirtyToTrueIfItHasChanged();
    };
    var onChangeHandler = useCallback(function (value) {
        var _a;
        setValue(value);
        if (!formState[name] || value !== ((_a = formState[name]) === null || _a === void 0 ? void 0 : _a.value)) {
            var newFormState = JSON.parse(JSON.stringify(formState)) || {};
            newFormState[name] = __assign(__assign({}, newFormState[name]), { value: value });
            var errors = getValidationErrors(isRequired ? __spreadArray(__spreadArray([], (validators || []), true), [isMandatory], false) : validators, value, newFormState);
            setFormState(name, {
                value: value,
                isDirty: true,
                errors: errors.map(function (e) { return t(e); }),
                isValid: errors.length === 0 && !(isRequired && value === initialValue),
                isRequired: isRequired
            });
        }
    }, [
        value,
        formState,
        initialValue,
        isRequired,
        name,
        setFormState,
        t,
        validators
    ]);
    //clean up
    useEffect(function () {
        return function () {
            if (cleanStateOnUnmount) {
                setFormState(name, undefined);
            }
        };
    }, [cleanStateOnUnmount]);
    useEffect(function () {
        var _a, _b;
        var hasValueChanged = value !== ((_a = formState[name]) === null || _a === void 0 ? void 0 : _a.value);
        var hasRequiredChanged = isRequired !== undefined && isRequired !== ((_b = formState[name]) === null || _b === void 0 ? void 0 : _b.isRequired);
        //initialize the input
        if (!formState[name] || hasValueChanged || hasRequiredChanged) {
            var newFormState = JSON.parse(JSON.stringify(formState)) || {};
            newFormState[name] = __assign(__assign({}, newFormState[name]), { value: value });
            var errors = getValidationErrors(isRequired
                ? __spreadArray(__spreadArray([], ((validators === null || validators === void 0 ? void 0 : validators.filter(function (validator) { return validator.error !== isMandatory.error; })) || []), true), [
                    isMandatory
                ], false) : validators, value, newFormState);
            setFormState(name, {
                value: value,
                isDirty: value !== initialValue,
                errors: errors.map(function (e) { return t(e); }),
                isValid: errors.length === 0,
                isRequired: !!isRequired
            });
        }
    }, [
        value,
        formState,
        initialValue,
        isRequired,
        name,
        setFormState,
        t,
        validators
    ]);
    return {
        value: value,
        errors: (_d = (_c = formState[name]) === null || _c === void 0 ? void 0 : _c.errors) !== null && _d !== void 0 ? _d : [],
        isDirty: isDirty,
        isRequired: isRequired,
        onBlurHandler: onBlurHandler,
        onChangeHandler: onChangeHandler
    };
};

var FormCheckboxInput = function (props) {
    var _a = useInput(__assign({}, props)), value = _a.value, onChangeHandler = _a.onChangeHandler;
    return (jsx(CheckboxInput, __assign({}, props, { value: !!value, onChange: function (v) {
            onChangeHandler(v);
        } })));
};

var DatePicker = function (_a) {
    var name = _a.name, label = _a.label, errors = _a.errors, labelPosition = _a.labelPosition, required = _a.required, value = _a.value, showClearDate = _a.showClearDate, minDate = _a.minDate, maxDate = _a.maxDate, format = _a.format, onChange = _a.onChange;
    var _b = useState(false), focused = _b[0], setFocused = _b[1];
    var showClear = useMemo(function () { return !!value && showClearDate; }, [value]);
    var onDateChange = function (date) {
        onChange(date);
    };
    return (jsx(InputLayout, __assign({ label: label, errors: errors, required: required, labelPosition: labelPosition }, { children: jsx("div", __assign({ className: drpWrapper$1 }, { children: jsx(SingleDatePicker, { displayFormat: format, id: "".concat(name, "-datepicker"), date: value !== null && value !== void 0 ? value : null, focused: focused, noBorder: true, numberOfMonths: 1, isOutsideRange: function (day) {
                    return (!!(minDate && moment(day).isSameOrBefore(minDate)) ||
                        !!(maxDate && moment(day).isSameOrAfter(maxDate)));
                }, showClearDate: showClear, onDateChange: onDateChange, onFocusChange: function () { return setFocused(!focused); }, hideKeyboardShortcutsPanel: true, enableOutsideDays: true }) })) })));
};
var drpWrapper$1 = style({
    display: 'flex',
    flex: 1,
    $nest: {
        '& .SingleDatePicker': {
            width: percent(100),
            boxSizing: 'border-box',
            $nest: {
                '& > div': {
                    width: percent(100),
                    boxSizing: 'border-box'
                }
            }
        },
        '& .SingleDatePickerInput': {
            background: Colours.darkBlue,
            borderRadius: Sizes.borderRadius,
            border: "1px solid ".concat(Colours.blue),
            padding: "0 ".concat(rem(0.5)),
            boxSizing: 'border-box',
            width: percent(100)
        },
        '& *': {
            fontFamily: fontFamily
        },
        '& .DayPicker': {
            boxShadow: boxShadow
        },
        '& .SingleDatePicker_picker': {
            zIndex: 1000
        },
        '& .SingleDatePicker_picker, & .CalendarMonth, & .CalendarMonthGrid, & .DayPicker__horizontal': {
            background: Colours.darkBlue
        },
        '& .DateInput_fangStroke': {
            stroke: Colours.darkBlue,
            fill: Colours.darkBlue
        },
        '& .DayPickerNavigation_button': {
            backgroundColor: Colours.blue,
            border: "1px solid ".concat(Colours.textLight)
        },
        '& .DayPickerNavigation_svg__horizontal': {
            fill: Colours.textLight
        },
        '& .DayPicker_weekHeader': {
            color: Colours.textLight
        },
        '& .DayPicker_weekHeader_li': {
            fill: Colours.textLight
        },
        '& .CalendarMonth_caption': {
            color: Colours.textLight
        },
        '& .SingleDatePickerInput_arrow': {
            margin: margin(0, rem(0.5))
        },
        '& .DateInput': {
            background: Colours.darkBlue,
            width: percent(100)
        },
        '& .DateInput_input': {
            color: Colours.textLight,
            padding: px(5),
            borderBottom: 0,
            fontSize: px(16),
            background: Colours.darkBlue,
            boxSizing: 'border-box'
        },
        '& .DateInput_input__focused::after': {
            position: 'absolute',
            content: "''",
            width: percent(100),
            height: px(2),
            background: Colours.primary
            // borderBottom: `${px(2)} solid ${Colours.primary}`
        },
        '& .SingleDatePickerInput__showClearDates': {
            paddingRight: 0
        },
        '& .DayPickerNavigation_button__disabled': {
            border: 0,
            display: 'none'
        },
        '& .SingleDatePickerInput_arrow_svg': {
            fill: Colours.textLight,
            height: px(20),
            width: px(20)
        },
        '& .SingleDatePickerInput_clearDates_default:focus, & .SingleDatePickerInput_clearDates_default:hover': {
            background: 'none',
            $nest: {
                '& .SingleDatePickerInput_clearDates_svg': {
                    fill: Colours.blue
                }
            }
        },
        '& .SingleDatePickerInput_clearDates': {
            position: 'relative',
            right: 'auto',
            top: 'auto',
            transform: 'none',
            margin: 0
        },
        '& .SingleDatePickerInput_clearDates_svg': {
            fill: Colours.textLight
        },
        '& .CalendarDay__default': {
            background: Colours.blue,
            color: Colours.textLight,
            border: "1px solid ".concat(Colours.lightBlue)
        },
        '& .CalendarDay__default:hover': {
            background: Colours.lighterBlue,
            color: 'white'
        },
        '& .CalendarDay__blocked_out_of_range, & .CalendarDay__blocked_out_of_range:hover': {
            backgroundColor: Colours.darkerBlue
        },
        '& .CalendarDay__blocked_out_of_range, & .CalendarDay__blocked_out_of_range:active, & .CalendarDay__blocked_out_of_range:hover': {
            color: Colours.textDark,
            border: "1px solid ".concat(Colours.darkBlue)
        },
        '& .CalendarDay__selected_span': {
            background: Colours.lightestBlue,
            color: 'white',
            border: "1px solid ".concat(Colours.lighterBlue)
        },
        '& .CalendarDay__selected_span:hover': {
            background: Colours.primary
        },
        '& .CalendarDay__selected': {
            background: Colours.primary,
            color: 'white',
            border: "1px solid ".concat(Colours.lightestBlue)
        },
        '& .CalendarDay__selected:hover': {
            border: "1px solid ".concat(Colours.lightBlue),
            background: Colours.lightBlue,
            color: 'white'
        },
        '& .CalendarDay__hovered_span:hover, & .CalendarDay__hovered_span': {
            background: Colours.blue,
            color: 'white',
            border: "1px solid ".concat(Colours.blue)
        },
        '& .CalendarDay__hovered_span:hover': {
            background: Colours.lightestBlue
        }
    }
});

var FormDatePickerInput = function (props) {
    var _a = useInput(__assign({}, props)), value = _a.value, errors = _a.errors, isDirty = _a.isDirty, onChangeHandler = _a.onChangeHandler, onBlurHandler = _a.onBlurHandler;
    return (jsx(DatePicker, { name: props.name, value: value, label: props.label, maxDate: props.maxDate, minDate: props.minDate, disabled: props.disabled, errors: isDirty ? errors : [], onBlur: onBlurHandler, onChange: onChangeHandler, readonly: props.readonly, showClearDate: props.showClearDate }));
};

var FormNumberInput = function (props) {
    var input = useInput(__assign(__assign({}, props), { validators: __spreadArray(__spreadArray([], (props.validators || []), true), [
            {
                error: 'Not a valid number',
                isValid: function (newValue, formState) {
                    return !Number.isNaN(Number(newValue)) || Number.isInteger(newValue);
                }
            }
        ], false) }));
    return (jsx(NumberInput, { onChange: function (value) {
            return input.onChangeHandler(value === undefined ? null : value);
        }, value: input.value, disabled: props.disabled, errors: input.isDirty ? input.errors : [], hideControls: props.hideControls, label: props.label, max: props.max, min: props.min, onBlur: input.onBlurHandler, placeholder: props.placeholder, suffix: props.suffix, required: props.isRequired, id: props.name, hideErrors: props.hideErrors, transparent: props.transparent, readonly: props.readonly, labelSize: props.labelSize, "data-testid": "form-number-input", allowDecimals: props.allowDecimals }));
};

var FormNumberRangeInput = function (props) {
    var _a, _b;
    var input = useInput(__assign({}, props));
    return (jsxs(Vertical, __assign({ spacing: 0 }, { children: [jsxs(Horizontal, __assign({ verticalAlign: "center", "data-testid": "form-number-range" }, { children: [jsx(NumberInput, { required: props.isRequired, label: props.label, disabled: props.isDisabled, min: props.min, max: props.max, value: (_a = input.value) === null || _a === void 0 ? void 0 : _a[0], onBlur: input.onBlurHandler, onChange: function (value) { var _a; return input.onChangeHandler([Number(value), (_a = input.value) === null || _a === void 0 ? void 0 : _a[1]]); }, placeholder: props.placeholder, "data-testid": "form-number-range-from" }), jsx(Content, __assign({ className: style({
                            fontFamily: fontFamily,
                            color: Colours.textLight
                        }) }, { children: "to" })), jsx(NumberInput, { required: props.isRequired, label: props.label ? ' ' : undefined, disabled: props.isDisabled, min: props.min, max: props.max, value: (_b = input.value) === null || _b === void 0 ? void 0 : _b[1], onBlur: input.onBlurHandler, onChange: function (value) { var _a; return input.onChangeHandler([(_a = input.value) === null || _a === void 0 ? void 0 : _a[0], Number(value)]); }, placeholder: props.placeholder, "data-testid": "form-number-range-to" })] })), jsx(InputErrors, __assign({}, input))] })));
};

var FormSelectInput = function (props) {
    var input = useInput(__assign({}, props));
    return (jsx(SelectInput, __assign({}, props, { transparent: props.transparent, readonly: props.isReadonly, required: props.isRequired, disabled: props.isDisabled, label: props.label, options: props.options, isMultiple: props.isMultiple, onChange: function (value) {
            input.onChangeHandler(Array.isArray(value) ? value.map(function (v) { return v.value; }) : [value.value]);
        }, value: input.value, errors: input.errors, onBlur: function () { return input.onBlurHandler(); }, labelSize: props.labelSize, "data-testid": "form-select" })));
};

var FormSwitchInput = function (props) {
    var _a = useInput(__assign({}, props)), value = _a.value, onChangeHandler = _a.onChangeHandler;
    return (jsx(SwitchInput, __assign({}, props, { labelPosition: props.labelPosition, label: props.label, size: props.size, value: !!value, onChange: onChangeHandler })));
};

var FormTextAreaInput = function (props) {
    var input = useInput(__assign({}, props));
    return (jsx(TextAreaInput, { label: props.label, value: input.value, name: props.name, onChange: function (value) { return input.onChangeHandler(value); }, disabled: props.disabled, placeholder: props.placeholder, onBlur: input.onBlurHandler, errors: input.isDirty ? input.errors : [], id: props.name, required: props.isRequired, rows: props.rows, maxLength: props.maxLength, counter: props.counter, "data-testid": "form-text-area" }));
};

var FormTextInput = function (props) {
    var input = useInput(__assign({}, props));
    return (jsx(TextInput, { label: props.label, value: input.value, name: props.name, onChange: function (value) { return input.onChangeHandler(value); }, disabled: props.disabled, placeholder: props.placeholder, onBlur: input.onBlurHandler, password: props.password, errors: input.isDirty ? input.errors : [], id: props.name, required: input.isRequired, suffix: props.suffix, "data-testid": "form-text", readonly: props.readonly, hideErrors: props.hideErrors }));
};

var FormTimeDropDown = function (props) {
    var input = useInput(__assign({}, props));
    return (jsx(TimeDropDown, { onChange: function (value) {
            return input.onChangeHandler(value === undefined ? null : value);
        }, seconds: input.value || 0 }));
};

var FormTimeInput = function (props) {
    var _a = useInput(__assign({}, props)), value = _a.value, errors = _a.errors, isDirty = _a.isDirty, onChangeHandler = _a.onChangeHandler, onBlurHandler = _a.onBlurHandler;
    return (jsx(TimeInput, { name: props.name, value: value, label: props.label, disabled: props.disabled, errors: isDirty ? errors : [], onBlur: onBlurHandler, onChange: onChangeHandler }));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1 = ".radio {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    font-family: Arial, sans-serif;\n    font-size: 16px;\n    height: 30px;\n}\n\n.radio input {\n    display: none;\n}\n\n.radio span {\n    display: flex;\n    align-items: center;\n    padding-left: 30px;\n    position: relative;\n    user-select: none;\n}\n\n.radio span::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    width: 20px;\n    height: 20px;\n    border: 2px solid #fff;\n    border-radius: 50%;\n    transition: all 0.3s ease;\n}\n\n.radio input:checked+span::before {\n    border-color: #02ADC3;\n}\n\n.radio span::after {\n    content: '';\n    position: absolute;\n    padding: 4px;\n    left: 6px;\n    background: #02ADC3;\n    border: 2px solid #02ADC3;\n    border-radius: 50%;\n    transform: scale(0);\n    transition: transform 0.3s ease;\n}\n\n.radio input:checked+span::after {\n    transform: scale(1);\n}";
styleInject(css_248z$1);

var RadioInputMonitor = /** @class */ (function () {
    function RadioInputMonitor() {
    }
    RadioInputMonitor.monitor = function (input, onChange) {
        var _a;
        var groupName = input.name;
        if (!RadioInputMonitor.callbacks.has(groupName)) {
            RadioInputMonitor.callbacks.set(groupName, []);
        }
        var callbacks = RadioInputMonitor.callbacks.get(groupName);
        if (!callbacks.find(function (item) { return item.input.id === input.id; })) {
            (_a = RadioInputMonitor.callbacks.get(groupName)) === null || _a === void 0 ? void 0 : _a.push({ input: input, onChange: onChange });
            input.addEventListener('change', function (e) {
                RadioInputMonitor.callbacks.get(groupName).forEach(function (item) {
                    item.onChange(item.input.checked);
                });
            });
        }
    };
    RadioInputMonitor.select = function (input) {
        var _a;
        var groupName = input.name;
        input.checked = true;
        (_a = RadioInputMonitor.callbacks.get(groupName)) === null || _a === void 0 ? void 0 : _a.forEach(function (item) {
            item.onChange(item.input.checked);
        });
    };
    RadioInputMonitor.callbacks = new Map();
    return RadioInputMonitor;
}());

var RadioInput = function (_a) {
    var name = _a.name, label = _a.label, groupName = _a.groupName, value = _a.value, onChange = _a.onChange, _b = _a.readOnly, readOnly = _b === void 0 ? false : _b;
    var ref = useRef(null);
    useEffect(function () {
        if (ref.current) {
            RadioInputMonitor.monitor(ref.current, function (isSelected) {
                if (onChange) {
                    onChange(isSelected);
                }
            });
        }
    }, [ref]);
    useEffect(function () {
        if (value && ref.current) {
            RadioInputMonitor.select(ref.current);
        }
    }, [value]);
    return (jsxs("label", __assign({ className: "radio", style: {
            userSelect: readOnly ? 'none' : 'auto'
        } }, { children: [jsx("input", { type: "radio", id: name, name: groupName, ref: ref }), jsx("span", { children: label })] })));
};

var FormRadioInput = function (props) {
    var _a = useInput(__assign({}, props)), onChangeHandler = _a.onChangeHandler, value = _a.value;
    console.log('InputRadio stored value for ' + props.name + ': ' + value);
    //console.log("InputRadio stored value for " + props.name + ": " + props.value);
    var initValue = value !== undefined ? value : props.value;
    return (jsx(RadioInput, __assign({}, props, { label: props.label, onChange: function (value) {
            if (props.onChange) {
                props.onChange(value);
            }
            onChangeHandler(value);
        }, value: initValue !== null && initValue !== void 0 ? initValue : false })));
};

var isBetweenValidator = function (first, second, inclusive) {
    return {
        error: "Value must be between ".concat(first, " and ").concat(second).concat(inclusive && ' inclusive', "."),
        isValid: function (value) {
            return inclusive
                ? value >= first && value <= second
                : value > first && value < second;
        }
    };
};

var emailRegExp = new RegExp(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/);
var isEmail = {
    error: 'It has to be a valid email.',
    isValid: function (value) {
        return emailRegExp.test(value);
    }
};

var isGreaterThanValidator = function (number) {
    return {
        error: "Value must be greater than ".concat(number, "."),
        isValid: function (value) {
            return value > number;
        }
    };
};

var lengthIsGreaterThanValidator = function (length) {
    return {
        error: "Value must have a length greater than ".concat(length, " characters."),
        isValid: function (value) {
            return (value === null || value === void 0 ? void 0 : value.length) > length;
        }
    };
};

var passwordsMustBeTheSameValidator = {
    error: 'Passwords must be the same',
    isValid: function (_, _a) {
        var password = _a.password, repetition = _a.repetition;
        return (password === null || password === void 0 ? void 0 : password.value) === (repetition === null || repetition === void 0 ? void 0 : repetition.value);
    }
};

var NewPasswordLogin = function (_a) {
    var onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var onSubmitHandler = function (_a) {
        var password = _a.password;
        onSubmit(password.value);
    };
    return (jsx(Vertical, __assign({ width: 300, spacing: 15, "data-testid": "login-new-password" }, { children: jsxs(Form, __assign({ title: t('Change password'), onSubmit: onSubmitHandler, submitButtonText: t('Change') }, { children: [jsx(Stretch, __assign({ className: classNames$4.info }, { children: t('You need to set a new password. Save it properly as this is the one you will be using to login.') })), jsx(FormTextInput, { password: true, label: t('Password'), name: "password", validators: [isMandatory, lengthIsGreaterThanValidator(10)] }), jsx(FormTextInput, { password: true, label: t('Repeat password'), name: "repetition", validators: [passwordsMustBeTheSameValidator] })] })) })));
};
var classNames$4 = stylesheet({
    info: {
        maxWidth: Sizes.input,
        background: Colours.darkBlue,
        borderRadius: Sizes.borderRadius,
        padding: '0.65rem',
        textAlign: 'center',
        color: Colours.textLight,
        border: "1px solid ".concat(Colours.blue),
        fontSize: '15px',
        lineHeight: '1.35rem',
        fontFamily: fontFamily
    }
});

var OTPLogin = function (_a) {
    var onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var onSubmitHandler = function (_a) {
        var code = _a.code;
        onSubmit(code.value);
    };
    return (jsx(Vertical, __assign({ width: 300, spacing: 15, "data-testid": "login-otp" }, { children: jsx(Form, __assign({ title: t('OTP verification'), onSubmit: onSubmitHandler, submitButtonText: t('Login') }, { children: jsx(FormTextInput, { label: t('OTP code'), name: "code", validators: [isMandatory] }) })) })));
};

var COGNITO_SESSION_DURATION_IN_MS = 180000;
var SECOND_IN_MS = 1000;
var OTPSetUpLogin = function (_a) {
    var secret = _a.secret, onSubmit = _a.onSubmit, onCopy = _a.onCopy;
    var t = useTranslation().t;
    var _b = useState(COGNITO_SESSION_DURATION_IN_MS), timeToExpire = _b[0], setTimeToExpire = _b[1];
    useEffect(function () {
        if (timeToExpire > 0) {
            setTimeout(function () {
                setTimeToExpire(timeToExpire - SECOND_IN_MS);
            }, 1000);
        }
    }, [timeToExpire]);
    var onSubmitHandler = function (_a) {
        var otp = _a.otp;
        onSubmit(otp.value);
    };
    var onClickHandler = function () {
        copy(secret);
        onCopy === null || onCopy === void 0 ? void 0 : onCopy();
    };
    return (jsx(Vertical, __assign({ width: 300, spacing: 15, "data-testid": "login-otp-setup" }, { children: jsxs(Form, __assign({ title: t('OTP client verification'), onSubmit: onSubmitHandler, submitButtonText: t('Verify') }, { children: [jsxs(Vertical, __assign({ className: classNames$3.info }, { children: [jsx(Content, { children: t('Now we need to verify your OTP client. You can use whichever you want (for example, Google Authenticator). Make sure you will always have access to it as you will need an OTP code everytime you log in.') }), jsx(Button, { onClick: onClickHandler, appearance: "hollow", content: t('Copy to clipboard'), fullWidth: true })] })), jsx(Content, __assign({ className: classNames$3.expiration }, { children: timeToExpire <= 0
                        ? t('Expired')
                        : t('Expires in', { time: moment(timeToExpire).format('mm:ss') }) })), jsx(FormTextInput, { label: t('One-time password (OTP)'), name: "otp", validators: [isMandatory] })] })) })));
};
var classNames$3 = stylesheet({
    info: {
        background: Colours.darkBlue,
        borderRadius: Sizes.borderRadius,
        padding: '0.65rem',
        textAlign: 'center',
        color: Colours.textLight,
        border: "1px solid ".concat(Colours.blue),
        fontSize: '15px',
        lineHeight: '1.35rem',
        fontFamily: fontFamily
    },
    expiration: {
        fontFamily: fontFamily,
        color: Colours.textLight
    }
});

var UsernamePasswordLogin = function (_a) {
    var onSubmit = _a.onSubmit, onForgotPassword = _a.onForgotPassword;
    var t = useTranslation().t;
    var onSubmitHandler = function (_a) {
        var username = _a.username, password = _a.password;
        onSubmit(username.value, password.value);
    };
    return (jsx(Vertical, __assign({ width: 300, spacing: 15, className: style({ fontFamily: fontFamily }), "data-testid": "login-username-password" }, { children: jsxs(Form, __assign({ title: t('Login'), onSubmit: onSubmitHandler, submitButtonText: t('Login') }, { children: [jsx(FormTextInput, { label: t('Username'), name: "username", validators: [isMandatory] }), jsx(FormTextInput, { name: "password", password: true, label: jsxs(Horizontal, { children: [jsx(Content, { children: t('Password') }), onForgotPassword && (jsxs(Fragment, { children: [jsx(StretchSpacer, {}), jsx(Content, __assign({ horizontalAlign: "right", className: classNames$2.passwordLabel, onClick: function () { return onForgotPassword === null || onForgotPassword === void 0 ? void 0 : onForgotPassword(); } }, { children: t('Forgot password?') }))] }))] }), validators: [isMandatory] })] })) })));
};
var classNames$2 = stylesheet({
    passwordLabel: {
        color: Colours.textDark,
        cursor: 'pointer',
        fontSize: Sizes.fontSize1,
        $nest: {
            '&:hover': {
                color: Colours.textLight
            }
        }
    }
});

var ForgotPasswordLogin = function (_a) {
    var onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var onSubmitHandler = function (_a) {
        var username = _a.username;
        onSubmit(username.value);
    };
    return (jsx(Vertical, __assign({ width: 300, spacing: 15, className: style({ fontFamily: fontFamily }), "data-testid": "login-forgot-password" }, { children: jsx(Form, __assign({ title: t('Forgot password'), onSubmit: onSubmitHandler, submitButtonText: t('Confirm') }, { children: jsx(FormTextInput, { label: t('Username'), name: "username", validators: [isMandatory] }) })) })));
};

var NewPasswordWithCodeLogin = function (_a) {
    var onSubmit = _a.onSubmit;
    var t = useTranslation().t;
    var onSubmitHandler = function (_a) {
        var password = _a.password, verificationCode = _a.verificationCode;
        onSubmit(password.value, verificationCode.value);
    };
    return (jsx(Vertical, __assign({ width: 300, spacing: 15, "data-testid": "login-new-password-with-code" }, { children: jsxs(Form, __assign({ title: t('New password'), onSubmit: onSubmitHandler, submitButtonText: t('Change') }, { children: [jsx(FormTextInput, { password: true, label: t('Verification code'), name: "verificationCode", validators: [isMandatory] }), jsx(FormTextInput, { password: true, label: t('Password'), name: "password", validators: [isMandatory, lengthIsGreaterThanValidator(10)] }), jsx(FormTextInput, { password: true, label: t('Repeat password'), name: "repetition", validators: [passwordsMustBeTheSameValidator] })] })) })));
};

var MenuList = function (_a) {
    var groups = _a.groups, direction = _a.direction;
    var ref = useRef(null);
    var _b = useState(false), openAbove = _b[0], setOpenAbove = _b[1];
    useLayoutEffect(function () {
        var _a;
        var bounds = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        setOpenAbove(bounds
            ? bounds.y + bounds.height >=
                (window.innerHeight || document.documentElement.clientHeight)
            : false);
    }, [setOpenAbove, ref]);
    return (jsx(MenuList$1, { children: jsx("div", __assign({ ref: ref, "data-testid": CONTEXT_MENU_LIST_TEST_ID, className: classes(menuList, style({
                position: 'absolute',
                bottom: openAbove ? 0 : 'auto',
                right: direction === 'left' ? 0 : 'auto',
                left: direction === 'right' ? 0 : 'auto'
            })) }, { children: jsx(SubMenu, { groups: groups }) })) }));
};

var MODAL_BACKGROUND_TESTID = 'modal-background';
var Modal = function (_a) {
    var title = _a.title, onHide = _a.onHide, children = _a.children, topOffset = _a.topOffset, _b = _a.fixed, fixed = _b === void 0 ? true : _b, width = _a.width, maxWidth = _a.maxWidth, height = _a.height, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight, zIndex = _a.zIndex;
    var _c = React__default.useState(true), visible = _c[0], setVisible = _c[1];
    var onClickHandler = function () {
        setVisible(false);
        setTimeout(onHide, animationDurationInSeg * 1000);
    };
    return (jsxs(Content, __assign({ className: classes(style({
            position: fixed ? 'fixed' : 'absolute',
            top: 0,
            right: 0,
            zIndex: zIndex || 1000,
            height: percent(100),
            width: percent(100)
        }), visible ? classNames$1.fadeIn : classNames$1.fadeOut), verticalAlign: "center", horizontalAlign: "center", "data-testid": "modal-container" }, { children: [jsx("div", { onClick: onClickHandler, className: classNames$1.background, "data-testid": MODAL_BACKGROUND_TESTID }), jsxs(Content, __assign({ className: classes(classNames$1.content, style({
                    overflow: 'hidden',
                    top: topOffset !== undefined ? topOffset : '30%',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: width !== undefined ? width : 'auto',
                    height: height !== undefined ? height : 'auto',
                    minWidth: minWidth !== undefined ? minWidth : 400,
                    minHeight: minHeight !== undefined ? minHeight : 'none',
                    maxWidth: maxWidth !== undefined ? maxWidth : 'none',
                    maxHeight: maxHeight !== undefined ? maxHeight : 'none'
                })), "data-testid": "modal-content" }, { children: [title && (jsxs(Vertical, __assign({ style: { flex: 1 }, padding: 25, spacing: 25, width: percent(100), height: percent(100), className: style({
                            boxSizing: 'border-box',
                            overflow: 'hidden'
                        }) }, { children: [jsx(Horizontal, __assign({ className: classNames$1.title, "data-testid": "modal-title" }, { children: title })), children] }))), !title && children] }))] })));
};
var animationDurationInSeg = 0.5;
var classNames$1 = stylesheet({
    modal: {
        position: 'fixed',
        top: 0,
        right: 0,
        width: viewWidth(100),
        height: viewHeight(100),
        zIndex: 1000
    },
    background: {
        height: '100%',
        width: '100%',
        background: 'black',
        opacity: 0.4
    },
    content: {
        position: 'absolute',
        background: Colours.darkBlue,
        borderRadius: Sizes.borderRadius
    },
    title: {
        fontSize: Sizes.fontSize3,
        color: Colours.textLight,
        fontFamily: fontFamily
    },
    fadeIn: {
        animationName: keyframes({
            from: {
                opacity: 0
            },
            to: {
                opacity: 1
            }
        }),
        animationDuration: "".concat(animationDurationInSeg, "s")
    },
    fadeOut: {
        opacity: 1,
        animationName: keyframes({
            to: {
                opacity: 0
            }
        }),
        animationDuration: "".concat(animationDurationInSeg, "s"),
        animationFillMode: 'forwards'
    }
});

var ConfirmationModal = function (_a) {
    var description = _a.description, title = _a.title, actionButtonContent = _a.actionButtonContent, actionDisabled = _a.actionDisabled, _b = _a.buttonAppearance, buttonAppearance = _b === void 0 ? 'blue' : _b, onCancel = _a.onCancel, onConfirm = _a.onConfirm, confirmTestId = _a.confirmTestId, cancelTestId = _a.cancelTestId;
    var t = useTranslation().t;
    return (jsx(Modal, __assign({ onHide: onCancel }, { children: jsxs(Vertical, __assign({ padding: 25, spacing: 25, width: 500, "data-testid": "confirmation-modal-content" }, { children: [jsx(Stretch, __assign({ className: classNames.title, "data-testid": "confirmation-modal-title" }, { children: title })), jsx(Content, __assign({ className: classNames.description, "data-testid": "confirmation-modal-description" }, { children: description })), jsxs(Horizontal, __assign({ "data-testid": "confirmation-modal-buttons" }, { children: [jsx(Button, { appearance: "hollow", onClick: onCancel, content: t('Cancel'), "data-testid": cancelTestId }), jsx(StretchSpacer, {}), jsx(Button, { disabled: actionDisabled, appearance: buttonAppearance, onClick: onConfirm, content: actionButtonContent, "data-testid": confirmTestId })] }))] })) })));
};
var classNames = stylesheet({
    modal: {
        width: 500
    },
    title: {
        fontSize: Sizes.fontSize3,
        color: Colours.textLight,
        fontFamily: fontFamily
    },
    description: {
        color: Colours.textLight,
        lineHeight: Sizes.lineHeight,
        fontFamily: fontFamily
    }
});

var TimelineChart = function (_a) {
    var data = _a.data, _b = _a.scenarioChanges, scenarioChanges = _b === void 0 ? [] : _b, _c = _a.events, events = _c === void 0 ? [] : _c, range = _a.range, hideEvents = _a.hideEvents, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? Colours.darkestBlue : _d, withAxis = _a.withAxis, onScenarioClick = _a.onScenarioClick, onEventClick = _a.onEventClick, onZoom = _a.onZoom, onDataClick = _a.onDataClick;
    var scenarioChangesDataset = scenarioChangesToDataset(scenarioChanges);
    var eventsDataset = eventsToDataset(events);
    var labelHeight = rem(2);
    var chartHeight = 5;
    var eventsHeight = 3;
    return (jsxs(Vertical, __assign({ className: style({ backgroundColor: backgroundColor }), spacing: 0, height: percent(100), width: percent(100), "data-testid": "timeline-chart" }, { children: [jsx(Box, __assign({ sizing: chartHeight, width: percent(100) }, { children: jsx(Graph, { datasets: __spreadArray([], data, true), hideLabels: true, hideAxis: true, options: {
                        start: range === null || range === void 0 ? void 0 : range.start,
                        end: range === null || range === void 0 ? void 0 : range.end
                    }, onZoom: onZoom, onDataClick: onDataClick }) })), !hideEvents && (jsx(Box, __assign({ sizing: eventsHeight, width: percent(100) }, { children: jsx(Graph, { options: {
                        start: range === null || range === void 0 ? void 0 : range.start,
                        end: range === null || range === void 0 ? void 0 : range.end
                    }, datasets: eventsDataset, tags: scenarioChangesDataset, hideLabels: true, hideAxis: true, hideTooltip: true, onZoom: onZoom, onDataClick: function (_a) {
                        var data = _a.data;
                        return onEventClick === null || onEventClick === void 0 ? void 0 : onEventClick(events === null || events === void 0 ? void 0 : events.find(function (e) { return e.id === data.meta.id; }));
                    }, onTagClick: function (tag) {
                        return onScenarioClick === null || onScenarioClick === void 0 ? void 0 : onScenarioClick(scenarioChanges === null || scenarioChanges === void 0 ? void 0 : scenarioChanges.find(function (c) { return c.id === tag.id; }));
                    } }) }))), withAxis && (jsx(Box, __assign({ height: labelHeight, width: percent(100) }, { children: jsx(Graph, { hideAxis: { y: true }, hideLabels: true, hideData: true, hideLines: true, datasets: __spreadArray([], data, true), options: {
                        start: range === null || range === void 0 ? void 0 : range.start,
                        end: range === null || range === void 0 ? void 0 : range.end
                    }, hideTooltip: true }) })))] })));
};
var eventsToDataset = function (events) {
    var eventsGroupedByColor = events.reduce(function (acc, event) {
        var _a;
        var color = event.color || Colours.red;
        return __assign(__assign({}, acc), (_a = {}, _a[color] = __spreadArray(__spreadArray([], (acc[color] || []), true), [event], false), _a));
    }, {});
    return Object.keys(eventsGroupedByColor).map(function (c) {
        return {
            label: 'Events',
            type: 'bar',
            color: c,
            key: 'events-' + c,
            yAxisId: 'data',
            data: eventsGroupedByColor[c].map(function (event) { return ({
                timestamp: event.timestamp,
                value: 100,
                meta: event
            }); })
        };
    });
};
var scenarioChangesToDataset = function (scenarioChanges) {
    return scenarioChanges.map(function (change) { return ({
        id: change.id,
        fill: change.fill || Colours.primary,
        from: change.start,
        to: change.end,
        label: change.name,
        color: change.color || 'black'
    }); });
};

var DateRangePicker = function (_a) {
    var startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, showClearDates = _a.showClearDates, withConfirmButton = _a.withConfirmButton, confirmButtonText = _a.confirmButtonText, onChange = _a.onChange;
    var t = useTranslation().t;
    var _b = useState(null), focusedInput = _b[0], setFocusedInput = _b[1];
    var _c = useState(startDate), start = _c[0], setStart = _c[1];
    var _d = useState(endDate), end = _d[0], setEnd = _d[1];
    var showClear = useMemo(function () { return !!(startDate || endDate) && showClearDates; }, [startDate, endDate]);
    var onDatesChange = function (_a) {
        var startDate = _a.startDate, endDate = _a.endDate;
        if (focusedInput === 'startDate') {
            setFocusedInput('endDate');
            setStart(startDate);
            setEnd(null);
        }
        else {
            setEnd(endDate);
            setFocusedInput('startDate');
        }
        !withConfirmButton && onChange({ startDate: startDate, endDate: endDate });
    };
    var handleOutsideRange = function (day) {
        return (!!(minDate && day.isBefore(minDate)) ||
            !!(maxDate && day.isAfter(maxDate)));
    };
    return (jsx(Content, __assign({ className: drpWrapper, "data-testid": "date-range-picker" }, { children: jsx(DateRangePicker$1, { horizontalMargin: 32, isOutsideRange: handleOutsideRange, displayFormat: "DD-MM-YYYY", focusedInput: focusedInput, onFocusChange: setFocusedInput, endDateId: "endDate", startDateId: "startDate", startDate: start, endDate: end, onDatesChange: onDatesChange, hideKeyboardShortcutsPanel: true, showClearDates: showClear, reopenPickerOnClearDates: false, maxDate: maxDate, minDate: minDate, minimumNights: 0, transitionDuration: 0, keepOpenOnDateSelect: withConfirmButton, onClose: function () {
                setFocusedInput(null);
                setStart(startDate);
                setEnd(endDate);
            }, renderCalendarInfo: withConfirmButton
                ? function () {
                    return (jsx(Stretch, __assign({ horizontalAlign: "right", padding: [0, rem(1), rem(1), rem(1)] }, { children: jsx(Button, { appearance: "blue", content: confirmButtonText || t('Select'), size: "small", disabled: !start || !end, onClick: function () {
                                onChange({
                                    startDate: start,
                                    endDate: end
                                });
                                setFocusedInput(null);
                            } }) })));
                }
                : undefined }) })));
};
var drpWrapper = style({
    $nest: {
        '& *': {
            fontFamily: fontFamily
        },
        '& .DayPicker': {
            boxShadow: boxShadow
        },
        '& .DateRangePickerInput__withBorder': {
            background: Colours.darkBlue,
            borderRadius: Sizes.borderRadius,
            border: "1px solid ".concat(Colours.blue),
            padding: "0 ".concat(rem(0.5))
        },
        '& .DateRangePicker_picker': {
            zIndex: 1000
        },
        '& .DateRangePicker_picker, & .CalendarMonth, & .CalendarMonthGrid, & .DayPicker__horizontal': {
            background: Colours.darkBlue
        },
        '& .DateInput_fangStroke': {
            stroke: Colours.darkBlue,
            fill: Colours.darkBlue
        },
        '& .DayPickerNavigation_button': {
            backgroundColor: Colours.blue,
            border: "1px solid ".concat(Colours.textLight)
        },
        '& .DayPickerNavigation_svg__horizontal': {
            fill: Colours.textLight
        },
        '& .DayPicker_weekHeader': {
            color: Colours.textLight
        },
        '& .DayPicker_weekHeader_li': {
            fill: Colours.textLight
        },
        '& .CalendarMonth_caption': {
            color: Colours.textLight
        },
        '& .DateRangePickerInput_arrow': {
            margin: margin(0, rem(0.5))
        },
        '& .DateInput': {
            width: 'auto'
        },
        '& .DateInput_input': {
            color: Colours.textLight,
            width: rem(5.5),
            padding: px(5),
            borderBottom: 0,
            fontSize: px(16),
            background: Colours.darkBlue
        },
        '& .DateInput_input__focused::after': {
            position: 'absolute',
            content: "''",
            width: percent(100),
            height: px(2),
            background: Colours.primary
            // borderBottom: `${px(2)} solid ${Colours.primary}`
        },
        '& .DateRangePickerInput__showClearDates': {
            paddingRight: 0
        },
        '& .DayPickerNavigation_button__disabled': {
            border: 0,
            display: 'none'
        },
        '& .DateRangePickerInput_arrow_svg': {
            fill: Colours.textLight,
            height: px(20),
            width: px(20)
        },
        '& .DateRangePickerInput_clearDates_default:focus, & .DateRangePickerInput_clearDates_default:hover': {
            background: 'none',
            $nest: {
                '& .DateRangePickerInput_clearDates_svg': {
                    fill: Colours.blue
                }
            }
        },
        '& .DateRangePickerInput_clearDates': {
            position: 'relative',
            right: 'auto',
            top: 'auto',
            transform: 'none',
            margin: 0
        },
        '& .DateRangePickerInput_clearDates_svg': {
            fill: Colours.textLight
        },
        '& .CalendarDay__default': {
            background: Colours.blue,
            color: Colours.textLight,
            border: "1px solid ".concat(Colours.lightBlue)
        },
        '& .CalendarDay__default:hover': {
            background: Colours.lighterBlue,
            color: 'white'
        },
        '& .CalendarDay__blocked_out_of_range, & .CalendarDay__blocked_out_of_range:hover': {
            backgroundColor: Colours.darkerBlue
        },
        '& .CalendarDay__blocked_out_of_range, & .CalendarDay__blocked_out_of_range:active, & .CalendarDay__blocked_out_of_range:hover': {
            color: Colours.textDark,
            border: "1px solid ".concat(Colours.darkBlue)
        },
        '& .CalendarDay__selected_span': {
            background: Colours.lightestBlue,
            color: 'white',
            border: "1px solid ".concat(Colours.lighterBlue)
        },
        '& .CalendarDay__selected_span:hover': {
            background: Colours.primary
        },
        '& .CalendarDay__selected': {
            background: Colours.primary,
            color: 'white',
            border: "1px solid ".concat(Colours.lightestBlue)
        },
        '& .CalendarDay__selected:hover': {
            border: "1px solid ".concat(Colours.lightBlue),
            background: Colours.lightBlue,
            color: 'white'
        },
        '& .CalendarDay__hovered_span:hover, & .CalendarDay__hovered_span': {
            background: Colours.blue,
            color: 'white',
            border: "1px solid ".concat(Colours.blue)
        },
        '& .CalendarDay__hovered_span:hover': {
            background: Colours.lightestBlue
        }
    }
});

var TimeRangePicker = function (_a) {
    var label = _a.label, startTime = _a.startTime, endTime = _a.endTime, transparent = _a.transparent, disabled = _a.disabled, maxTime = _a.maxTime, minTime = _a.minTime, _b = _a.direction, direction = _b === void 0 ? 'down' : _b, onChange = _a.onChange;
    var ref = useOnClickOutside(function () { return setIsPickerOpen(false); });
    var _c = useState(false), isPickerOpen = _c[0], setIsPickerOpen = _c[1];
    var startMoment = moment(startTime, config.format.time);
    var endMoment = moment(endTime, config.format.time);
    var displayValue = useMemo(function () {
        var placeholder = '--:--';
        var startDisplayValue = startMoment.isValid()
            ? startMoment.format(config.format.time)
            : placeholder;
        var endDisplayValue = endMoment.isValid() && startMoment.isBefore(endMoment)
            ? endMoment.format(config.format.time)
            : placeholder;
        return "".concat(startDisplayValue, " - ").concat(endDisplayValue);
    }, [startTime, endTime]);
    var onTimeRangeChange = function (_a) {
        var startTime = _a.startTime, endTime = _a.endTime;
        setIsPickerOpen(false);
        onChange({
            startTime: startTime.format(config.format.time),
            endTime: endTime.format(config.format.time)
        });
    };
    return (jsxs("div", __assign({ ref: ref, className: style({ position: 'relative' }) }, { children: [jsxs("div", __assign({ "data-testid": TIME_RANGE_PICKER_TOGGLE_TESTID, className: style({ cursor: 'pointer', position: 'relative' }), onClick: function () { return !disabled && setIsPickerOpen(true); } }, { children: [jsx(TextInput, { label: label, labelPosition: "left", id: TIME_RANGE_PICKER_DISPLAY_VALUE_TESTID, value: displayValue, onChange: function () { }, transparent: transparent }), jsx(Box, { className: style({
                            position: 'absolute',
                            top: 0,
                            bottom: 0,
                            left: 0,
                            right: 0
                        }) })] })), isPickerOpen && (jsx(Picker, { start: startMoment, end: endMoment, max: maxTime, min: minTime, onChange: onTimeRangeChange, direction: direction }))] })));
};
var Picker = function (_a) {
    var start = _a.start, end = _a.end, min = _a.min, max = _a.max, direction = _a.direction, onChange = _a.onChange;
    var t = useTranslation().t;
    var _b = useState(start), startTime = _b[0], setStartTime = _b[1];
    var _c = useState(end), endTime = _c[0], setEndTime = _c[1];
    var onSetStartTime = function (newStartTime) {
        setStartTime(newStartTime);
        if (newStartTime.isAfter(endTime)) {
            setEndTime(newStartTime);
        }
    };
    var startErrors = useMemo(function () {
        var errors = [];
        if (min && startTime.isBefore(moment(min, config.format.time))) {
            errors.push(t("Start time must be after ".concat(moment(min, config.format.time).format(config.format.time))));
        }
        return errors;
    }, [startTime, endTime, min, max]);
    var endErrors = useMemo(function () {
        var errors = [];
        if (!startTime.isBefore(endTime)) {
            errors.push(t('End time must be after start time'));
        }
        if (max && endTime.isAfter(moment(max, config.format.time))) {
            errors.push(t("End time must be before ".concat(moment(max, config.format.time).format(config.format.time))));
        }
        return errors;
    }, [startTime, endTime, min, max]);
    return (jsxs(Vertical, __assign({ spacing: rem(1), className: classes(styles$7.picker, style({ bottom: direction === 'up' ? '100%' : 'auto' })), "data-testid": TIME_RANGE_PICKER }, { children: [jsxs(Horizontal, __assign({ spacing: rem(0.5), verticalAlign: "top" }, { children: [jsx(TimeInput, { value: startTime.format(config.format.time), onChange: function (v) {
                            onSetStartTime(moment(v, config.format.time));
                        }, min: min, max: max, errors: startErrors }), jsx(Content, __assign({ height: px(36), verticalAlign: "center", horizontalAlign: "center", className: style({ color: Colours.textLight }) }, { children: "-" })), jsx(TimeInput, { min: startTime.format(config.format.time) || min, max: max, value: endTime.format(config.format.time), onChange: function (v) {
                            setEndTime(moment(v, config.format.time));
                        }, errors: endErrors })] })), jsx(Horizontal, __assign({ sizing: "stretch", horizontalAlign: "right" }, { children: jsx(Button, { disabled: endErrors.length > 0 || startErrors.length > 0, appearance: "blue", content: "Select", onClick: function () { return onChange({ startTime: startTime, endTime: endTime }); } }) }))] })));
};
var styles$7 = stylesheet({
    picker: {
        padding: padding(rem(1), px(20)),
        boxSizing: 'border-box',
        position: 'absolute',
        background: Colours.darkBlue,
        width: px(300),
        boxShadow: boxShadow
    }
});
var TIME_RANGE_PICKER_DISPLAY_VALUE_TESTID = 'time-range-picker-display';
var TIME_RANGE_PICKER_TOGGLE_TESTID = 'time-range-picker-toggle';
var TIME_RANGE_PICKER = 'time-range-picker';

var tabsContext = createContext({
    activeTab: '',
    tabs: [],
    styles: undefined,
    withCustomTabs: false,
    onChange: function () { }
});
var Tabs = function (_a) {
    var children = _a.children, activeTab = _a.activeTab, tabs = _a.tabs, styles = _a.styles, withCustomTabs = _a.withCustomTabs, onChange = _a.onChange;
    return (jsx(tabsContext.Provider, __assign({ value: { activeTab: activeTab, tabs: tabs, onChange: onChange } }, { children: jsxs(Vertical, __assign({ sizing: "stretch", width: (styles === null || styles === void 0 ? void 0 : styles.width) ? styles.width : percent(100), maxWidth: styles === null || styles === void 0 ? void 0 : styles.maxWidth, height: styles === null || styles === void 0 ? void 0 : styles.height, maxHeight: styles === null || styles === void 0 ? void 0 : styles.maxHeight, className: style({ overflow: 'hidden' }), "data-testid": "tabs-container", spacing: styles === null || styles === void 0 ? void 0 : styles.spacing }, { children: [!withCustomTabs && (jsx(Horizontal, __assign({ "data-testid": "tabs-list" }, { children: (tabs || []).map(function (tab) { return (jsx(Content, __assign({ onClick: function () { return onChange === null || onChange === void 0 ? void 0 : onChange(tab); }, className: classes(tabStyle$1, tab === activeTab && 'active', style({
                            padding: (styles === null || styles === void 0 ? void 0 : styles.size) === 'sm' ? 10 : 15,
                            fontSize: (styles === null || styles === void 0 ? void 0 : styles.size) === 'sm' ? Sizes.fontSize2 : undefined
                        })), "data-testid": 'tab-name' + (tab === activeTab ? '-active' : '') }, { children: tab }), tab)); }) }))), children] })) })));
};
var tabStyle$1 = style({
    cursor: 'pointer',
    fontSize: Sizes.fontSize3,
    fontFamily: fontFamily,
    color: Colours.textLight,
    textDecoration: 'none',
    borderBottom: '2px solid transparent',
    $nest: {
        '&.active': {
            borderBottom: "2px solid ".concat(Colours.primary)
        }
    }
});

var TabContent = function (_a) {
    var children = _a.children, name = _a.name;
    var activeTab = useContext(tabsContext).activeTab;
    return (jsx(Stretch, __assign({ className: classes(activeTab !== name && 'hidden', content, style({ overflow: 'hidden' })), "data-testid": "tabs-content" }, { children: children })));
};
var content = style({
    $nest: {
        '&.hidden': {
            display: 'none'
        }
    }
});

var TabHeader = function (_a) {
    var styles = _a.styles, name = _a.name, onClick = _a.onClick;
    var activeTab = useContext(tabsContext).activeTab;
    return (jsx(Content, __assign({ onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(name); }, className: classes(tabStyle, name === activeTab && 'active', style({
            padding: (styles === null || styles === void 0 ? void 0 : styles.size) === 'sm' ? 10 : 15,
            fontSize: (styles === null || styles === void 0 ? void 0 : styles.size) === 'sm' ? Sizes.fontSize2 : undefined
        })), "data-testid": 'tab-name' + (name === activeTab ? '-active' : '') }, { children: name }), name));
};
var tabStyle = style({
    cursor: 'pointer',
    fontSize: Sizes.fontSize3,
    fontFamily: fontFamily,
    color: Colours.textLight,
    textDecoration: 'none',
    borderBottom: '2px solid transparent',
    $nest: {
        '&.active': {
            borderBottom: "2px solid ".concat(Colours.primary)
        }
    }
});

var _path$a;
function _extends$i() { return _extends$i = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$i.apply(null, arguments); }
function SvgDepth(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H6v24h12V0zm-1.5 1.5v2.25h-5.25v1.5h5.25v1.5h-3v1.5h3v1.5h-5.25v1.5h5.25v1.5h-3v1.5h3v1.5h-5.25v1.5h5.25v1.5h-3v1.5h3v2.25h-9v-21h9z"
  })));
}

var _g$8;
function _extends$h() { return _extends$h = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$h.apply(null, arguments); }
function SvgAf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$8 || (_g$8 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.375 11.051a.375.375 0 01-.375-.375M18.688 15.063a.375.375 0 01-.375-.375M22.75 10.676a.375.375 0 01-.375.375M19.063 14.688a.375.375 0 01-.375.375M22.375 10.3c.207 0 .375.168.375.375M18.688 14.313c.207 0 .375.167.375.374M22 10.676c0-.207.168-.375.375-.375M18.313 14.688c0-.207.167-.374.375-.374M19.875 6.551a.375.375 0 01-.375-.375M20.25 6.176a.375.375 0 01-.375.375M19.875 5.8c.207 0 .375.168.375.375M19.5 6.176c0-.207.168-.375.375-.375"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 10.52V1.56h5.6v8.96M1 6l5.6.04M9.56 1.56h4.48M9.56 6.04h3.36M9.56 1.56v8.96"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04 22.743C4.893 18.888 6.135 17 9.617 17a7.026 7.026 0 015.76 3.02 7.024 7.024 0 01-5.76 3.022c-3.381 0-4.54-1.706-8.618-5.784M11.176 19.38a.3.3 0 01-.3.3M10.876 19.08a.3.3 0 01.3.3M10.576 19.38a.3.3 0 01.3-.3M10.876 19.68a.3.3 0 01-.3-.3"
  })))));
}

var _path$9, _rect, _rect2, _rect3, _rect4, _path2$3;
function _extends$g() { return _extends$g = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$g.apply(null, arguments); }
function SvgFeedingTube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 24h-4c0-5.517.328-7.156 2.586-9.414C21.72 12.452 23.429 12 28 12h3l-3 4c-3.43 0-4.52.348-5.586 1.414C21.172 18.656 21 19.517 21 24zM19 30c0 2.8 0 4.2-1.145 5.6-.764.933-3.382 1.4-7.855 1.4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 8,
    height: 6,
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-50 37.47 15.347)",
    x: 36.97,
    y: 13.847,
    width: 1,
    height: 3,
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-50 33.47 16.347)",
    x: 32.97,
    y: 14.847,
    width: 1,
    height: 3,
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    transform: "rotate(-20 37.983 19.58)",
    x: 37.483,
    y: 18.081,
    width: 1,
    height: 3,
    rx: 0.5
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27c1.5 1.333 3 2 4.5 2s3-.667 4.5-2M17 27c1.5 1.333 3 2 4.5 2s3-.667 4.5-2M11 29c1.5 0 3-.667 4.5-2M39 29c-1.333 0-2.667-.667-4-2"
  })));
}

var _path$8;
function _extends$f() { return _extends$f = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$f.apply(null, arguments); }
function SvgOxygen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.444 14.435c1.6 0 2.49.81 2.49 1.925 0 .762-.338 1.253-1.32 2.09l-1.205 1.027v.089H22V21h-5.098v-1.248l2.33-1.988c.786-.669.884-.925.884-1.249 0-.367-.263-.69-.765-.69-.538 0-.844.372-.844.863H16.79c0-1.35 1.071-2.253 2.653-2.253zM9.12 4c4.33 0 7.11 2.899 7.11 7.57 0 4.682-2.77 7.58-7.11 7.58-4.36 0-7.12-2.898-7.12-7.58C2 6.9 4.78 4 9.12 4zm0 3.028c-2.03 0-3.38 1.773-3.38 4.542 0 2.78 1.33 4.552 3.38 4.552 2.02 0 3.37-1.773 3.37-4.552 0-2.769-1.35-4.542-3.37-4.542z"
  })));
}

var _path$7;
function _extends$e() { return _extends$e = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$e.apply(null, arguments); }
function SvgSchooling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2 2l-.213 1.613c-.662.306-1.24.73-1.687 1.112-.284-.381-.745-.653-1.3-.725v3.2c.586-.077 1.072-.372 1.35-.788A6.28 6.28 0 0017.6 7.45v.95s.705-.15 1.287-.8C21.22 7.552 22 5.6 22 5.6s-.648-1.934-2.613-2.325C18.597 2.308 17.2 2 17.2 2zm1.475 2c1.45 0 2.17 1.04 2.437 1.563-.275.434-.967 1.237-2.312 1.237-1.413 0-2.548-.692-3.2-1.2 0-.027-.01-.048-.013-.075.483-.44 1.16-.942 1.888-1.25L18 4.1c.225-.058.45-.1.675-.1zm1.125.8a.6.6 0 100 1.2.6.6 0 000-1.2zM6 4l-.266 2.016c-.828.382-1.55.912-2.109 1.39C3.27 6.93 2.693 6.59 2 6.5v4c.732-.096 1.34-.465 1.688-.984A7.85 7.85 0 006.5 10.812V12s.88-.188 1.61-1C11.022 10.94 12 8.5 12 8.5s-.81-2.418-3.266-2.906C7.746 4.384 6 4 6 4zm1.844 2.5c1.812 0 2.713 1.3 3.047 1.953C10.547 8.996 9.68 10 8 10c-1.766 0-3.186-.865-4-1.5 0-.033-.014-.06-.016-.094.604-.549 1.45-1.177 2.36-1.562L7 6.625c.281-.072.563-.125.844-.125zm1.406 1a.75.75 0 100 1.5.75.75 0 000-1.5zM12.6 11l-.372 2.822c-1.16.536-2.171 1.277-2.953 1.947C8.777 15.102 7.971 14.626 7 14.5v5.6c1.025-.134 1.876-.65 2.362-1.378.966.694 2.29 1.435 3.938 1.815V22.2s1.233-.262 2.253-1.4c4.08-.085 5.447-3.5 5.447-3.5s-1.135-3.385-4.572-4.069C15.045 11.54 12.6 11 12.6 11zm2.581 3.5c2.538 0 3.798 1.821 4.266 2.734-.481.76-1.693 2.166-4.047 2.166-2.472 0-4.46-1.211-5.6-2.1 0-.046-.02-.085-.022-.131.845-.769 2.029-1.65 3.303-2.188l.919-.306a4.768 4.768 0 011.181-.175zm1.969 1.4a1.05 1.05 0 100 2.1 1.05 1.05 0 000-2.1z"
  })));
}

var _path$6;
function _extends$d() { return _extends$d = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$d.apply(null, arguments); }
function SvgTemperature(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2a2 2 0 00-2 2v9.021c-1.99 1.5-2.726 4.372-1.139 6.778a4.9 4.9 0 002.973 2.068A5.01 5.01 0 0017 17c0-1.563-.754-3.04-2-3.979V12h1a1 1 0 000-2h-1V8h1a1 1 0 000-2h-1V4a2 2 0 00-2-2h-2zm0 2h2v2h-2V4z"
  })));
}

var _path$5;
function _extends$c() { return _extends$c = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$c.apply(null, arguments); }
function SvgVisibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10h8a2 2 0 002-2v-8c0-5.523-4.477-10-10-10zm0 2a8 8 0 110 16 8 8 0 010-16zm0 4a1 1 0 00-.195.02A3.99 3.99 0 008 12a4 4 0 004 4c2.14 0 3.87-1.684 3.979-3.797l.001-.004a1 1 0 00-1.111-1.19L14.86 11H14a1 1 0 01-1-1v-.86l-.01-.011A1 1 0 0012 8z"
  })));
}

var _path$4, _path2$2;
function _extends$b() { return _extends$b = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$b.apply(null, arguments); }
function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.15 468.625H63.787c-11.737 0-21.262-9.526-21.262-21.262V64.638c0-11.737 9.526-21.262 21.262-21.262H255.15c11.758 0 21.262-9.504 21.262-21.262S266.908.85 255.15.85H63.787C28.619.85 0 29.47 0 64.638v382.724c0 35.168 28.619 63.787 63.787 63.787H255.15c11.758 0 21.262-9.504 21.262-21.262 0-11.758-9.504-21.262-21.262-21.262z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    d: "M505.664 240.861L376.388 113.286c-8.335-8.25-21.815-8.143-30.065.213s-8.165 21.815.213 30.065l92.385 91.173H191.362c-11.758 0-21.262 9.504-21.262 21.262 0 11.758 9.504 21.263 21.262 21.263h247.559l-92.385 91.173c-8.377 8.25-8.441 21.709-.213 30.065a21.255 21.255 0 0015.139 6.336c5.401 0 10.801-2.041 14.926-6.124l129.276-127.575A21.303 21.303 0 00512 255.998c0-5.696-2.275-11.118-6.336-15.137z"
  })));
}

var _g$7;
function _extends$a() { return _extends$a = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$a.apply(null, arguments); }
function SvgPellets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$7 || (_g$7 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.21 8.587a2.917 2.917 0 013.377-3.377l.086-.085-3.536-3.536-.011.012a2.5 2.5 0 10-3.24 3.809l3.251 3.25.073-.073zM17.5 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM6.79 15.587a2.917 2.917 0 00-3.377-3.377l-.086-.085 3.536-3.536.011.012a2.5 2.5 0 113.24 3.809l-3.251 3.25-.073-.073zM3.5 18a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM17.21 20.587a2.917 2.917 0 013.377-3.377l.086-.085-3.536-3.536-.011.012a2.5 2.5 0 10-3.24 3.809l3.251 3.25.073-.073zM20.5 23a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
  }))));
}

var _path$3;
function _extends$9() { return _extends$9 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$9.apply(null, arguments); }
function SvgActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    viewBox: "0 0 24 17",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.203 0c-.966 0 2.362 2.11.635 3.946C6.48 5.215 4.771 6.84 4.771 6.84S3.144 3.719.328 3.719c-.119 0-.42.064-.115.566.469.775 1.328 2.34 1.328 3.774 0 1.428-.868 3.308-1.444 4.088-.204.278-.066.51.23.51 3.65 0 4.444-3.35 4.444-3.35s3.319 3.318 7.645 3.974c.52 1.428-1.086 3.066-.32 3.066h1.473c.36 0 2.664-1.756 2.942-3.123 3.517-.474 5.627-1.889 6.922-3.774.356-.515.623-.944.145-1.787-.582-1.032-2.155-3.684-6.115-4.74C16.908 1.194 15.138 0 14.405 0H8.203zm10.644 6.074c.926 0 1.674.738 1.674 1.646 0 .907-.748 1.645-1.674 1.645-.924 0-1.673-.736-1.673-1.645 0-.908.749-1.646 1.673-1.646zm0 .965a.681.681 0 100 1.361c.386 0 .694-.3.694-.68 0-.38-.308-.68-.694-.68z"
  })));
}

var _path$2, _circle;
function _extends$8() { return _extends$8 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$8.apply(null, arguments); }
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": "errorIconTitle",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none",
    color: "#000"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8v5M12 16h0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10
  })));
}

var _g$6;
function _extends$7() { return _extends$7 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$7.apply(null, arguments); }
function SvgNumberOfFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$6 || (_g$6 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2h1.714v6M2 8h3.429M18.857 2h3.429l-2.572 2.571s2.572 0 2.572 1.715C22.286 8 20.57 8 18.857 8M9.571 4.143a2.143 2.143 0 014.286 0c0 1.286-2.023 2.366-4.286 3.857h4.286"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.055 20.605C7.417 15.5 9.145 13 13.988 13a10.17 10.17 0 014.521 1.064A9.637 9.637 0 0122 17a9.635 9.635 0 01-3.49 2.936A10.167 10.167 0 0113.988 21C9.284 21 7.673 18.742 2 13.342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.737 16.55a.408.408 0 01-.417-.397c0-.22.187-.398.417-.398M15.737 16.55c.23 0 .418-.178.418-.397a.408.408 0 00-.418-.398"
  }))));
}

var _g$5;
function _extends$6() { return _extends$6 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$6.apply(null, arguments); }
function SvgVisibilityOfWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$5 || (_g$5 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 10l-6 6 6 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.338 11.662C7.625 11.877 9 13.062 9 16c0 2.939-1.375 4.123-1.662 4.338M11.667 16H13M15.667 16H17M19.667 16H21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21 3.28c-1.894.75-4.066.236-5.4-1.28A4.785 4.785 0 0112 3.62 4.785 4.785 0 018.4 2C7.067 3.515 4.894 4.028 3 3.274M3 6.657c1.894.753 4.066.238 5.4-1.278A4.785 4.785 0 0012 7a4.785 4.785 0 003.6-1.62c1.333 1.516 3.505 2.03 5.4 1.28"
  })))));
}

var _g$4;
function _extends$5() { return _extends$5 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$5.apply(null, arguments); }
function SvgSchoolingOfFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$4 || (_g$4 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.3 18.962S7.8 22 4.8 22c-2.5 0-3-1.519-3-1.519s.5-1.519 3-1.519c3 0 4.5 3.038 4.5 3.038M22.2 15.165s-1.5 3.038-4.5 3.038c-2.5 0-3-1.52-3-1.52s.5-1.518 3-1.518c3 0 4.5 3.038 4.5 3.038M12.3 10.97s-1.5 3.038-4.5 3.038c-2.5 0-3-1.52-3-1.52s.5-1.518 3-1.518c3 0 4.5 3.038 4.5 3.038M20.5 5.57S19 8.608 16 8.608c-2.5 0-3-1.52-3-1.52s.5-1.518 3-1.518c3 0 4.5 3.038 4.5 3.038M9.2 1.8S7.7 4.838 4.7 4.838c-2.5 0-3-1.519-3-1.519S2.2 1.8 4.7 1.8c3 0 4.5 3.038 4.5 3.038"
  }))));
}

var _g$3;
function _extends$4() { return _extends$4 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$4.apply(null, arguments); }
function SvgDistanceFishCam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$3 || (_g$3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.545 2.455l-19.09 19.09M22.255 7.255V1.8H16.8M1.8 16.8v5.455h5.455"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M12.25 15.583l2.609.89v-.89c0-.736.584-1.333 1.304-1.333h4.783c.72 0 1.304.597 1.304 1.333v5.334c0 .736-.584 1.333-1.304 1.333h-4.783c-.72 0-1.304-.597-1.304-1.333v-.89l-2.609.89v-5.334z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 1.75s2.2 5 6.6 5c3.667 0 4.4-2.5 4.4-2.5s-.733-2.5-4.4-2.5c-4.4 0-6.6 5-6.6 5"
  }))));
}

var _g$2;
function _extends$3() { return _extends$3 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$3.apply(null, arguments); }
function SvgChaosOfFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$2 || (_g$2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.038 14.298s.22 3.381-2.378 4.881c-2.165 1.25-3.358.185-3.358.185s-.326-1.566 1.839-2.816c2.598-1.5 5.416.381 5.416.381M13.707 9.944s2.448 2.342 5.267 1.315c2.35-.855 2.3-2.453 2.3-2.453s-.99-1.256-3.339-.401c-2.819 1.026-3.19 4.394-3.19 4.394M9.457 8.879s-2.818 1.88-5.416.38C1.876 8.01 2.202 6.444 2.202 6.444s1.193-1.065 3.358.185c2.598 1.5 2.378 4.88 2.378 4.88"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19.75,
    cy: 17.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.75,
    cy: 4.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.75,
    cy: 1.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.75,
    cy: 21.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 2.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.75,
    cy: 4.75,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.75,
    cy: 19.75,
    r: 1
  }))));
}

var _g$1;
function _extends$2() { return _extends$2 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$2.apply(null, arguments); }
function SvgDensityOfFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g$1 || (_g$1 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3 18.97s-1.5 3.038-4.5 3.038c-2.5 0-3-1.52-3-1.52s.5-1.518 3-1.518c3 0 4.5 3.038 4.5 3.038M1.8 14.666s1.8 3.645 5.4 3.645c3 0 3.6-1.822 3.6-1.822s-.6-1.823-3.6-1.823c-3.6 0-5.4 3.645-5.4 3.645M22.3 7.667s-2.6 5.266-7.8 5.266c-4.333 0-5.2-2.633-5.2-2.633s.867-2.633 5.2-2.633c5.2 0 7.8 5.266 7.8 5.266"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.333
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.933 2.067L5 1l1.067 1.067M6.067 7.933L5 9 3.933 7.933M5 1v8M2.067 6.067L1 5l1.067-1.067M7.933 3.933L9 5 7.933 6.067M1 5h8"
  })))));
}

var _path$1, _path2$1, _path3$1, _path4;
function _extends$1() { return _extends$1 = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends$1.apply(null, arguments); }
function SvgActivityTrend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.75c-1.585.382-2.942 1.635-3.76 2.295a8.142 8.142 0 00-.743-.612C1.86 10.603.5 10.5.5 10.5s.355 1.61 1.292 2.495C.855 13.879.5 15.49.5 15.49s1.36-.103 2.497-.933c.257-.188.504-.39.737-.607.816.66 2.18 1.917 3.766 2.3L7 18c1.232-.208 2.464-1.11 2.96-1.508C14 16.312 15.5 13.72 15.5 13c0-.688-1.5-3.313-5.528-3.492C9.485 9.118 8.242 8.21 7 8l.5 1.75z",
    stroke: "#E0EEF3",
    strokeWidth: 0.9,
    strokeLinejoin: "round"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13a.5.5 0 100-1 .5.5 0 000 1z",
    fill: "#E0EEF3"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 16.125a6.226 6.226 0 010-6.25",
    stroke: "#E0EEF3",
    strokeWidth: 0.9,
    strokeMiterlimit: 20,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 13.25l2.5-2.5 2.5 2.5m-5 2l2.5-2.5 2.5 2.5",
    stroke: "#E0EEF3",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgNormalizedActivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.75c-1.585.382-2.942 1.635-3.76 2.295a8.142 8.142 0 00-.743-.612C1.86 10.603.5 10.5.5 10.5s.355 1.61 1.292 2.495C.855 13.879.5 15.49.5 15.49s1.36-.103 2.497-.933c.257-.188.504-.39.737-.607.816.66 2.18 1.917 3.766 2.3L7 18c1.232-.208 2.464-1.11 2.96-1.508C14 16.312 15.5 13.72 15.5 13c0-.688-1.5-3.313-5.528-3.492C9.485 9.118 8.242 8.21 7 8l.5 1.75z",
    stroke: "#E0EEF3",
    strokeWidth: 0.9,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13a.5.5 0 100-1 .5.5 0 000 1z",
    fill: "#E0EEF3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.825 16.125a6.226 6.226 0 010-6.25",
    stroke: "#E0EEF3",
    strokeWidth: 0.9,
    strokeMiterlimit: 20,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#normalized_activity_svg__clip0_3595_8053)",
    stroke: "#E0EEF3",
    strokeWidth: 0.9,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.672 15.333l4.666-4.667M19.336 12.333a1 1 0 100-2 1 1 0 000 2zM22.672 15.666a1 1 0 100-2 1 1 0 000 2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "normalized_activity_svg__clip0_3595_8053"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(17 9)",
    d: "M0 0h8v8H0z"
  })))));
}

var iconsWithStroke = [
    'appetiteFactor',
    'chaos_of_fish',
    'density_of_fish',
    'distance_fish_cam',
    'number_of_fish',
    'visibility_of_water',
    'schooling_of_fish'
];
var getIconStrokeColor = function (icon, color) {
    return iconsWithStroke.includes(icon) ? color : 'none';
};

var icons = {
    depth: SvgDepth,
    appetiteFactor: SvgAf,
    feedingTube: SvgFeedingTube,
    oxygen: SvgOxygen,
    schooling: SvgSchooling,
    temperature: SvgTemperature,
    visibility: SvgVisibility,
    exitGood: SvgExit,
    exitBad: SvgExit,
    exitEmergency: SvgExit,
    pellets: SvgPellets,
    activity: SvgActivity,
    number_of_fish: SvgNumberOfFish,
    visibility_of_water: SvgVisibilityOfWater,
    distance_fish_cam: SvgDistanceFishCam,
    chaos_of_fish: SvgChaosOfFish,
    density_of_fish: SvgDensityOfFish,
    schooling_of_fish: SvgSchoolingOfFish,
    relative_activity: SvgNormalizedActivity,
    trend_activity: SvgActivityTrend
};
var SignalInfoDropdown = function (_a) {
    var icon = _a.icon, _b = _a.iconColor, iconColor = _b === void 0 ? Colours.textLight : _b, value = _a.value, unit = _a.unit, options = _a.options, readonly = _a.readonly, direction = _a.direction, onSelect = _a.onSelect;
    var Icon = icon ? icons[icon] : SvgError;
    var dropdownOptions = useMemo(function () {
        return readonly
            ? []
            : options.map(function (group) {
                return group.map(function (option) {
                    return __assign(__assign({}, option), { icon: option.icon
                            ? function (props) {
                                if (!option.icon)
                                    return null;
                                var Icon = icons[option.icon];
                                return (jsx(Icon, __assign({}, props, { fill: getColor$1(option.icon, option.iconColor || Colours.textLight), stroke: getIconStrokeColor(option.icon, option.iconColor || Colours.textLight) })));
                            }
                            : undefined, onClick: function () { return onSelect(option.key); } });
                });
            });
    }, [options, readonly]);
    var color = useMemo(function () {
        return getColor$1(icon, iconColor);
    }, [icon, iconColor]);
    return (jsx(DropdownWrapper, __assign({ options: dropdownOptions, direction: direction }, { children: jsxs(Horizontal, __assign({ height: px(24), spacing: rem(0.5), verticalAlign: "center", className: style({ cursor: readonly ? 'default' : 'pointer' }), padding: [0, rem(0.5)], "data-testid": "signal-dropdown-container" }, { children: [jsx(Icon, { width: 18, height: 18, fill: !icon || iconsWithStroke.includes(icon) ? 'none' : color, stroke: !icon || iconsWithStroke.includes(icon) ? color : 'none' }), jsx(Content, __assign({ verticalAlign: "center", className: style({
                        fontFamily: fontFamily,
                        fontSize: Sizes.fontSize1,
                        color: Colours.textLight
                    }), "data-testid": "signal-dropdown-content" }, { children: String(value) + unit }))] })) })));
};
var getColor$1 = function (icon, color) {
    switch (icon) {
        case 'exitGood':
            return Colours.green;
        case 'exitBad':
            return Colours.orange;
        case 'exitEmergency':
            return Colours.red;
        default:
            return color;
    }
};

var SignalProgressBar = function (_a) {
    var _b = _a.value, value = _b === void 0 ? '--' : _b, name = _a.name, unit = _a.unit, percentage = _a.percentage, invert = _a.invert;
    var pipeHeight = useMemo(function () {
        return percent(percentage < 0.1 ? 10 : percentage > 1 ? 100 : percentage * 100);
    }, [percentage]);
    var barColor = useMemo(function () { return getProgressBarColor(percentage, !!invert); }, [percentage, invert]);
    return (jsxs(Horizontal, __assign({ spacing: rem(1) }, { children: [jsx(Box, __assign({ width: px(6), height: px(40), className: style({
                    background: color(barColor).fadeOut(0.8).toString(),
                    borderRadius: Sizes.borderRadius,
                    overflow: 'hidden'
                }), verticalAlign: "bottom", "data-testid": "signal-progress-container" }, { children: jsx(Box, { width: percent(100), height: pipeHeight, className: style({ background: barColor }), "data-testid": "signal-progress-bar" }) })), jsxs(Vertical, __assign({ spacing: 0, className: style({ fontFamily: fontFamily }), padding: [px(2), 0, 0, 0] }, { children: [jsx(Content, __assign({ className: style({
                            color: Colours.textLight,
                            fontSize: Sizes.fontSize2
                        }), "data-testid": "signal-progress-name" }, { children: name })), jsx(StretchSpacer, {}), jsxs(Content, __assign({ className: style({
                            color: Colours.textLight
                        }), "data-testid": "signal-progress-value" }, { children: [value, " ", unit] }))] }))] })));
};
var getProgressBarColor = function (percentage, invert) {
    var color = percentage > 0.9
        ? Colours.red
        : Number(percentage) > 0.5
            ? Colours.orange
            : Colours.primary;
    if (invert)
        color =
            percentage > 0.5
                ? Colours.primary
                : Number(percentage) > 0.1
                    ? Colours.orange
                    : Colours.red;
    return color;
};

var signalsConfiguration = {
    activity: {
        name: 'Activity',
        key: 'activity',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_activity: {
        name: 'Activity (Avg)',
        key: 'av_activity',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    density: {
        name: 'Fish Density',
        key: 'density',
        color: Colours.green,
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_density: {
        name: 'Fish Density (Avg)',
        key: 'av_density',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    schooling: {
        name: 'Schooling Behaviour',
        key: 'schooling',
        color: Colours.yellow,
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_schooling: {
        name: 'Schooling Behaviour (Avg)',
        key: 'av_schooling',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    visibility: {
        name: 'Visibility',
        key: 'visibility',
        color: Colours.blue,
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_visibility: {
        name: 'Visibility (Avg)',
        key: 'av_visibility',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    balling: {
        name: 'Balling',
        key: 'balling',
        color: Colours.orange,
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_balling: {
        name: 'Balling (Avg)',
        key: 'av_balling',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    speed: {
        name: 'Speed',
        key: 'speed',
        color: '#1C1E28',
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_speed: {
        name: 'Speed (Avg)',
        key: 'av_speed',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    close_camera: {
        name: 'Distance',
        key: 'close_camera',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line'
    },
    av_close_camera: {
        name: 'Distance (Avg)',
        key: 'av_close_camera',
        color: Colours.red,
        label: '%',
        range: [0, 100],
        graph: 'line',
        gradient: true
    },
    no_pellets: {
        name: 'Pellets',
        key: 'no_pellets',
        label: '#',
        graph: 'line'
    },
    depth: {
        name: 'Camera Depth',
        key: 'depth',
        label: 'm',
        graph: 'line'
    },
    no_waste: {
        name: 'Waste',
        key: 'no_waste',
        label: '#',
        graph: 'line'
    },
    rate_gram_per_sec: {
        name: 'Feed Rate',
        key: 'rate_gram_per_sec',
        label: 'kg/min',
        graph: 'area',
        gradient: true
    },
    kgtonmin: {
        name: 'Feed Rate',
        key: 'kgtonmin',
        label: 'kg/ton/min',
        graph: 'area',
        gradient: true
    },
    pelletfishmin: {
        name: 'Feed Rate',
        key: 'pelletfishmin',
        label: 'p/fish/min',
        graph: 'area',
        gradient: true
    },
    visit_dose: {
        name: 'Feed Dose',
        key: 'visit_dose',
        label: 'kg',
        graph: 'area',
        gradient: true
    },
    TEMPERATURE: {
        name: 'Temperature',
        key: 'TEMPERATURE',
        graph: 'line'
    },
    TEMPERATURE_alert: {
        name: 'Temperature Alerts',
        key: 'TEMPERATURE_alert',
        graph: 'bar'
    },
    OXYGEN: {
        name: 'Disolved Oxygen',
        key: 'OXYGEN',
        graph: 'line'
    },
    OXYGEN_alert: {
        name: 'Oxygen Alerts',
        key: 'OXYGEN_alert',
        graph: 'bar'
    },
    SALINITY: {
        name: 'Salinity',
        key: 'SALINITY',
        graph: 'line'
    },
    SALINITY_alert: {
        name: 'Salinity Alerts',
        key: 'SALINITY_alert',
        graph: 'bar'
    },
    SATURATION: {
        name: 'Saturation',
        key: 'SATURATION',
        graph: 'line'
    },
    SATURATION_alert: {
        name: 'Salinity Alerts',
        key: 'SATURATION_alert',
        graph: 'bar'
    },
    tide_m: {
        name: 'Tide',
        key: 'tide_m',
        label: 'm',
        graph: 'line'
    },
    feed_score: {
        name: 'Recommendation',
        key: 'feed_score',
        label: '%',
        range: [0, 100],
        graph: 'line'
    }
};
var legendOptions = [
    [
        {
            text: 'Vision',
            subGroups: [
                [
                    {
                        text: 'Activity %',
                        key: 'activity'
                    },
                    {
                        text: 'Activity (Avg) %',
                        key: 'av_activity'
                    },
                    {
                        text: 'Fish Density %',
                        key: 'density'
                    },
                    {
                        text: 'Fish Density (Avg) %',
                        key: 'av_density'
                    },
                    {
                        text: 'Schooling Behaviour %',
                        key: 'schooling'
                    },
                    {
                        text: 'Schooling Behaviour (Avg) %',
                        key: 'av_schooling'
                    },
                    {
                        text: 'Visibility %',
                        key: 'visibility'
                    },
                    {
                        text: 'Visibility (Avg) %',
                        key: 'av_visibility'
                    },
                    {
                        text: 'Balling %',
                        key: 'balling'
                    },
                    {
                        text: 'Balling (Avg) %',
                        key: 'av_balling'
                    },
                    {
                        text: 'Speed %',
                        key: 'speed'
                    },
                    {
                        text: 'Speed (Avg) %',
                        key: 'av_speed'
                    },
                    {
                        text: 'Visibility %',
                        key: 'visibility'
                    },
                    {
                        text: 'Visibility (Avg) %',
                        key: 'av_visibility'
                    },
                    {
                        text: 'Distance %',
                        key: 'close_camera'
                    },
                    {
                        text: 'Distance (Avg) %',
                        key: 'av_close_camera'
                    },
                    {
                        text: 'Pellets #',
                        key: 'no_pellets'
                    },
                    {
                        text: 'Camera Depth m',
                        key: 'depth'
                    },
                    {
                        text: 'Waste #',
                        key: 'no_waste'
                    }
                ]
            ]
        },
        {
            text: 'AI',
            subGroups: [
                [
                    {
                        text: 'Recommendation %',
                        key: 'feed_score'
                    }
                ]
            ]
        },
        {
            text: 'Feed',
            subGroups: [
                [
                    {
                        text: 'Feed Rate kg/min',
                        key: 'rate_gram_per_sec'
                    },
                    {
                        text: 'Feed Rate kg/ton/min',
                        key: 'kgtonmin'
                    },
                    {
                        text: 'Feed Rate p/fish/min',
                        key: 'pelletfishmin'
                    },
                    {
                        text: 'Feed Dose kg',
                        key: 'visit_dose'
                    }
                ]
            ]
        },
        {
            text: 'Sensors',
            subGroups: [
                [
                    {
                        text: 'Temperature',
                        key: 'TEMPERATURE'
                    },
                    {
                        text: 'Temperature Alerts',
                        key: 'TEMPERATURE_alert'
                    },
                    {
                        text: 'Disolved Oxygen',
                        key: 'OXYGEN'
                    },
                    {
                        text: 'Oxygen Alerts',
                        key: 'OXYGEN_alert'
                    },
                    {
                        text: 'Salinity',
                        key: 'SALINITY'
                    },
                    {
                        text: 'Salinity Alerts',
                        key: 'SALINITY_alert'
                    },
                    {
                        text: 'Saturation',
                        key: 'SATURATION'
                    },
                    {
                        text: 'Salinity Alerts',
                        key: 'SATURATION_alert'
                    }
                ]
            ]
        },
        {
            text: 'Weather',
            subGroups: [
                [
                    {
                        text: 'Tide m',
                        key: 'tide_m'
                    }
                ]
            ]
        }
    ]
];

var SignalLegendDropdown = function (_a) {
    var availableOptions = _a.availableOptions, color = _a.color, value = _a.value, onSelect = _a.onSelect;
    var mapOptions = useCallback(function (groups, type) {
        return groups.map(function (g) {
            return g.map(function (option) {
                var _a;
                return (__assign(__assign({}, option), { text: "".concat(option.text).concat(option.unit ? " ".concat(option.unit) : ''), disabled: !((_a = option.subGroups) === null || _a === void 0 ? void 0 : _a.length) &&
                        !availableOptions.includes(option.key), onClick: function () {
                        return onSelect(signalsConfiguration[option.key], type);
                    }, subGroups: mapOptions(option.subGroups || [], option.text) }));
            });
        });
    }, [onSelect]);
    var mappedOptions = useMemo(function () {
        return mapOptions(legendOptions);
    }, [availableOptions, mapOptions]);
    var valueText = useMemo(function () {
        if (!value)
            return;
        var signal = signalsConfiguration[value];
        return signal.name + (signal.label ? " ".concat(signal.label) : '');
    }, [value]);
    return (jsxs(Horizontal, __assign({ height: px(36), verticalAlign: "center", spacing: rem(0.5), className: style({
            fontFamily: fontFamily,
            color: Colours.textLight,
            cursor: 'pointer',
            $nest: {
                '&:hover > div > svg': {
                    color: 'white'
                }
            }
        }), "data-testid": "signal-legend-container" }, { children: [jsx(Box, __assign({ width: px(20), height: px(20), className: style({
                    background: color,
                    borderRadius: px(4)
                }), verticalAlign: "center", horizontalAlign: "center", onClick: function () { return value && onSelect(undefined); }, "data-testid": "signal-legend-remove" }, { children: value && (jsx(Icon, { icon: faTimes, color: color, className: style({
                        width: px(12),
                        height: px(12)
                    }) })) })), jsx(DropdownWrapper, __assign({ options: mappedOptions }, { children: jsxs(Horizontal, __assign({ spacing: rem(0.5), verticalAlign: "center" }, { children: [jsx(Stretch, __assign({ maxWidth: rem(10), className: style({
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }), "data-testid": "signal-legend-value" }, { children: valueText || 'Select' })), jsx(Icon, { icon: faAngleDown })] })) }))] })));
};
var SignalLegendToggle = function (_a) {
    var text = _a.text, toggled = _a.toggled, onToggle = _a.onToggle;
    return (jsxs(Horizontal, __assign({ height: px(36), verticalAlign: "center", onClick: onToggle, spacing: rem(0.5), className: style({
            fontFamily: fontFamily,
            color: toggled ? Colours.textLight : Colours.textDark,
            cursor: 'pointer'
        }), "data-testid": "signal-legend-strategy" }, { children: [jsx(Box, { width: px(20), height: px(20), className: style({
                    background: color(Colours.purple)
                        .fadeOut(toggled ? 0 : 0.5)
                        .toString(),
                    borderRadius: px(4)
                }) }), jsx(Content, { children: text })] })));
};

var FeedingMonitor = function (_a) {
    var disabled = _a.disabled, unit = _a.unit, value = _a.value, observeValue = _a.observeValue, paused = _a.paused, onIncrease = _a.onIncrease, onDecrease = _a.onDecrease, onInput = _a.onInput, onPlayPause = _a.onPlayPause;
    var _b = useState(value), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState(false), isInput = _c[0], setIsInput = _c[1];
    var resetInput = useCallback(function () {
        setIsInput(false);
        setInputValue(value);
    }, [value]);
    var submitInput = useCallback(function () {
        setIsInput(false);
        onInput === null || onInput === void 0 ? void 0 : onInput(Number(inputValue));
    }, [inputValue]);
    var onKeyDown = useCallback(function (e) {
        if (e.key === 'Enter')
            submitInput();
        if (e.key === 'Escape')
            resetInput();
    }, [submitInput, resetInput]);
    return (jsxs(Horizontal, __assign({ spacing: rem(1), padding: rem(1), "data-testid": "feeding-monitor" }, { children: [jsxs(Vertical, __assign({ horizontalAlign: "center", minWidth: px(70) }, { children: [jsxs(ControlValue$1, __assign({ dataTestId: "observe-af", "data-testid": "feeding-monitor-observe-af" }, { children: [observeValue || '--', ' AF'] })), jsx(ControlValue$1, __assign({ dataTestId: "system-value", className: style({ fontSize: px(22) }), "data-testid": "feeding-monitor-af", onClick: function () { return onInput && setIsInput(true); } }, { children: onInput && isInput ? (jsx(Box, __assign({ width: rem(3), onKeyDown: onKeyDown }, { children: jsx(NumberInput, { id: "feeding-monitor-input", value: inputValue, onChange: setInputValue, autoFocus: true }) }))) : (value || '--') })), jsx(ControlValue$1, __assign({ dataTestId: "unit" }, { children: unit }))] })), jsx(StretchSpacer, {}), jsxs(Vertical, __assign({ "data-testid": "feeding-monitor-controls" }, { children: [jsx(ControlIcon$1, { disabled: !!disabled || isInput, dataTestId: "increase", icon: faPlus, onClick: onIncrease }), jsx(ControlIcon$1, { disabled: !!disabled || isInput, icon: paused ? faPlay : faPause, className: style({ height: px(14), marginLeft: !paused ? px(2) : 0 }), onClick: onPlayPause, dataTestId: "play-pause" }), jsx(ControlIcon$1, { disabled: !!disabled || isInput, dataTestId: "decrease", icon: faMinus, onClick: onDecrease })] }))] })));
};
var ControlIcon$1 = function (_a) {
    var icon = _a.icon, className = _a.className, onClick = _a.onClick, dataTestId = _a.dataTestId, disabled = _a.disabled;
    return (jsx(Content, __assign({ verticalAlign: "center", horizontalAlign: "center", className: classes(disabled && 'disabled', button$1), onClick: function () { return !disabled && onClick(); }, "data-testid": dataTestId }, { children: jsx(Icon, { icon: icon, color: color(disabled ? Colours.textDisabled : Colours.textLight).toString(), className: className }) })));
};
var ControlValue$1 = function (_a) {
    var className = _a.className, children = _a.children, dataTestId = _a.dataTestId, onClick = _a.onClick;
    return (jsx(Content, __assign({ height: px(30), width: percent(100), verticalAlign: "center", horizontalAlign: "center", className: classes(style({
            color: Colours.primary,
            fontFamily: fontFamily
        }), className), "data-testid": dataTestId, onClick: onClick }, { children: children })));
};
var button$1 = style({
    height: px(30),
    width: px(30),
    borderRadius: percent(100),
    cursor: 'pointer',
    background: color(Colours.lightestBlue).fadeOut(0.5).toString(),
    $nest: {
        '&.disabled': {
            cursor: 'default'
        },
        '&:not(.disabled):active:hover': {
            transform: scale(0.9),
            transition: 'none'
        }
    },
    transition: '0.1s ease-out',
    userSelect: 'none'
});

var FeedingMonitorOverlay = function (_a) {
    var disabled = _a.disabled, unit = _a.unit, value = _a.value, paused = _a.paused, onIncrease = _a.onIncrease, onDecrease = _a.onDecrease, onInput = _a.onInput, onPlayPause = _a.onPlayPause, min = _a.min, max = _a.max;
    var _b = useState(value), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState(false), isInput = _c[0], setIsInput = _c[1];
    var resetInput = useCallback(function () {
        setIsInput(false);
        setInputValue(value);
    }, [value]);
    var submitInput = useCallback(function () {
        setIsInput(false);
        onInput === null || onInput === void 0 ? void 0 : onInput(Number(inputValue));
    }, [inputValue]);
    var onKeyDown = useCallback(function (e) {
        if (e.key === 'Enter')
            submitInput();
        if (e.key === 'Escape')
            resetInput();
    }, [submitInput, resetInput]);
    return (jsxs(Horizontal, __assign({ verticalAlign: "center", spacing: rem(1), padding: rem(1), "data-testid": "feeding-monitor" }, { children: [jsx(ControlIcon, { disabled: !!disabled || isInput, icon: paused ? faPlay : faPause, className: style({ height: px(14), marginLeft: !paused ? px(2) : 0 }), onClick: onPlayPause, dataTestId: "play-pause" }), jsx(ControlIcon, { disabled: !!disabled || isInput, dataTestId: "decrease", icon: faMinus, onClick: onDecrease }), jsxs(Box, { children: [jsx(Vertical, __assign({ spacing: 2, horizontalAlign: "center", minWidth: px(70) }, { children: jsx(ControlValue, __assign({ dataTestId: "system-value", className: style({ fontSize: px(22) }), "data-testid": "feeding-monitor-af", onClick: function () { return onInput && setIsInput(true); } }, { children: onInput && isInput ? (jsx(Box, __assign({ width: rem(3), onKeyDown: onKeyDown }, { children: jsx(NumberInput, { id: "feeding-monitor-input", min: min, max: max, value: inputValue, onChange: setInputValue, autoFocus: true }) }))) : (value || '--') })) })), jsx(ControlValue, __assign({ dataTestId: "unit" }, { children: unit }))] }), jsx(ControlIcon, { disabled: !!disabled || isInput, dataTestId: "increase", icon: faPlus, onClick: onIncrease })] })));
};
var ControlIcon = function (_a) {
    var icon = _a.icon, className = _a.className, onClick = _a.onClick, dataTestId = _a.dataTestId, disabled = _a.disabled;
    return (jsx(Content, __assign({ verticalAlign: "center", horizontalAlign: "center", className: classes(disabled && 'disabled', button), onClick: function () { return !disabled && onClick(); }, "data-testid": dataTestId }, { children: jsx(Icon, { icon: icon, color: color(disabled ? Colours.textDisabled : Colours.textLight).toString(), className: className }) })));
};
var ControlValue = function (_a) {
    var className = _a.className, children = _a.children, dataTestId = _a.dataTestId, onClick = _a.onClick;
    return (jsx(Content, __assign({ height: px(30), width: percent(100), verticalAlign: "center", horizontalAlign: "center", className: classes(style({
            color: Colours.primary,
            fontFamily: fontFamily
        }), className), "data-testid": dataTestId, onClick: onClick }, { children: children })));
};
var button = style({
    height: px(30),
    width: px(30),
    borderRadius: percent(100),
    cursor: 'pointer',
    background: color(Colours.lightestBlue).fadeOut(0.5).toString(),
    $nest: {
        '&.disabled': {
            cursor: 'default'
        },
        '&:not(.disabled):active:hover': {
            transform: scale(0.9),
            transition: 'none'
        }
    },
    transition: '0.1s ease-out',
    userSelect: 'none'
});

var FeedingAutomation = function (_a) {
    var disabled = _a.disabled, strategy = _a.strategy, strategies = _a.strategies, scenario = _a.scenario, scenarios = _a.scenarios, negativeExit = _a.negativeExit, positiveExitCount = _a.positiveExitCount, negativeExitCount = _a.negativeExitCount, positiveExit = _a.positiveExit, positiveWaiting = _a.positiveWaiting, negativeWaiting = _a.negativeWaiting, synced = _a.synced, fullHeight = _a.fullHeight, selectInputMaxHeight = _a.selectInputMaxHeight, selectInputMenuPlacement = _a.selectInputMenuPlacement, onStrategyChange = _a.onStrategyChange, onScenarioChange = _a.onScenarioChange;
    return (jsxs(Vertical, __assign({ spacing: rem(0.5), className: style({ fontFamily: fontFamily }), sizing: fullHeight ? 'stretch' : 'content', "data-testid": "feeding-automation" }, { children: [jsxs(Vertical, __assign({ spacing: rem(0.5), "data-testid": "feeding-automation-dropdowns" }, { children: [jsx(Content, __assign({ className: style({ color: Colours.textLight }) }, { children: "Strategy" })), jsx(SelectInput, { menuPlacement: selectInputMenuPlacement, maxMenuHeight: selectInputMaxHeight, transparent: true, readonly: disabled, onChange: function (o) { return onStrategyChange(o.value); }, options: strategies, value: [strategy] }), jsx(SelectInput, { menuPlacement: selectInputMenuPlacement, maxMenuHeight: selectInputMaxHeight, transparent: true, readonly: disabled, onChange: function (o) { return onScenarioChange(o.value); }, options: scenarios, value: [scenario] })] })), fullHeight && jsx(StretchSpacer, {}), jsxs(Vertical, __assign({ spacing: rem(0.5), "data-testid": "feeding-automation-next-scenarios-container" }, { children: [jsxs(Horizontal, __assign({ spacing: rem(0.5), className: style({ color: Colours.textLight }), verticalAlign: "center" }, { children: [jsx(Content, { children: "Next" }), jsx(Box, { height: px(8), width: px(8), className: style({
                                    background: synced ? Colours.green : Colours.orange,
                                    borderRadius: percent(50)
                                }) })] })), jsx(NextScenario, { count: positiveExitCount, value: positiveExit, scenarios: scenarios, icon: faPlus, color: Colours.green, waiting: positiveWaiting }), jsx(NextScenario, { count: negativeExitCount, value: negativeExit, scenarios: scenarios, icon: faMinus, color: Colours.red, waiting: negativeWaiting })] }))] })));
};
var NextScenario = function (_a) {
    var icon = _a.icon, waiting = _a.waiting, color = _a.color, value = _a.value, scenarios = _a.scenarios, count = _a.count;
    return (jsxs(Horizontal, __assign({ verticalAlign: "bottom", spacing: rem(1), "data-testid": "feeding-automation-next-scenario" }, { children: [jsx(SelectInput, { transparent: true, onChange: function () { }, options: scenarios, value: [value], disabled: true }), jsx(Content, __assign({ height: percent(100), verticalAlign: "center", horizontalAlign: "right", width: px(20), className: style({ fontFamily: fontFamily, color: Colours.textLight }) }, { children: count || '-/-' })), jsx(Content, __assign({ height: percent(100), verticalAlign: "center" }, { children: waiting ? (jsx(CircleCountdown, { isPlaying: true, duration: waiting, onComplete: function () { }, color: Colours.primary, width: 18 })) : (jsx(Icon, { icon: icon, color: color })) }))] })));
};

var getDiffInMinutes = function (a, b) {
    return moment(b, 'HH:mm').diff(moment(a, '"HH:mm"'), 'minutes');
};
var getDiffInSeconds = function (a, b) {
    return moment(b, 'HH:mm:ss').diff(moment(a, '"HH:mm:ss"'), 'seconds');
};

var FeedLineRange = function (_a) {
    var isInEditMode = _a.isInEditMode, startTime = _a.startTime, endTime = _a.endTime, schedules = _a.schedules, selectedScheduleIndex = _a.selectedScheduleIndex, onChange = _a.onChange, onScheduleSelect = _a.onScheduleSelect;
    var _b = useState(false), isEditing = _b[0], setIsEditing = _b[1];
    var _c = useState(-1), scheduleIdHovered = _c[0], setIsScheduleIdHovered = _c[1];
    var _d = useState(), editingSchedule = _d[0], setEditingSchedule = _d[1];
    var _e = useState(schedules), internalSchedules = _e[0], setInternalSchedules = _e[1];
    useEffect(function () {
        setInternalSchedules(schedules);
    }, [schedules]);
    var handleEdit = useCallback(function (slotStartTime, index) {
        var isBefore = editingSchedule &&
            slotStartTime.isBefore(moment(editingSchedule.startTime, 'HH:mm'));
        if (isBefore)
            return;
        setEditingSchedule(function (s) { return ({
            startTime: (s === null || s === void 0 ? void 0 : s.startTime) || slotStartTime.format('HH:mm'),
            endTime: moment(slotStartTime).add(5, 'minutes').format('HH:mm'),
            percentageTotal: (s === null || s === void 0 ? void 0 : s.percentageTotal) || 0,
            visits: (s === null || s === void 0 ? void 0 : s.visits) || 0
        }); });
    }, [
        internalSchedules,
        editingSchedule,
        setInternalSchedules,
        setEditingSchedule
    ]);
    var handleDelete = function (slotStartTime) {
        var scheduleIndex = internalSchedules.findIndex(function (s) {
            return slotStartTime.isBetween(moment(s.startTime, 'HH:mm'), moment(s.endTime, 'HH:mm'), undefined, '[)');
        });
        if (scheduleIndex !== -1) {
            setInternalSchedules(function (s) {
                s.splice(scheduleIndex, 1);
                return __spreadArray([], s, true);
            });
        }
        onChange(internalSchedules);
    };
    var handleMouseUp = function () {
        if (isEditing) {
            var nonConflictingSchedules = internalSchedules.filter(function (internal) {
                var internalStartsInsideNew = moment(internal.startTime, 'HH:mm').isSameOrAfter(moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.startTime, 'HH:mm')) &&
                    moment(internal.startTime, 'HH:mm').isSameOrBefore(moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.endTime, 'HH:mm'));
                var internalEndsInsideNew = moment(internal.endTime, 'HH:mm').isSameOrAfter(moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.startTime, 'HH:mm')) &&
                    moment(internal.endTime, 'HH:mm').isSameOrBefore(moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.endTime, 'HH:mm'));
                var newStartsInsideInternal = moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.startTime, 'HH:mm').isSameOrAfter(moment(internal.startTime, 'HH:mm')) &&
                    moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.startTime, 'HH:mm').isSameOrBefore(moment(internal.endTime, 'HH:mm'));
                var newEndsInsideInternal = moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.endTime, 'HH:mm').isSameOrAfter(moment(internal.startTime, 'HH:mm')) &&
                    moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.endTime, 'HH:mm').isSameOrBefore(moment(internal.endTime, 'HH:mm'));
                var hasConflict = internalStartsInsideNew ||
                    internalEndsInsideNew ||
                    newStartsInsideInternal ||
                    newEndsInsideInternal;
                return !hasConflict;
            });
            var s = editingSchedule
                ? __spreadArray(__spreadArray([], nonConflictingSchedules, true), [editingSchedule], false) : internalSchedules;
            setIsEditing(false);
            setInternalSchedules(s);
            onChange(s);
            setEditingSchedule(undefined);
        }
    };
    var slots = useMemo(function () {
        var numOfFiveMinuteSlots = getDiffInMinutes(startTime, endTime) / 5;
        return Array.from({ length: numOfFiveMinuteSlots }, function (_, i) { return ({
            startTime: moment(startTime, 'HH:mm').add(i * 5, 'minutes'),
            endTime: moment(startTime, 'HH:mm').add((i + 1) * 5, 'minutes')
        }); });
    }, [startTime, endTime]);
    return (jsx(Horizontal, __assign({ "data-testid": FEED_LINE_RANGE, sizing: "stretch", width: percent(100), spacing: 0, className: style({ background: Colours.darkBlue }), padding: [px(2), 0, px(4), 0], onMouseLeave: function () {
            if (isEditing) {
                var s = editingSchedule
                    ? __spreadArray(__spreadArray([], internalSchedules, true), [editingSchedule], false) : internalSchedules;
                setIsEditing(false);
                setInternalSchedules(s);
                onChange(s);
                setEditingSchedule(undefined);
            }
        } }, { children: slots.map(function (slot, i) {
            var schedulesList = editingSchedule
                ? __spreadArray(__spreadArray([], internalSchedules, true), [editingSchedule], false) : internalSchedules;
            var isSet = getIsSlotWithinSchedule(slot.startTime, schedulesList);
            var isALastSlot = getIsSlotLastInSchedule(slot.startTime, schedulesList);
            var scheduleNumber = getSlotScheduleNumber(slot.startTime, schedulesList);
            var isStartOfSchedule = schedulesList.some(function (s) { return s.startTime === slot.startTime.format('HH:mm'); });
            return (jsx(Slot, { isBeingSet: slot.startTime.isBetween(moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.startTime, 'HH:mm'), moment(editingSchedule === null || editingSchedule === void 0 ? void 0 : editingSchedule.endTime, 'HH:mm'), undefined, '[)'), isLastSlot: scheduleNumber === scheduleIdHovered && isALastSlot, isInEditMode: isInEditMode, isSelected: selectedScheduleIndex === scheduleNumber, startTime: slot.startTime.format('HH:mm'), isEditing: isEditing, isSet: isSet, isStartOfSchedule: isStartOfSchedule, onClickSchedule: function () { return onScheduleSelect(scheduleNumber); }, onMouseDown: function (e) {
                    e.preventDefault();
                    if (e.button === 0) {
                        !isEditing && setIsEditing(true);
                        handleEdit(slot.startTime, i);
                    }
                }, onMouseOver: function (e) {
                    e.preventDefault();
                    if (e.button === 0) {
                        isEditing && handleEdit(slot.startTime, i);
                    }
                    setIsScheduleIdHovered(scheduleNumber);
                }, onMouseUp: function (e) {
                    e.preventDefault();
                    if (e.button === 0) {
                        handleMouseUp();
                    }
                }, onContextMenu: function (e) {
                    if (!isInEditMode)
                        return;
                    e.preventDefault();
                    handleDelete(slot.startTime);
                } }, i));
        }) })));
};
var Slot = function (_a) {
    var startTime = _a.startTime, isSet = _a.isSet, isStartOfSchedule = _a.isStartOfSchedule, isEditing = _a.isEditing, isInEditMode = _a.isInEditMode, isLastSlot = _a.isLastSlot, isSelected = _a.isSelected, isBeingSet = _a.isBeingSet, onMouseDown = _a.onMouseDown, onMouseOver = _a.onMouseOver, onMouseUp = _a.onMouseUp, onContextMenu = _a.onContextMenu, onClickSchedule = _a.onClickSchedule;
    var _b = useState(false), showTime = _b[0], setShowTime = _b[1];
    return (jsxs(Stretch, __assign({ height: percent(100), className: style({
            position: 'relative'
        }) }, { children: [isLastSlot && isInEditMode && (jsx(Box, __assign({ onClick: onClickSchedule, className: style({
                    cursor: 'pointer',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    zIndex: 1000000
                }) }, { children: jsx(Icon, { className: style({
                        width: px(22),
                        height: px(22)
                    }), icon: faCog, color: Colours.white }) }))), jsx(Stretch, { onMouseEnter: function (e) {
                    setShowTime(true);
                }, onMouseLeave: function (e) {
                    setShowTime(false);
                }, onMouseDown: isInEditMode ? onMouseDown : void 0, onMouseOver: isInEditMode ? onMouseOver : void 0, onMouseUp: isInEditMode ? onMouseUp : void 0, onContextMenu: onContextMenu, height: percent(100), width: percent(100), className: style({
                    position: 'relative',
                    background: isBeingSet
                        ? Colours.primaryLight
                        : isSelected
                            ? Colours.yellow
                            : isSet
                                ? Colours.primary
                                : Colours.darkBlue,
                    opacity: isSelected ? 1 : 0.7,
                    cursor: isInEditMode ? 'crosshair' : 'default',
                    $nest: {
                        '&:hover': {
                            background: isSet
                                ? isEditing
                                    ? Colours.primary
                                    : Colours.lightestBlue
                                : Colours.lightBlue
                        },
                        '&::before': isStartOfSchedule && isSet
                            ? {
                                content: "''",
                                position: 'absolute',
                                left: 0,
                                width: px(2),
                                height: percent(100),
                                background: Colours.darkBlue
                            }
                            : {}
                    }
                }) }), showTime && (jsx(Box, __assign({ className: style({
                    fontFamily: fontFamily,
                    position: 'absolute',
                    top: -42,
                    left: percent(50),
                    color: Colours.textLight,
                    transform: translateX(percent(-50))
                }) }, { children: startTime })))] })));
};
var getIsSlotWithinSchedule = function (slotStartTime, schedules) {
    return schedules.some(function (schedule) {
        return slotStartTime.isBetween(moment(schedule.startTime, 'HH:mm'), moment(schedule.endTime, 'HH:mm'), undefined, '[)');
    });
};
var getSlotScheduleNumber = function (slotStartTime, schedules) {
    return schedules.reduce(function (p, schedule, i) {
        return slotStartTime.isBetween(moment(schedule.startTime, 'HH:mm'), moment(schedule.endTime, 'HH:mm'), undefined, '[)')
            ? i
            : p;
    }, -1);
};
var getIsSlotLastInSchedule = function (slotStartTime, schedules) {
    return schedules.some(function (schedule) {
        return slotStartTime.isBetween(moment(schedule.startTime, 'HH:mm'), moment(schedule.endTime, 'HH:mm'), undefined, '[)') &&
            slotStartTime.isSameOrAfter(moment(schedule.endTime, 'HH:mm').subtract(5, 'minutes'));
    });
};
var FEED_LINE_RANGE = 'feed_line_range';

var FeedLineBar = function (_a) {
    var percentage = _a.percentage, readonly = _a.readonly, colored = _a.colored, onClick = _a.onClick;
    var validatedPercentage = Math.min(Math.max(percentage, 0), 1);
    var freeSlots = useMemo(function () {
        return Array.from(Array(Math.round(10 - Math.ceil(validatedPercentage * 10))).keys());
    }, [validatedPercentage]);
    var usedSlots = useMemo(function () { return Array.from(Array(Math.ceil(validatedPercentage * 10)).keys()); }, [validatedPercentage]);
    var barColour = useMemo(function () {
        var colour = Colours.primary;
        if (colored) {
            if (validatedPercentage >= 0.9) {
                colour = Colours.red;
            }
            else if (validatedPercentage >= 0.8) {
                colour = Colours.orange;
            }
            else if (validatedPercentage >= 0.5) {
                colour = Colours.yellow;
            }
        }
        return colour;
    }, [validatedPercentage, colored]);
    return (jsxs(Vertical, __assign({ spacing: 0, sizing: "stretch", padding: px(4), className: styles$6.container }, { children: [freeSlots.map(function (slot) { return (jsx(Content, { "data-testid": FEED_LINE_BAR_SLOT_TESTID, width: percent(100), height: percent(10), className: classes(styles$6.slot, readonly && 'readonly'), onClick: function () { return !readonly && (onClick === null || onClick === void 0 ? void 0 : onClick(1 - slot / 10)); } }, slot)); }), jsx(Vertical, __assign({ spacing: 0, tag: "div", style: {
                    height: percent(Math.ceil(validatedPercentage * 10) * 10),
                    background: barColour
                }, className: classes(styles$6.bar, validatedPercentage === 1 && 'full'), width: percent(100), "data-testid": FEED_LINE_BAR_TESTID }, { children: usedSlots.map(function (slot, index) { return (jsx(Content, { "data-testid": FEED_LINE_BAR_SLOT_TESTID, width: percent(100), height: percent((1 / Math.ceil(validatedPercentage * 10)) * 100), className: classes(styles$6.slot, readonly && 'readonly'), onClick: function () {
                        return !readonly && (onClick === null || onClick === void 0 ? void 0 : onClick(Math.round(usedSlots.length - slot) / 10));
                    } }, slot)); }) }))] })));
};
var styles$6 = stylesheet({
    container: {
        height: px(100),
        background: Colours.darkBlue
    },
    slot: {
        overflow: 'hidden',
        transition: 'background ease 0.3s',
        cursor: 'pointer',
        $nest: {
            '&:hover': {
                background: Colours.lighterBlue
            },
            '&.readonly': {
                cursor: 'default',
                background: 'transparent'
            }
        }
    },
    bar: {
        borderTopLeftRadius: px(4),
        borderTopRightRadius: px(4),
        $nest: {
            '&.full': {
                borderTopLeftRadius: px(0),
                borderTopRightRadius: px(0)
            }
        }
    }
});
var FEED_LINE_BAR_SLOT_TESTID = 'feed-line-bar-slot';
var FEED_LINE_BAR_TESTID = 'feed-line-bar';

var FeedLineUtilizationChart = function (_a) {
    var transportTimePercentage = _a.transportTimePercentage, pens = _a.pens;
    return (jsx(Horizontal, __assign({ height: px(50), width: percent(100), className: styles$5.container, spacing: 0 }, { children: jsx(UtilizationChart, { pens: pens, transportTimePercentage: transportTimePercentage }) })));
};
var UtilizationChart = function (_a) {
    var pens = _a.pens, transportTimePercentage = _a.transportTimePercentage;
    var t = useTranslation().t;
    var _b = useState(), tooltipText = _b[0], setTooltipText = _b[1];
    var _c = useState(), hoveredBarCenter = _c[0], setHoveredBarCenter = _c[1];
    var _d = useState(-50), tooltipTranslateX = _d[0], setTooltipTranslateX = _d[1];
    var chartRef = useRef(null);
    var tooltipRef = useRef(null);
    var availabilityPercentage = useMemo(function () {
        return (1 -
            transportTimePercentage -
            pens.reduce(function (acc, a) { return acc + a.percentage; }, 0));
    }, [transportTimePercentage, pens]);
    var sortedPens = useMemo(function () {
        return pens.sort(function (a, b) {
            return a < b ? 1 : -1;
        });
    }, [pens]);
    // Sets Bar Center Point to place tooltip
    var handleMouseEnter = function (barRef, text) {
        setTooltipText(text);
        setHoveredBarCenter(barRef.offsetLeft + barRef.clientWidth / 2);
    };
    // Adjusts tooltip if it overflows
    useLayoutEffect(function () {
        var _a, _b, _c;
        var tooltipOverflowsLeft = (hoveredBarCenter || 0) - (((_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) < 0;
        var tooltipOverflowsRight = (hoveredBarCenter || 0) + (((_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0) >
            (((_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth) || 0);
        setTooltipTranslateX(tooltipOverflowsLeft ? 0 : tooltipOverflowsRight ? -100 : -50);
    }, [tooltipRef, hoveredBarCenter]);
    return (jsxs(Horizontal, __assign({ ref: chartRef, height: px(50), width: percent(100), className: styles$5.chart, spacing: 0, "data-testid": FEED_LINE_COMPARISON_CHART_TESTID }, { children: [jsx(ChartBar, { color: Colours.darkPurple, id: FEED_LINE_UTILIZATION_TRANSPORT_TIME_TESTID, percentage: transportTimePercentage, onMouseEnter: function (e) {
                    return handleMouseEnter(e.currentTarget, t('Transport time'));
                }, onMouseLeave: function () { return setTooltipText(undefined); } }), sortedPens.map(function (p, index) { return (jsx(ChartBar, { color: Colours.primary, id: FEED_LINE_UTILIZATION_PEN_TESTID, percentage: p.percentage, onMouseLeave: function () { return setTooltipText(undefined); }, onMouseEnter: function (e) { return handleMouseEnter(e.currentTarget, p.name); } }, index)); }), jsx(ChartBar, { id: FEED_LINE_UTILIZATION_AVAILABLE_TESTID, color: Colours.green, percentage: availabilityPercentage, onMouseLeave: function () { return setTooltipText(undefined); }, onMouseEnter: function (e) {
                    return handleMouseEnter(e.currentTarget, t('Availability'));
                } }), tooltipText && (jsx(Content, __assign({ ref: tooltipRef, className: classes(styles$5.tooltip, style({
                    top: percent(50),
                    left: hoveredBarCenter,
                    transform: translate(percent(tooltipTranslateX), percent(-50))
                })) }, { children: tooltipText })))] })));
};
var ChartBar = function (_a) {
    var id = _a.id, color = _a.color, percentage = _a.percentage, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return (jsx(Box, { "data-testid": id, className: style({ background: color, position: 'relative' }), height: percent(100), style: {
            width: percent(Math.round(Math.min(Math.max(percentage * 100, 0), 100)))
        }, onMouseOver: onMouseEnter, onMouseLeave: onMouseLeave }));
};
var FEED_LINE_COMPARISON_CHART_TESTID = 'feed-line-comparison-chart';
var styles$5 = stylesheet({
    container: {
        borderRadius: px(8),
        overflow: 'hidden',
        background: Colours.blue
    },
    chart: {
        position: 'relative',
        $nest: {
            '& > *': {
                boxSizing: 'border-box',
                $nest: {
                    '&:not(:first-child)': {
                        borderLeft: "2px solid ".concat(Colours.blue)
                    }
                }
            }
        }
    },
    tooltip: {
        pointerEvents: 'none',
        position: 'absolute',
        backgroundColor: color(Colours.blue).fade(0.9).toRGBA().toString(),
        padding: padding(rem(0.5), rem(1)),
        fontFamily: fontFamily,
        borderRadius: px(8),
        color: Colours.textLight
    }
});
var FEED_LINE_UTILIZATION_TRANSPORT_TIME_TESTID = 'feed-line-utilization-chart-transport-time';
var FEED_LINE_UTILIZATION_PEN_TESTID = 'feed-line-utilization-chart-pen';
var FEED_LINE_UTILIZATION_AVAILABLE_TESTID = 'feed-line-utilization-chart-available';

var FeedLineComparisonChart = function (_a) {
    var topLine = _a.topLine, bottomLine = _a.bottomLine;
    return (jsxs(Vertical, __assign({ spacing: px(1), width: percent(100), className: container }, { children: [jsx(UtilizationChart, { pens: topLine.pens, transportTimePercentage: topLine.transportTimePercentage }), jsx(UtilizationChart, { pens: bottomLine.pens, transportTimePercentage: bottomLine.transportTimePercentage })] })));
};
var container = style({
    borderRadius: px(8),
    overflow: 'hidden',
    background: Colours.blue
});

var FeedLineDayUtilization = function (_a) {
    var feedLines = _a.feedLines, selectedFeedLine = _a.selectedFeedLine, bars = _a.bars, startTime = _a.startTime, endTime = _a.endTime, _b = _a.plannedFeed, plannedFeed = _b === void 0 ? 0 : _b, _c = _a.expectedFeed, expectedFeed = _c === void 0 ? 0 : _c, feedUnit = _a.feedUnit, overshoot = _a.overshoot, onFeedLineChange = _a.onFeedLineChange, onTimeRangeChange = _a.onTimeRangeChange, onOvershootChange = _a.onOvershootChange;
    var t = useTranslation().t;
    var sortedBars = useMemo(function () {
        return bars.sort(function (a, b) {
            var aTime = moment(a.time, config.format.time);
            var bTime = moment(b.time, config.format.time);
            return aTime.isBefore(bTime) ? -1 : 1;
        });
    }, [bars]);
    var getPlannedFeedErrors = useCallback(function () {
        if (!plannedFeed)
            return [];
        // calculate how much plannedFeed varies from expectedFeed in percentage
        var percDifference = Math.abs(Math.round(((plannedFeed - expectedFeed) / expectedFeed) * 100));
        if (plannedFeed > expectedFeed * (1 + overshoot)) {
            return [t('Planned feed is X% above expected', { percDifference: percDifference })];
        }
        if (plannedFeed < expectedFeed * (1 - overshoot)) {
            return [t('Planned feed is X% below expected', { percDifference: percDifference })];
        }
        return [];
    }, [plannedFeed, expectedFeed, overshoot, t]);
    return (jsxs(Vertical, __assign({ spacing: rem(1), width: percent(100), className: styles$4.container, padding: [px(8), px(16), px(20), px(16)] }, { children: [jsxs(Grid, __assign({ justify: "right", spacing: rem(1) }, { children: [jsx(Box, __assign({ width: rem(10) }, { children: jsx(SelectInput, { transparent: true, options: feedLines.map(function (l) { return ({ value: l, label: l }); }), value: [selectedFeedLine], onChange: function (o) { return onFeedLineChange(o.value); } }) })), jsx(Horizontal, __assign({ verticalAlign: "top", width: rem(12) }, { children: jsx(TimeRangePicker, { label: t('Schedule'), onChange: onTimeRangeChange, startTime: startTime, endTime: endTime }) })), jsx(Horizontal, __assign({ verticalAlign: "top", width: em(9) }, { children: jsx(NumberInput, { label: t('Overshoot'), labelPosition: "left", value: overshoot * 100, max: 100, suffix: "%", onChange: onOvershootChange }) })), jsx(StretchSpacer, {}), jsx(Horizontal, __assign({ verticalAlign: "top", maxWidth: rem(11) }, { children: jsx(TextInput, { id: FEED_LINE_DAY_PLANNED_FEED_TESTID, readonly: true, transparent: true, label: t('Planned'), labelPosition: "left", value: (feedUnit === 'g'
                                ? plannedFeed
                                : plannedFeed / 1000).toFixed(feedUnit === 'g' ? 0 : 2), suffix: feedUnit, onChange: function () { }, errors: getPlannedFeedErrors() }) })), jsx(Horizontal, __assign({ verticalAlign: "top", maxWidth: rem(11) }, { children: jsx(TextInput, { id: FEED_LINE_DAY_EXPECTED_FEED_TESTID, readonly: true, transparent: true, label: t('Target'), labelPosition: "left", value: (feedUnit === 'g'
                                ? expectedFeed
                                : expectedFeed / 1000).toFixed(feedUnit === 'g' ? 0 : 2), suffix: feedUnit, onChange: function () { } }) }))] })), jsx(Horizontal, __assign({ spacing: px(2), height: px(140), width: percent(100) }, { children: sortedBars.map(function (bar, index) { return (jsxs(Vertical, __assign({ sizing: "stretch", spacing: px(8), "data-testid": FEED_LINE_DAY_BAR_TESTID }, { children: [jsx(FeedLineBar, { percentage: bar.percentage, readonly: true, colored: true }), jsx(Content, __assign({ className: style({
                                color: Colours.textDark,
                                fontFamily: fontFamily,
                                fontSize: Sizes.fontSize2
                            }) }, { children: bar.time }))] }), "".concat(bar.time, "-").concat(index))); }) }))] })));
};
var styles$4 = stylesheet({
    container: {
        boxSizing: 'border-box',
        background: Colours.darkerBlue,
        borderRadius: Sizes.borderRadius
    }
});
var FEED_LINE_DAY_BAR_TESTID = 'feed-line-day-util-bar';
var FEED_LINE_DAY_FEED_RATE_TESTID = 'feed-line-day-feed-rate';
var FEED_LINE_DAY_PLANNED_FEED_TESTID = 'feed-line-day-planned-feed';
var FEED_LINE_DAY_EXPECTED_FEED_TESTID = 'feed-line-day-expected-feed';

var FeedLineUtilizationBreakdown = function (_a) {
    var transportTimePercentage = _a.transportTimePercentage, pens = _a.pens;
    var t = useTranslation().t;
    var availabilityPercentage = useMemo(function () {
        return (1 -
            transportTimePercentage -
            pens.reduce(function (acc, a) { return acc + a.percentage; }, 0));
    }, [transportTimePercentage, pens]);
    var sortedPens = useMemo(function () {
        return pens.sort(function (a, b) {
            var aPercentage = a.percentage;
            var bPercentage = b.percentage;
            return aPercentage < bPercentage ? 1 : -1;
        });
    }, [pens]);
    return (jsxs(Horizontal, __assign({ spacing: rem(1), width: percent(100) }, { children: [jsxs(Vertical, __assign({ sizing: "stretch", spacing: rem(1), width: percent(100) }, { children: [jsx(Bar, { id: FEED_LINE_BREAKDOWN_TRANSPORT_TIME_TESTID, colour: Colours.darkPurple, percentage: transportTimePercentage }), sortedPens.map(function (p) { return (jsx(Bar, { id: FEED_LINE_BREAKDOWN_PEN_TESTID, colour: Colours.primary, percentage: p.percentage }, p.name)); }), jsx(Bar, { id: FEED_LINE_BREAKDOWN_AVAILABLE_TESTID, colour: Colours.green, percentage: availabilityPercentage })] })), jsxs(Vertical, __assign({ spacing: rem(1) }, { children: [jsx(Content, __assign({ verticalAlign: "center", horizontalAlign: "right", height: px(40), className: style({ fontFamily: fontFamily, color: Colours.textLight }) }, { children: t('Transport time') })), sortedPens.map(function (p) { return (jsx(Content, __assign({ verticalAlign: "center", horizontalAlign: "right", height: px(40), className: style({ fontFamily: fontFamily, color: Colours.textLight }) }, { children: p.name }))); }), jsx(Content, __assign({ verticalAlign: "center", horizontalAlign: "right", height: px(40), className: style({ fontFamily: fontFamily, color: Colours.textLight }) }, { children: t('Availability') }))] }))] })));
};
var Bar = function (_a) {
    var id = _a.id, colour = _a.colour, percentage = _a.percentage;
    return (jsxs(Horizontal, __assign({ width: percent(100), verticalAlign: "center" }, { children: [jsx(Box, { "data-testid": id, className: classes(style({ background: colour }), barStyle), height: px(40), style: {
                    width: percent(Math.round(Math.min(Math.max(percentage * 100, 0), 100)))
                } }), jsx(StretchSpacer, {})] })));
};
var barStyle = style({
    borderTopRightRadius: px(8),
    borderBottomRightRadius: px(8)
});
var FEED_LINE_BREAKDOWN_TRANSPORT_TIME_TESTID = 'breakdown-transport-time';
var FEED_LINE_BREAKDOWN_PEN_TESTID = 'breakdown-pen';
var FEED_LINE_BREAKDOWN_AVAILABLE_TESTID = 'breakdown-available';

var BAR_HEIGHT = px(22);
var VisitsChart = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, visits = _a.visits, transportTimeSec = _a.transportTimeSec, feedUnit = _a.feedUnit, highlightCurrentVisit = _a.highlightCurrentVisit;
    var totalMinutes = getDiffInMinutes(startTime, endTime);
    var _b = useState(), hoveredBarCenter = _b[0], setHoveredBarCenter = _b[1];
    var _c = useState(-50), tooltipTranslateX = _c[0], setTooltipTranslateX = _c[1];
    var _d = useState(), tooltipText = _d[0], setTooltipText = _d[1];
    var chartRef = useRef(null);
    var tooltipRef = useRef(null);
    // Sets Bar Center Point to place tooltip
    var handleMouseEnter = function (barRef, text) {
        setTooltipText(text);
        setHoveredBarCenter(barRef.offsetLeft + barRef.clientWidth / 2);
    };
    // Adjusts tooltip if it overflows
    useLayoutEffect(function () {
        var _a, _b, _c;
        var tooltipOverflowsLeft = (hoveredBarCenter || 0) - (((_a = tooltipRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) || 0) < 0;
        var tooltipOverflowsRight = (hoveredBarCenter || 0) + (((_b = tooltipRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth) || 0) >
            (((_c = chartRef.current) === null || _c === void 0 ? void 0 : _c.clientWidth) || 0);
        setTooltipTranslateX(tooltipOverflowsLeft ? 0 : tooltipOverflowsRight ? -100 : -50);
    }, [tooltipRef, hoveredBarCenter]);
    return (jsxs(Horizontal, __assign({ spacing: 0, height: BAR_HEIGHT, width: percent(100), ref: chartRef, className: style({
            background: Colours.darkBlue,
            position: 'relative',
            boxSizing: 'border-box',
            borderTop: "4px solid ".concat(Colours.darkBlue)
        }) }, { children: [visits.map(function (v, i) {
                var isHighlighted = moment().isBetween(moment(v.startTime, 'HH:mm'), moment(v.endTime, 'HH:mm')) && highlightCurrentVisit;
                return (jsxs(Horizontal, __assign({ spacing: 0, height: percent(100), width: percent(getWidth(totalMinutes, getDiffInMinutes(v.startTime, v.endTime))), className: style({
                        left: percent(getStartPositionPercent(startTime, endTime, v.startTime)),
                        position: 'absolute',
                        borderLeft: "1px solid ".concat(Colours.blue),
                        borderRight: "1px solid ".concat(Colours.blue),
                        boxSizing: 'border-box'
                    }), onMouseEnter: function (e) {
                        return handleMouseEnter(e.currentTarget, (v.doseGrams / (feedUnit === 'kg' ? 1000 : 1)).toFixed(2) +
                            feedUnit);
                    }, onMouseLeave: function () { return setTooltipText(undefined); } }, { children: [jsx(Box, { className: style({
                                background: Colours.darkPurple,
                                borderRight: "1px solid ".concat(Colours.blue),
                                boxSizing: 'border-box'
                            }), height: percent(100), width: getWidth(totalMinutes, transportTimeSec / 60) }), jsx(Stretch, { className: style({
                                background: isHighlighted ? Colours.orange : Colours.primary,
                                boxShadow: isHighlighted ? "0 0 6px ".concat(Colours.orange) : ''
                            }), height: percent(100), minWidth: px(1) })] }), i));
            }), tooltipText && (jsx(Content, __assign({ ref: tooltipRef, className: classes(style({
                    pointerEvents: 'none',
                    position: 'absolute',
                    backgroundColor: color(Colours.blue)
                        .fade(0.9)
                        .toRGBA()
                        .toString(),
                    padding: padding(rem(0.5), rem(1)),
                    fontFamily: fontFamily,
                    borderRadius: px(8),
                    color: Colours.textLight,
                    zIndex: 10
                }), style({
                    top: percent(50),
                    left: hoveredBarCenter,
                    transform: translate(percent(tooltipTranslateX), percent(-50))
                })) }, { children: tooltipText })))] })));
};
var getStartPositionPercent = function (startTime, endTime, visitStartTime) {
    var totalMinutes = getDiffInMinutes(startTime, endTime);
    var visitStartTimeInMinutes = getDiffInMinutes(startTime, visitStartTime);
    return (visitStartTimeInMinutes * 100) / totalMinutes;
};
var getWidth = function (totalMinutes, time) {
    var width = Math.max(0, Math.min(100, (time * 100) / totalMinutes));
    return width;
};

var PenUtilizationFooter = function (_a) {
    var _b, _c, _d;
    var selectedSchedule = _a.selectedSchedule, maxPercentageTotal = _a.maxPercentageTotal, onSelectedScheduleChange = _a.onSelectedScheduleChange, onCancel = _a.onCancel;
    var _e = useState(), editedSchedule = _e[0], setEditedSchedule = _e[1];
    useEffect(function () {
        if (selectedSchedule) {
            setEditedSchedule(__assign({}, selectedSchedule));
        }
    }, [selectedSchedule]);
    var handleVisitsChange = function (visits) {
        if (editedSchedule || selectedSchedule) {
            var schedule = __assign({}, (editedSchedule || selectedSchedule));
            schedule.visits = visits;
            setEditedSchedule(schedule);
        }
    };
    var handlesPercentageTotal = function (percentageTotal) {
        if (editedSchedule || selectedSchedule) {
            var schedule = __assign({}, (editedSchedule || selectedSchedule));
            schedule.percentageTotal =
                percentageTotal !== undefined
                    ? (percentageTotal || 0) / 100
                    : undefined;
            setEditedSchedule(schedule);
        }
    };
    if (!selectedSchedule)
        return null;
    return (jsxs(Horizontal$1, __assign({ verticalAlign: "center", spacing: rem(1) }, { children: [jsx(Horizontal$1, __assign({ verticalAlign: "top", width: rem(8) }, { children: jsx(NumberInput, { id: PEN_VISITS_PER_DATE_TESTID, fullWidth: true, label: t('Visits'), labelPosition: "left", value: (_b = (editedSchedule || selectedSchedule)) === null || _b === void 0 ? void 0 : _b.visits, onChange: function (v) { return handleVisitsChange(v); } }) })), jsx(Horizontal$1, __assign({ verticalAlign: "top", width: rem(11) }, { children: jsx(NumberInput, { id: PEN_VISITS_PER_DATE_TESTID, fullWidth: true, label: t('Percentage'), labelPosition: "left", suffix: "/ ".concat((maxPercentageTotal || 0) * 100, " %"), value: ((_c = (editedSchedule || selectedSchedule)) === null || _c === void 0 ? void 0 : _c.percentageTotal) !== undefined
                        ? (((_d = (editedSchedule || selectedSchedule)) === null || _d === void 0 ? void 0 : _d.percentageTotal) || 0) *
                            100
                        : undefined, max: maxPercentageTotal * 100, onChange: function (v) { return handlesPercentageTotal(v); } }) })), jsx(Button, { content: "Cancel", appearance: "red", size: "small", onClick: function () { return onCancel(); } }), jsx(Button, { content: "Confirm", appearance: "blue", size: "small", onClick: function () {
                    return editedSchedule &&
                        onSelectedScheduleChange(editedSchedule);
                }, disabled: !editedSchedule ||
                    editedSchedule.visits === undefined ||
                    editedSchedule.percentageTotal === undefined })] })));
};

var DEFAULT_MAX_VISITS_PER_DAY = 250;
var PenUtilizationHeader = function (_a) {
    var name = _a.name, withOrderControls = _a.withOrderControls, canOrderUp = _a.canOrderUp, canOrderDown = _a.canOrderDown, visitsPerDay = _a.visitsPerDay, feedRate = _a.feedRate, feedRateUnit = _a.feedRateUnit, plannedFeed = _a.plannedFeed, expectedFeed = _a.expectedFeed, growthTableTarget = _a.growthTableTarget, feedUnit = _a.feedUnit, maxVisitsPerDay = _a.maxVisitsPerDay, isInEditMode = _a.isInEditMode, onFeedNow = _a.onFeedNow, onOrderDown = _a.onOrderDown, onOrderUp = _a.onOrderUp, onVisitsPerDayChange = _a.onVisitsPerDayChange, onFeedRateChange = _a.onFeedRateChange, onTargetFeedChange = _a.onTargetFeedChange;
    var getPlannedFeedErrors = function () {
        var deviation = 0.05;
        var percDifference = Math.round((plannedFeed / expectedFeed) * 100);
        if (plannedFeed > expectedFeed * (1 + deviation)) {
            return [
                t("Planned feed is X% above expected", {
                    percDifference: percDifference - 100
                })
            ];
        }
        if (plannedFeed < expectedFeed * (1 - deviation)) {
            return [
                t("Planned feed is X% below expected", {
                    percDifference: 100 - percDifference
                })
            ];
        }
        return [];
    };
    var getTargetFeedOffsetNotifications = function () {
        var deviation = 0.02;
        var percDifference = Math.abs(Math.round((expectedFeed / growthTableTarget) * 100) - 100);
        // If the expected feed is more than 2% above or below the target, show a notification
        if (expectedFeed > growthTableTarget * (1 + deviation)) {
            return [
                t("Target is X% above table target YZ", {
                    target: growthTableTarget,
                    percDifference: percDifference,
                    unit: feedUnit
                })
            ];
        }
        // If the expected feed is more than 2% above or below the target, show a notification
        if (expectedFeed < growthTableTarget * (1 - deviation)) {
            return [
                t("Target is X% below table target YZ", {
                    target: growthTableTarget,
                    unit: feedUnit,
                    percDifference: percDifference
                })
            ];
        }
        return [];
    };
    return (jsxs(Grid, __assign({ spacing: [rem(1), rem(2)] }, { children: [jsxs(Horizontal, __assign({ padding: [rem(0.5), 0, 0, 0], spacing: rem(1), verticalAlign: "top" }, { children: [withOrderControls && (jsxs(Vertical, __assign({ spacing: 0, "data-testid": "pen-utilization-header-controls", className: style({
                            visibility: isInEditMode ? 'visible' : 'hidden'
                        }) }, { children: [jsx(Box, __assign({ height: 14, onClick: function () { return canOrderUp && (onOrderUp === null || onOrderUp === void 0 ? void 0 : onOrderUp()); }, "data-testid": "pen-utilization-header-order-up" }, { children: canOrderUp && (jsx(Icon, { icon: faCaretUp, color: Colours.textLight, className: style({ height: px(14), cursor: 'pointer' }) })) })), jsx(Box, __assign({ height: 14, onClick: function () { return canOrderDown && (onOrderDown === null || onOrderDown === void 0 ? void 0 : onOrderDown()); }, "data-testid": "pen-utilization-header-order-down" }, { children: canOrderDown && (jsx(Icon, { icon: faCaretDown, color: Colours.textLight, className: style({ height: px(14), cursor: 'pointer' }) })) }))] }))), jsx(Heading, __assign({ size: 3, "data-testid": PEN_NAME_TESTID, className: style({ lineHeight: rem(2) }) }, { children: name })), !isInEditMode && (jsx(Button, { icon: faPlayCircle, size: "small", content: "Feed now", appearance: "hollow-blue", onClick: onFeedNow }))] })), jsxs(Fragment, { children: [jsx(Horizontal, __assign({ height: rem(3), verticalAlign: "top", width: rem(11) }, { children: jsx(NumberInput, { id: PEN_VISITS_PER_DATE_TESTID, fullWidth: true, label: t('Visits per day'), labelPosition: "left", value: visitsPerDay, min: 0, max: maxVisitsPerDay || DEFAULT_MAX_VISITS_PER_DAY, onChange: function (v) { return onVisitsPerDayChange(Number(v) || undefined); }, readonly: true }) })), jsx(Horizontal, __assign({ verticalAlign: "top", width: rem(13) }, { children: jsx(NumberInput, { id: PEN_FEED_RATE_PER_AF_TESTID, label: t('Feed Rate'), labelPosition: "left", value: feedRate, suffix: feedRateUnit, onChange: onFeedRateChange, readonly: !isInEditMode }) }))] }), jsx(StretchSpacer, {}), jsxs(Horizontal, __assign({ height: rem(3), verticalAlign: "top" }, { children: [jsx(Box, __assign({ maxWidth: rem(14) }, { children: jsx(TextInput, { value: plannedFeed ? parseFloat(plannedFeed.toFixed(2)).toString() : '', onChange: function () { }, readonly: true, transparent: true, label: t('Planned feed'), labelPosition: "left", suffix: feedUnit, errors: getPlannedFeedErrors() }) })), jsx(Box, __assign({ maxWidth: rem(14) }, { children: jsx(NumberInput, { value: expectedFeed, label: t('Target feed'), labelPosition: "left", suffix: feedUnit, min: 0, onChange: function (v) {
                                onTargetFeedChange(Number(v) || undefined);
                            }, errors: getTargetFeedOffsetNotifications(), readonly: !isInEditMode }) }))] }))] })));
};

var PenUtilization = function (_a) {
    var startTime = _a.startTime, endTime = _a.endTime, name = _a.name, schedules = _a.schedules, visits = _a.visits, visitsPerDay = _a.visitsPerDay, feedRate = _a.feedRate, feedRateUnit = _a.feedRateUnit, plannedFeed = _a.plannedFeed, expectedFeed = _a.expectedFeed, growthTableTarget = _a.growthTableTarget, feedUnit = _a.feedUnit, transportTimeSec = _a.transportTimeSec, timeHighlightLine = _a.timeHighlightLine, withOrderControls = _a.withOrderControls, canOrderUp = _a.canOrderUp, canOrderDown = _a.canOrderDown, maxVisitsPerDay = _a.maxVisitsPerDay, isInEditMode = _a.isInEditMode, errors = _a.errors, onOrderUp = _a.onOrderUp, onOrderDown = _a.onOrderDown, onSchedulesChange = _a.onSchedulesChange, onVisitsPerDayChange = _a.onVisitsPerDayChange, onTargetFeedChange = _a.onTargetFeedChange, onFeedRateChange = _a.onFeedRateChange, onFeedNow = _a.onFeedNow;
    var interval = useRef();
    var _b = useState(), timeHighlightLineOffset = _b[0], setTimeHighlightLineOffset = _b[1];
    var _c = useState(), selectedScheduleIndex = _c[0], setSelectedScheduleIndex = _c[1];
    useEffect(function () {
        if (timeHighlightLine && !isInEditMode) {
            interval.current && window.clearInterval(interval.current);
            interval.current = window.setInterval(function () {
                var offset = getLeftOffsetFromTime(startTime, endTime, moment().format('HH:mm:ss'));
                setTimeHighlightLineOffset(offset);
            }, 1000);
        }
        else {
            interval.current && window.clearInterval(interval.current);
        }
        return function () {
            interval.current && window.clearInterval(interval.current);
        };
    }, [timeHighlightLine, isInEditMode, startTime, endTime, interval]);
    var selectedSchedule = useMemo(function () {
        return selectedScheduleIndex !== undefined
            ? schedules[selectedScheduleIndex]
            : undefined;
    }, [schedules, selectedScheduleIndex]);
    var handleScheduleVisitsChange = function (schedule) {
        if (selectedScheduleIndex !== undefined) {
            var newSchedules = __spreadArray([], schedules, true);
            newSchedules.splice(selectedScheduleIndex, 1, schedule);
            onSchedulesChange(newSchedules);
            setSelectedScheduleIndex(undefined);
        }
    };
    var maxPercentageTotal = useMemo(function () {
        return Math.max(0, 1 -
            schedules.reduce(function (acc, schedule) {
                return acc + (schedule.percentageTotal || 0);
            }, 0));
    }, [schedules]);
    return (jsxs(Vertical, __assign({ spacing: rem(1), width: percent(100), className: styles$3.container, padding: [px(16), px(16), px(12), px(16)] }, { children: [jsx(PenUtilizationHeader, { name: name, isInEditMode: isInEditMode, withOrderControls: withOrderControls, canOrderUp: canOrderUp, canOrderDown: canOrderDown, onOrderUp: onOrderUp, onOrderDown: onOrderDown, expectedFeed: expectedFeed, plannedFeed: plannedFeed, growthTableTarget: growthTableTarget, feedRate: feedRate, feedRateUnit: feedRateUnit, feedUnit: feedUnit, onFeedRateChange: onFeedRateChange, onTargetFeedChange: onTargetFeedChange, onVisitsPerDayChange: onVisitsPerDayChange, visitsPerDay: visitsPerDay, maxVisitsPerDay: maxVisitsPerDay, onFeedNow: onFeedNow }), jsxs(Vertical, __assign({ spacing: 0, className: style({ position: 'relative' }) }, { children: [jsxs(Vertical, __assign({ spacing: 0, height: px(isInEditMode ? 120 : 60), width: percent(100) }, { children: [jsx(VisitsChart, { feedUnit: feedUnit, startTime: startTime, endTime: endTime, visits: visits, transportTimeSec: transportTimeSec, highlightCurrentVisit: !!(timeHighlightLine && !isInEditMode) }), jsx(FeedLineRange, { isInEditMode: isInEditMode, startTime: startTime, endTime: endTime, schedules: schedules, onScheduleSelect: function (scheduleIndex) {
                                    return setSelectedScheduleIndex(scheduleIndex);
                                }, selectedScheduleIndex: selectedScheduleIndex, onChange: function (schedules) {
                                    onSchedulesChange(schedules);
                                    setSelectedScheduleIndex(undefined);
                                } })] })), timeHighlightLine && !isInEditMode && (jsx(Box, { "data-testid": 'time-highlight-line', height: percent(100), width: px(2), className: style({
                            background: Colours.yellow,
                            position: 'absolute',
                            left: percent(timeHighlightLineOffset || 0),
                            boxShadow: "0 0 6px ".concat(Colours.yellow),
                            pointerEvents: 'none'
                        }) }))] })), isInEditMode && (jsx(PenUtilizationFooter, { maxPercentageTotal: maxPercentageTotal + ((selectedSchedule === null || selectedSchedule === void 0 ? void 0 : selectedSchedule.percentageTotal) || 0), selectedSchedule: selectedSchedule, onSelectedScheduleChange: handleScheduleVisitsChange, onCancel: function () { return setSelectedScheduleIndex(undefined); } })), (errors === null || errors === void 0 ? void 0 : errors.length) && (jsx(Vertical, __assign({ spacing: rem(0.5) }, { children: errors.map(function (error) { return (jsxs(Content, __assign({ className: style({
                        color: Colours.red,
                        fontSize: px(12),
                        fontFamily: fontFamily
                    }) }, { children: ["\u00B7 ", error] }))); }) })))] })));
};
var getLeftOffsetFromTime = function (startTime, endTime, now) {
    var totalSeconds = getDiffInSeconds(startTime, endTime);
    var diffFromStartTimeInSeconds = getDiffInSeconds(startTime, now);
    return Math.max(0, Math.min((diffFromStartTimeInSeconds / totalSeconds) * 100, 100));
};
var styles$3 = stylesheet({
    container: {
        boxSizing: 'border-box',
        background: Colours.darkerBlue,
        borderRadius: Sizes.borderRadius
    }
});
var PEN_BAR_AMOUNT_TESTID = 'pen-bar-amount';
var PEN_BAR_REMOVE_TESTID = 'pen-bar-remove';
var PEN_NAME_TESTID = 'pen-name';
var PEN_VISITS_PER_DATE_TESTID = 'pen-visits-per-day';
var PEN_FEED_RATE_PER_AF_TESTID = 'pen-feed-rate-per-af';

var CircleCountdown = function (_a) {
    var _b = _a.width, width = _b === void 0 ? 20 : _b, color = _a.color, duration = _a.duration, isPlaying = _a.isPlaying, onComplete = _a.onComplete;
    var _c = useState(duration), time = _c[0], setTime = _c[1];
    useEffect(function () {
        if (time === 0 && duration > 0) {
            setTime(duration);
        }
    }, [duration]);
    return (jsx(CountdownCircleTimer, { onComplete: onComplete, isSmoothColorTransition: true, isPlaying: isPlaying, strokeWidth: width / 10, size: width, trailColor: '#ffffff00', colors: color, duration: time }));
};

var AccordionContext = createContext({
    openIds: [],
    toggle: function (_id) { }
});
var Accordion = React__default.memo(function (_a) {
    var allowsMultiple = _a.allowsMultiple, children = _a.children;
    var _b = useState([]), openIds = _b[0], setOpenIds = _b[1];
    var handleSetId = useCallback(function (id) {
        setOpenIds(function (ids) {
            if (ids.includes(id)) {
                return allowsMultiple ? ids.filter(function (el) { return el !== id; }) : [];
            }
            else {
                return allowsMultiple ? __spreadArray(__spreadArray([], ids, true), [id], false) : [id];
            }
        });
    }, [setOpenIds, allowsMultiple]);
    return (jsx(AccordionContext.Provider, __assign({ value: useMemo(function () { return ({
            openIds: openIds,
            toggle: handleSetId
        }); }, [openIds, handleSetId]) }, { children: children })));
});
var AccordionHeader = React__default.memo(function (_a) {
    var id = _a.id, hideCarret = _a.hideCarret, children = _a.children;
    var _b = useContext(AccordionContext), toggle = _b.toggle, openIds = _b.openIds;
    return (jsxs(Horizontal, __assign({ spacing: 0, verticalAlign: "center", width: percent(100), padding: [0, rem(0.5)] }, { children: [jsx(Horizontal, __assign({ sizing: "stretch" }, { children: children })), !hideCarret && (jsxs(Fragment, { children: [jsx(HorizontalSpacer, { space: px(10) }), jsx(Content, __assign({ "data-testid": "accordion-toggle", onClick: function (e) {
                            toggle(id);
                            e.stopPropagation();
                        }, className: style({ padding: padding(px(10), px(5)) }) }, { children: jsx(Icon, { icon: openIds.includes(id) ? faAngleUp : faAngleDown, className: style({
                                cursor: 'pointer'
                            }) }) }))] }))] })));
});
var AccordionContent = React__default.memo(function (_a) {
    var id = _a.id, children = _a.children;
    var openIds = useContext(AccordionContext).openIds;
    return (jsx("div", __assign({ role: 'accordion-content-' + id, style: { display: (openIds === null || openIds === void 0 ? void 0 : openIds.includes(id)) ? 'flex' : 'none' } }, { children: children })));
});
var useAccordionContext = function () {
    return useContext(AccordionContext);
};

var EventsTimelineEvent = React__default.memo(function (_a) {
    var event = _a.event, highlighted = _a.highlighted, onView = _a.onView;
    var eventRef = useRef(null);
    useEffect(function () {
        if (eventRef && highlighted) {
            setTimeout(function () {
                var _a;
                (_a = eventRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
            }, 500);
        }
    }, [eventRef, highlighted]);
    // remove parameters
    //e.g: video/mp4
    var isSrcVideo = event.url && isVideo(event.url);
    var eventTime = event.timestamp
        .split('T')[1]
        .split('+')[0]
        .split('-')[0]
        .split(':')
        .slice(0, 2)
        .join(':');
    return (jsxs(Horizontal, __assign({ spacing: 0, minHeight: px(30), padding: [0, rem(0.5), 0, 0], ref: eventRef, "data-testid": "timeline-event", className: style({ position: 'relative' }), width: percent(100) }, { children: [jsxs(Horizontal, __assign({ spacing: px(24), width: px(92) }, { children: [jsx(Box, __assign({ width: px(40), padding: [px(28), 0, 0, 0], className: styles$2.eventTime, "data-testid": "timeline-event-time" }, { children: eventTime })), jsxs(Vertical, __assign({ spacing: 0, height: percent(100), horizontalAlign: "center", width: px(36) }, { children: [jsxs(Box, __assign({ height: px(46), horizontalAlign: "center" }, { children: [jsx(EventLine, { highlighted: highlighted }), jsx(Box, { verticalAlign: "center", horizontalAlign: "center", height: px(highlighted ? 26 : 20), width: px(highlighted ? 26 : 20), className: classes(styles$2.eventIcon, style({
                                            backgroundColor: (event.color && Colours[event.color]) ||
                                                mapReasonToColour(event.reason)
                                        }), highlighted && 'highlighted') })] })), jsx(EventLine, { highlighted: highlighted })] }))] })), jsx(Vertical, __assign({ sizing: "stretch", width: percent(100), className: style({ position: 'relative' }), padding: rem(0.5), spacing: 0 }, { children: jsxs(Accordion, { children: [jsx(EventHeader, { id: event.id, event: event, onView: onView ? function () { return onView === null || onView === void 0 ? void 0 : onView(event.id); } : undefined }), jsx(Vertical, __assign({ sizing: "stretch", spacing: rem(1.5) }, { children: jsx(AccordionContent, __assign({ id: event.id }, { children: event.url &&
                                    (isSrcVideo ? (jsx("video", __assign({ width: percent(100), autoPlay: true, loop: true, muted: true, controls: true, className: style({
                                            minWidth: percent(100),
                                            zIndex: 0
                                        }) }, { children: jsx("source", { src: event.url + '#t=0.1', type: "video/mp4" }) }))) : (jsx("img", { alt: "event", src: event.url, className: style({
                                            width: percent(100),
                                            zIndex: 0
                                        }) }))) })) }))] }) }))] })));
});
var EventHeader = function (_a) {
    var event = _a.event, id = _a.id, onView = _a.onView;
    var openIds = useAccordionContext().openIds;
    var isOpen = openIds.includes(id);
    return (jsx(Horizontal, __assign({ className: !isOpen ? styles$2.header : '', padding: [0, rem(1), 0, 0] }, { children: jsx(AccordionHeader, __assign({ id: id, hideCarret: !event.url }, { children: jsxs(Horizontal, __assign({ width: percent(100), verticalAlign: "center", spacing: 0 }, { children: [jsxs(Vertical, __assign({ padding: rem(0.5), spacing: rem(0.5), className: style({ flexShrink: 1 }), sizing: "stretch" }, { children: [jsx(Box, __assign({ className: style({
                                    fontSize: Sizes.fontSize2,
                                    color: Colours.textDark
                                }) }, { children: event.title })), event.description && (jsx(Box, __assign({ className: style({ lineHeight: px(20) }) }, { children: event.description })))] })), onView && (jsx(Fragment, { children: jsx(Content, __assign({ width: px(30) }, { children: jsx(Box, __assign({ className: classes(!isOpen && style({ display: 'none' }), 'eye-button') }, { children: jsx(Button, { icon: faEye, iconColor: Colours.textLight, onClick: onView }) })) })) }))] })) })) })));
};
var mapReasonToColour = function (reason) {
    return ((reason &&
        {
            alert: Colours.red,
            test: Colours.red,
            oxygen_sensor_alert: Colours.orange,
            temperate_sensor_alert: Colours.orange,
            salinity_sensor_alert: Colours.orange,
            auto_automation_scenario_change: Colours.purple,
            manual_automation_scenario_change: Colours.orange,
            feeding_system_change: Colours.nileBlue,
            activity_change: Colours.green
        }[reason]) ||
        Colours.red);
};
var styles$2 = stylesheet({
    eventIcon: {
        borderRadius: px(16),
        color: Colours.textDark,
        $nest: {
            '&.highlighted': {
                boxShadow: "0px 0px 5px 1px ".concat(Colours.blue)
            }
        }
    },
    eventTime: {
        fontSize: Sizes.fontSize2,
        color: Colours.textDark
    },
    header: {
        $nest: {
            '&:hover': {
                borderRadius: Sizes.borderRadius,
                background: Colours.darkBlue,
                $nest: {
                    '& .eye-button': {
                        display: 'block'
                    }
                }
            }
        }
    },
    eyeButton: {
        $nest: {
            '&:hover': {
                borderRadius: Sizes.borderRadius,
                background: Colours.darkBlue
            }
        }
    },
    container: {
        $nest: {
            '&:hover::before': {
                zIndex: 0,
                content: "\"\"",
                position: 'absolute',
                width: percent(100),
                height: percent(100),
                border: "2px solid ".concat(Colours.lightBlue),
                top: 0,
                right: 0,
                borderRadius: Sizes.borderRadius
            },
            '&:hover .reveal-button': {
                display: 'block'
            }
        }
    }
});

var EventsTimeline = function (_a) {
    var events = _a.events, selectedEventTimestamp = _a.selectedEventTimestamp, onEventClick = _a.onEventClick;
    var eventsByDay = mapEventsByDay(events);
    return (jsx(Vertical, __assign({ padding: rem(1), spacing: 0, width: percent(100), className: style({ boxSizing: 'border-box', fontFamily: fontFamily }) }, { children: Object.keys(eventsByDay).map(function (day) {
            var _a;
            return (jsxs(Vertical, __assign({ spacing: 0, width: percent(100), className: style({ boxSizing: 'border-box' }) }, { children: [jsx(EventDaySeparator, { day: moment(day, config.format.date) }, day + '-separator'), jsx(Vertical, __assign({ spacing: 0, width: percent(100) }, { children: (_a = eventsByDay[day]) === null || _a === void 0 ? void 0 : _a.map(function (e, i) {
                            return (jsx(EventsTimelineEvent, { event: e, onView: onEventClick ? function (id) { return onEventClick === null || onEventClick === void 0 ? void 0 : onEventClick(id); } : undefined, highlighted: selectedEventTimestamp ===
                                    moment(e.timestamp).format(config.format.datetime) }, "".concat(e.id, "-").concat(e.timestamp)));
                        }) }))] }), day));
        }) })));
};
var EventDaySeparator = function (_a) {
    var day = _a.day;
    return (jsxs(Horizontal, __assign({ width: px(100), horizontalAlign: "right", height: px(60) }, { children: [jsxs(Vertical, __assign({ spacing: 0, padding: [px(4), 0, 0, 0], className: styles$1.eventTime, sizing: "stretch", height: percent(100) }, { children: [jsx(Box, __assign({ className: styles$1.weekDay }, { children: day.format('ddd') })), jsx(Box, { children: day.format('MMM') })] })), jsxs(Vertical, __assign({ spacing: 0, height: percent(100), horizontalAlign: "center", width: px(36) }, { children: [jsx(Box, __assign({ height: px(36), width: px(36), className: styles$1.dayBox, verticalAlign: "center", horizontalAlign: "center" }, { children: day.format('DD') })), jsx(EventLine, {})] }))] })));
};
var EventLine = function (_a) {
    var highlighted = _a.highlighted;
    return (jsx(Stretch, { className: classes(line, highlighted && 'highlighted'), width: px(2) }));
};
var line = style({
    background: Colours.blue,
    $nest: {
        '&.highlighted': {
            background: Colours.blue,
            boxShadow: "0px 0px 5px 1px ".concat(Colours.blue)
        }
    }
});
var mapEventsByDay = function (events) {
    var days = {};
    events.forEach(function (event) {
        var dayOfEvent = event.day;
        if (!days[dayOfEvent]) {
            days[dayOfEvent] = [event];
        }
        else {
            days[dayOfEvent].push(event);
        }
    });
    return days;
};
var styles$1 = stylesheet({
    eventTime: {
        fontSize: Sizes.fontSize2,
        color: Colours.textLight
    },
    dayBox: {
        background: Colours.lightestBlue,
        borderRadius: Sizes.borderRadius,
        fontWeight: 'bold',
        color: Colours.textLight
    },
    weekDay: {
        fontWeight: 'bold',
        color: Colours.textLight
    }
});

var ShowMore = function (_a) {
    var maxHeight = _a.maxHeight, children = _a.children;
    var t = useTranslation().t;
    var _b = useState(false), showMore = _b[0], setShowMore = _b[1];
    var _c = useState(0), height = _c[0], setHeight = _c[1];
    var handleShowMore = useCallback(function () {
        setShowMore(function (showMore) { return !showMore; });
    }, [setShowMore]);
    var handleHeightChange = useCallback(function (height) {
        setHeight(height);
    }, [setHeight]);
    return (jsxs(Vertical, __assign({ spacing: rem(0.5), className: style({
            fontFamily: fontFamily,
            width: percent(100),
            boxSizing: 'border-box'
        }) }, { children: [jsx(Box, __assign({ className: style({
                    maxHeight: showMore ? 'none' : px(maxHeight),
                    overflow: 'hidden'
                }), width: percent(100) }, { children: jsx(HeightObserver, __assign({ onHeightChange: handleHeightChange }, { children: children })) })), jsxs(Horizontal, __assign({ className: style({
                    visibility: height <= maxHeight ? 'hidden' : 'visible'
                }) }, { children: [jsx(StretchSpacer, {}), jsx(Content, __assign({ className: style({
                            padding: px(8),
                            cursor: 'pointer',
                            color: Colours.textLight,
                            fontSize: Sizes.fontSize2
                        }), onClick: handleShowMore }, { children: t(showMore ? 'Show less' : 'Show more') }))] }))] })));
};
//component that observes the height of its children and calls a callback when it changes
var HeightObserver = function (_a) {
    var _b;
    var onHeightChange = _a.onHeightChange, children = _a.children;
    var ref = useRef(null);
    useLayoutEffect(function () {
        if (ref.current) {
            onHeightChange(ref.current.offsetHeight);
        }
    }, [onHeightChange, (_b = ref.current) === null || _b === void 0 ? void 0 : _b.offsetHeight]);
    return (jsx("div", __assign({ ref: ref, className: style({
            width: percent(100)
        }) }, { children: children })));
};

var CollapsibleBreakdown = function (props) {
    var title = props.title, initiallyOpen = props.initiallyOpen, sortDirection = props.sortDirection, children = props.children, styles = props.styles, onSortDirectionChange = props.onSortDirectionChange, onCollapse = props.onCollapse;
    var _a = useState(initiallyOpen !== null && initiallyOpen !== void 0 ? initiallyOpen : true), isOpen = _a[0], setIsOpen = _a[1];
    return (jsx(Box, __assign({ className: style({
            overflow: 'hidden',
            maxHeight: isOpen ? percent(100) : 'none',
            flex: important(1)
        }) }, { children: jsxs(Vertical, __assign({ className: classes(componentStyles$1.container, style({
                background: (styles === null || styles === void 0 ? void 0 : styles.background) || Colours.darkBlue
            })), padding: rem(0.5), spacing: rem(1) }, { children: [jsx(CollapsibleBreakdownHeader, { isOpen: isOpen, title: title, sortDirection: sortDirection, onSortDirectionChange: onSortDirectionChange, onCollapse: function () {
                        setIsOpen(!isOpen);
                        onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!isOpen);
                    } }), jsx(Stretch, __assign({ padding: [rem(0.75), rem(0.75), 0, rem(0.75)], className: classes(style({
                        display: isOpen ? 'flex' : 'none'
                    }), scrollClass) }, { children: children }))] })) })));
};
var CollapsibleBreakdownHeader = function (props) {
    var title = props.title, sortDirection = props.sortDirection, isOpen = props.isOpen, onSortDirectionChange = props.onSortDirectionChange, onCollapse = props.onCollapse;
    var handleSortDirectionChange = function () {
        if (sortDirection === 'asc') {
            onSortDirectionChange === null || onSortDirectionChange === void 0 ? void 0 : onSortDirectionChange('desc');
        }
        else if (sortDirection === 'desc') {
            onSortDirectionChange === null || onSortDirectionChange === void 0 ? void 0 : onSortDirectionChange(null);
        }
        else {
            onSortDirectionChange === null || onSortDirectionChange === void 0 ? void 0 : onSortDirectionChange('asc');
        }
    };
    var getSortIcon = function () {
        if (sortDirection === 'asc') {
            return faSortUp;
        }
        else if (sortDirection === 'desc') {
            return faSortDown;
        }
        else {
            return faSort;
        }
    };
    return (jsxs(Horizontal, __assign({ height: rem(2.5), padding: [0, 0, 0, rem(1)], verticalAlign: "center" }, { children: [jsxs(Horizontal, __assign({ onClick: handleSortDirectionChange, "data-testid": "collapsible-breakdown-header-title", className: classes(isOpen && onSortDirectionChange && 'open', componentStyles$1.titleContainer) }, { children: [jsx(Content, __assign({ className: componentStyles$1.title }, { children: title })), isOpen && onSortDirectionChange && jsx(Icon, { icon: getSortIcon() })] })), jsx(StretchSpacer, {}), jsx(IconButton, { icon: isOpen ? faCaretUp : faCaretDown, onClick: onCollapse })] })));
};
var componentStyles$1 = stylesheet({
    container: {
        boxSizing: 'border-box',
        width: '100%',
        fontFamily: fontFamily,
        color: Colours.textLight,
        borderRadius: Sizes.borderRadius,
        maxHeight: percent(100),
        overflow: 'hidden'
    },
    title: {
        textTransform: 'uppercase',
        fontSize: Sizes.fontSize2
    },
    titleContainer: {
        $nest: {
            '&.open': {
                cursor: 'pointer'
            }
        }
    }
});

var FilterableBreakdown = function (props) {
    var title = props.title, styles = props.styles, filterBy = props.filterBy, filterTitle = props.filterTitle, filterOptions = props.filterOptions, onFilterChange = props.onFilterChange, children = props.children;
    return (jsx(Box, __assign({ className: style({
            overflow: 'hidden',
            flex: important(1)
        }) }, { children: jsxs(Vertical, __assign({ className: classes(componentStyles.container, style({
                background: (styles === null || styles === void 0 ? void 0 : styles.background) || Colours.darkBlue
            })), padding: rem(0.5), spacing: rem(1) }, { children: [jsx(FilterableBreakdownHeader, { title: title, filterTitle: filterTitle, filterOptions: filterOptions, filterBy: filterBy, onFilterChange: onFilterChange }), jsx(Stretch, __assign({ padding: [rem(0.75), rem(0.75), 0, rem(0.75)], className: classes(scrollClass) }, { children: children }))] })) })));
};
var FilterableBreakdownHeader = function (props) {
    var title = props.title, filterTitle = props.filterTitle, filterOptions = props.filterOptions, filterBy = props.filterBy, onFilterChange = props.onFilterChange;
    var filteringByText = useMemo(function () {
        var selectedOption = filterOptions.find(function (opt) { return opt.value === filterBy; });
        return selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label;
    }, [filterBy, filterOptions]);
    return (jsxs(Horizontal, __assign({ height: rem(2.5), padding: [0, rem(1)], verticalAlign: "center" }, { children: [jsx(Horizontal, __assign({ onClick: function () { }, "data-testid": "collapsible-breakdown-header-title", className: classes(componentStyles.titleContainer) }, { children: jsx(Content, __assign({ className: componentStyles.title }, { children: title })) })), jsx(StretchSpacer, {}), jsx(DropdownWrapper, __assign({ options: [
                    filterOptions.map(function (option) { return ({
                        text: option.label,
                        key: option.value,
                        onClick: function () { return onFilterChange(option.value); }
                    }); })
                ], selectedItem: filterBy, alt: true, direction: "left", title: filterTitle }, { children: jsxs(Horizontal, __assign({ spacing: rem(0.5), className: style({
                        textTransform: 'uppercase',
                        fontSize: Sizes.fontSize2,
                        cursor: 'pointer'
                    }) }, { children: [jsxs(Content, { children: [filterTitle, ":"] }), jsx(Content, { children: filteringByText }), jsx(Icon, { icon: faCaretDown })] })) }))] })));
};
var componentStyles = stylesheet({
    container: {
        boxSizing: 'border-box',
        width: '100%',
        fontFamily: fontFamily,
        color: Colours.textLight,
        borderRadius: Sizes.borderRadius,
        maxHeight: percent(100),
        overflow: 'hidden'
    },
    title: {
        textTransform: 'uppercase',
        fontSize: Sizes.fontSize2
    },
    titleContainer: {
        $nest: {
            '&.open': {
                cursor: 'pointer'
            }
        }
    }
});

var sizes = {
    sm: 40,
    md: 60,
    lg: 80
};
var strokeWidths = {
    sm: 4,
    md: 5,
    lg: 6
};
var fontSizes = {
    sm: 16,
    md: 20,
    lg: 24
};
var DEFAULT_SCORE_RANGE = 100;
var DEFAULT_THRESHOLDS = [0.5, 0.8];
var ScoreCircle = function (props) {
    var score = props.score, size = props.size, thresholds = props.thresholds, trackColor = props.trackColor, range = props.range;
    var scoreRange = range || DEFAULT_SCORE_RANGE;
    var squareSize = sizes[size || 'sm'] || 40;
    var strokeWidth = strokeWidths[size || 'sm'] || 4;
    var fontSize = fontSizes[size || 'sm'] || 14;
    var radius = (squareSize - strokeWidth) / 2;
    var viewBox = "0 0 ".concat(squareSize, " ").concat(squareSize);
    var validScore = score !== null && !isNaN(score)
        ? Math.round(Math.min(scoreRange, Math.max(0, score * scoreRange)))
        : 1;
    var dashArray = radius * Math.PI * 2;
    var dashOffset = dashArray - (dashArray * (validScore || 0.2)) / DEFAULT_SCORE_RANGE;
    var getColour = useCallback(function () {
        if (score === null)
            return Colours.textDark;
        var thresholdsOrDefault = thresholds || DEFAULT_THRESHOLDS;
        var result = Colours.textDisabled;
        if (score <= thresholdsOrDefault[0]) {
            result = Colours.red;
        }
        else if (score <= thresholdsOrDefault[1]) {
            result = Colours.yellow;
        }
        else {
            result = Colours.green;
        }
        return result;
    }, [score, thresholds]);
    return (jsxs(Box, __assign({ className: styles.container, height: squareSize }, { children: [jsxs("svg", __assign({ width: squareSize, height: squareSize, viewBox: viewBox }, { children: [jsx("circle", { className: classes(styles.circleBackground, style({
                            stroke: trackColor || Colours.textDisabled
                        })), cx: squareSize / 2, cy: squareSize / 2, r: radius, strokeWidth: "".concat(strokeWidth, "px") }), jsx("circle", { className: classes(styles.circleProgress, style({
                            stroke: getColour()
                        })), cx: squareSize / 2, cy: squareSize / 2, r: radius, strokeWidth: "".concat(strokeWidth, "px"), 
                        // Start progress marker at 12 O'Clock
                        transform: "rotate(-90 ".concat(squareSize / 2, " ").concat(squareSize / 2, ")"), style: {
                            strokeDasharray: dashArray,
                            strokeDashoffset: dashOffset
                        } })] })), jsx(Content, __assign({ "data-testid": "score-circle-score", className: classes(styles.circleText, style({ fontSize: fontSize })) }, { children: score === null || isNaN(score) ? '--' : validScore }))] })));
};
var styles = stylesheet({
    container: {
        position: 'relative',
        width: 'fit-content'
    },
    circleBackground: {
        fill: 'none'
    },
    circleProgress: {
        fill: 'none',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
    },
    circleText: {
        color: Colours.textLight,
        fontFamily: fontFamily,
        fontWeight: 700,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        transformOrigin: 'center'
    }
});

var DotStatus;
(function (DotStatus) {
    DotStatus["POSITIVE"] = "POSITIVE";
    DotStatus["NEGATIVE"] = "NEGATIVE";
    DotStatus["WARNING"] = "WARNING";
})(DotStatus || (DotStatus = {}));
var colors = {
    NEGATIVE: Colours.red,
    POSITIVE: Colours.green,
    WARNING: Colours.yellow
};
var StatusDot = function (_a) {
    var status = _a.status, children = _a.children;
    return (jsxs(Horizontal, __assign({ spacing: '1rem', verticalAlign: "center", horizontalAlign: "center" }, { children: [jsx(Box, { className: classes(dot, getColor(status)) }), children != null && jsx(Content, { children: children })] })));
};
var dot = style({
    height: '1.25rem',
    width: '1.25rem',
    borderRadius: '50%'
});
var getColor = function (status) { return style({ backgroundColor: colors[status] }); };

var css_248z = ".react-toast-notifications__container {\n  font-family: 'Open Sans', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  box-sizing: border-box;\n}\n\n.react-toast-notifications__toast--error\n  .react-toast-notifications__toast__icon-wrapper {\n  background-color: #ff1f41 !important;\n}\n\n.react-toast-notifications__toast--success\n  .react-toast-notifications__toast__icon-wrapper {\n  background-color: #02adc3 !important;\n}\n\n.react-toast-notifications__toast,\n.react-toast-notifications__toast__content {\n  color: #a0bcc5 !important;\n  background: #002438 !important;\n  overflow: hidden !important;\n  width: auto !important;\n  max-width: 700px !important;\n  min-width: 200px;\n}\n";
styleInject(css_248z);

var Toast = function (props) { return (jsx(DefaultToast, __assign({}, props, { "data-testid": "toast-".concat(props.appearance) }))); };
var ToastNotificationsProvider = function (_a) {
    var _b = _a.placement, placement = _b === void 0 ? 'bottom-left' : _b, _c = _a.autoDismiss, autoDismiss = _c === void 0 ? true : _c, _d = _a.autoDismissTimeoutMS, autoDismissTimeoutMS = _d === void 0 ? 10000 : _d, children = _a.children;
    var newestOnTop = useMemo(function () {
        return ['top-left', 'top-center', 'top-right'].includes(placement);
    }, [placement]);
    return (jsx(ToastProvider, __assign({ placement: placement, autoDismiss: autoDismiss, autoDismissTimeout: autoDismissTimeoutMS, transitionDuration: 250, newestOnTop: newestOnTop, components: { Toast: Toast } }, { children: children })));
};

function textToNumber(t, options) {
    var text = t.replace(/[a-zA-Z]/g, '');
    if (text === '') {
        return '';
    }
    else if ((options === null || options === void 0 ? void 0 : options.max) !== undefined && Number(text) > options.max) {
        return options.max.toString();
    }
    else if ((options === null || options === void 0 ? void 0 : options.min) !== undefined && Number(text) < options.min) {
        return options.min.toString();
    }
    return text;
}

var en = {
    ns1: {
        'Forgot password': 'Forgot password',
        Confirm: 'Confirm',
        Username: 'Username',
        'Change password': 'Change password',
        Change: 'Change',
        'You need to set a new password. Save it properly as this is the one you will be using to login.': "You need to set a new password. Save it properly as this is the one\n          you will be using to login.",
        Password: 'Password',
        'Repeat password': 'Repeat password',
        'OTP verification': 'OTP verification',
        Login: 'Login',
        'OTP code': 'OTP code',
        'OTP client verification': 'OTP client verification',
        Verify: 'Verify',
        'Now we need to verify your OTP client. You can use whichever you want (for example, Google Authenticator). Make sure you will always have access to it as you will need an OTP code everytime you log in.': "Now we need to verify your OTP client. You can use whichever you\n            want (for example, Google Authenticator). Make sure you will always\n            have access to it as you will need an OTP code everytime you log in.",
        'Copy to clipboard': 'Copy to clipboard',
        Expired: 'Expired',
        'Expires in': 'Expires in: {{time}}',
        'One-time password (OTP)': 'One-time password (OTP)',
        'Forgot password?': 'Forgot password?',
        'New password': 'New password',
        'Verification code': 'Verification code',
        Schedule: 'Schedule',
        'Feed Rate': 'Feed Rate',
        Planned: 'Planned',
        Expected: 'Expected',
        Target: 'Target',
        'Visits per day': 'Visits per day',
        'Transport time': 'Transport time',
        Availability: 'Availability',
        'End time must be after start time': 'End time must be after start time',
        Configurations: 'Configurations',
        'Appetite Factor': 'Appetite Factor',
        is: 'is',
        'and this occured more than': 'and this occured more than',
        'and this occured': 'and this occured',
        'times within a span of_one': ' within a span of',
        'times within a span of_other': 'times within a span of',
        once: 'once',
        'Reactive time': 'Reactive time',
        'All fields are required and must be filled out': 'All fields are required and must be filled out',
        Group: 'Group',
        'Planned feed is X% above expected': 'Planned feed {{ percDifference, number }}% above expected',
        'Planned feed is X% below expected': 'Planned feed {{ percDifference, number }}% below expected',
        'Target is X% above table target YZ': "{{ percDifference, number }}% above table ({{ target, number }}{{unit, string}})",
        'Target is X% below table target YZ': "{{ percDifference, number }}% below table ({{ target , number }}{{unit, string}})",
        Overshoot: 'Overshoot',
        All: 'All',
        'Show less': 'Show less',
        'Show more': 'Show more',
        'Add statement': 'Add statement',
        'Exit Bad': 'Exit Bad',
        'Exit Good': 'Exit Good',
        Stop: 'Stop',
        If: 'If',
        and: 'and',
        Edit: 'Edit',
        Delete: 'Delete',
        Cancel: 'Cancel',
        Save: 'Save',
        'second(s)': 'second(s)',
        'minute(s)': 'minute(s)',
        'hour(s)': 'hour(s)',
        'day(s)': 'day(s)',
        'It has to be a valid email.': 'It has to be a valid email.',
        'Field is mandatory': 'Field is mandatory',
        'Add Pause': 'Add Pause',
        Select: 'Select'
    }
};

var es = {
    ns1: {
        'Forgot password': 'Olvidé la contraseña',
        Confirm: 'Confirmar',
        Username: 'Nombre de usuario',
        'Change password': 'Cambiar contraseña',
        Change: 'Cambiar',
        'You need to set a new password. Save it properly as this is the one you will be using to login.': 'Necesitas establecer una nueva contraseña. Guárdala correctamente ya que esta será la que utilizarás para iniciar sesión.',
        Password: 'Contraseña',
        'Repeat password': 'Repetir contraseña',
        'OTP verification': 'Verificación de OTP',
        Login: 'Iniciar sesión',
        'OTP code': 'Código OTP',
        'OTP client verification': 'Verificación del cliente OTP',
        Verify: 'Verificar',
        'Now we need to verify your OTP client. You can use whichever you want (for example, Google Authenticator). Make sure you will always have access to it as you will need an OTP code everytime you log in.': 'Ahora necesitamos verificar tu cliente OTP. Puedes usar el que quieras (por ejemplo, Google Authenticator). Asegúrate de siempre tener acceso a él ya que necesitarás un código OTP cada vez que inicies sesión.',
        'Copy to clipboard': 'Copiar',
        Expired: 'Expirado',
        'Expires in': 'Expira en: {{time}}',
        'One-time password (OTP)': 'Contraseña de un solo uso (OTP)',
        'Forgot password?': '¿Olvidaste tu contraseña?',
        'New password': 'Nueva contraseña',
        'Verification code': 'Código de verificación',
        Schedule: 'Programa',
        'Feed Rate': 'Tasa de alimentación',
        Planned: 'Planificado',
        Expected: 'Esperado',
        Target: 'Objetivo',
        'Visits per day': 'Visitas por día',
        'Transport time': 'Tiempo de transporte',
        Availability: 'Disponibilidad',
        'End time must be after start time': 'La hora de finalización debe ser posterior a la hora de inicio',
        Configurations: 'Configuraciones',
        'Appetite Factor': 'Factor de apetito',
        is: 'es',
        'and this occured more than': 'y esto ocurrió más de',
        'and this occured': 'y esto ocurrió',
        'times within a span of_one': ' veces en un lapso de',
        'times within a span of_other': ' veces en un lapso de',
        once: 'una vez',
        'Reactive time': 'Tiempo reactivo',
        'All fields are required and must be filled out': 'Todos los campos son obligatorios y deben completarse',
        Group: 'Grupo',
        'Planned feed is X% above expected': 'La alimentación planificada es {{ percDifference, number }}% por encima de lo esperado',
        'Planned feed is X% below expected': 'La alimentación planificada es {{ percDifference, number }}% por debajo de lo esperado',
        'Target is X% above table target YZ': 'El objetivo está {{ percDifference, number }}% por encima de la tabla ({{ target, number }}{{unit, string}})',
        'Target is X% below table target YZ': 'El objetivo está {{ percDifference, number }}% por debajo de la tabla ({{ target , number }}{{unit, string}})',
        Overshoot: 'Exceso',
        All: 'Todos',
        'Show less': 'Mostrar menos',
        'Show more': 'Mostrar más',
        'Add statement': 'Agregar declaración',
        'Exit Bad': 'Salida Negativa',
        'Exit Good': 'Salida Positiva',
        Stop: 'Cerrar',
        If: 'Si',
        and: 'y',
        Delete: 'Borrar',
        Edit: 'Editar',
        Cancel: 'Cancelar',
        Save: 'Guardar',
        'second(s)': 'segundo(s)',
        'minute(s)': 'minuto(s)',
        'hour(s)': 'hora(s)',
        'day(s)': 'día(s)',
        'It has to be a valid email.': 'Debe ser un correo electrónico válido.',
        'Field is mandatory': 'El campo es obligatorio',
        'Add Pause': 'Añadir pausa',
        Select: 'Seleccionar'
    }
};

var no = {
    ns1: {
        'Forgot password': 'Glemt passord',
        Confirm: 'Bekreft',
        Username: 'Brukernavn',
        'Change password': 'Endre passord',
        Change: 'Endre',
        'You need to set a new password. Save it properly as this is the one you will be using to login.': "Du m\u00E5 sette et nytt passord. Lagre det riktig, da dette er det du vil bruke for \u00E5 logge inn.",
        Password: 'Passord',
        'Repeat password': 'Gjenta passord',
        'OTP verification': 'OTP-verifisering',
        Login: 'Logg inn',
        'OTP code': 'OTP-kode',
        'OTP client verification': 'OTP-klientverifisering',
        Verify: 'Verifiser',
        'Now we need to verify your OTP client. You can use whichever you want (for example, Google Authenticator). Make sure you will always have access to it as you will need an OTP code everytime you log in.': "N\u00E5 m\u00E5 vi verifisere din OTP-klient. Du kan bruke hvilken som helst du vil (for eksempel, Google Authenticator). S\u00F8rg for at du alltid har tilgang til den, da du vil trenge en OTP-kode hver gang du logger inn.",
        'Copy to clipboard': 'Kopier til utklippstavle',
        Expired: 'Utløpt',
        'Expires in': 'Utløper om: {{time}}',
        'One-time password (OTP)': 'Engangspassord (OTP)',
        'Forgot password?': 'Glemt passord?',
        'New password': 'Nytt passord',
        'Verification code': 'Verifiseringskode',
        Schedule: 'Timeplan',
        'Feed Rate': 'Fôrhastighet',
        Planned: 'Planlagt',
        Expected: 'Forventet',
        Target: 'Mål',
        'Visits per day': 'Besøk per dag',
        'Transport time': 'Transporttid',
        Availability: 'Tilgjengelighet',
        'End time must be after start time': 'Sluttid må være etter starttid',
        Configurations: 'Konfigurasjoner',
        'Appetite Factor': 'Appetittfaktor',
        is: 'er',
        'and this occured more than': 'og dette skjedde mer enn',
        'and this occured': 'og dette skjedde',
        'times within a span of_one': ' ganger i løpet av en periode på',
        'times within a span of_other': ' ganger i løpet av en periode på',
        once: 'en gang',
        'Reactive time': 'Reaksjonstid',
        'All fields are required and must be filled out': 'Alle felt er påkrevd og må fylles ut',
        Group: 'Gruppe',
        'Planned feed is X% above expected': 'Planlagt fôr er {{ percDifference, number }}% over forventet',
        'Planned feed is X% below expected': 'Planlagt fôr er {{ percDifference, number }}% under forventet',
        'Target is X% above table target YZ': "M\u00E5let er {{ percDifference, number }}% over tabellen ({{ target, number }}{{unit, string}})",
        'Target is X% below table target YZ': "M\u00E5let er {{ percDifference, number }}% under tabellen ({{ target , number }}{{unit, string}})",
        Overshoot: 'Overskytende',
        All: 'Alle',
        'Show less': 'Vis mindre',
        'Show more': 'Vis mer',
        'Add statement': 'Legg til uttalelse',
        'Exit Bad': 'Avslutt dårlig',
        'Exit Good': 'Avslutt bra',
        Stop: 'Stopp',
        If: 'Hvis',
        and: 'og',
        Edit: 'Rediger',
        Delete: 'Slett',
        Save: 'Lagre',
        Cancel: 'Avbryt',
        'second(s)': 'sekund(er)',
        'minute(s)': 'minutt(er)',
        'hour(s)': 'time(r)',
        'day(s)': 'dag(er)',
        'It has to be a valid email.': 'Det må være en gyldig e-post.',
        'Field is mandatory': 'Feltet er obligatorisk',
        'Add Pause': 'Legg til pause',
        Select: 'Velg'
    }
};

var resources = {
    en: en,
    es: es,
    no: no
};
i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    defaultNS: 'ns1',
    resources: resources,
    lng: 'en',
    keySeparator: false,
    interpolation: {
        escapeValue: false // react already safes from xss
    }
});

export { SvgAf as AFIcon, Accordion, AccordionContent, AccordionHeader, SvgActivity as ActivityIcon, SvgActivityTrend as ActivityTrendIcon, AlertGroups, Button, CAMERA_ACTIONS, CONTEXT_MENU_LIST_TEST_ID, CONTEXT_MENU_SUBMENU_TEST_ID, SvgChaosOfFish as ChaosOfFishIcon, ChartBar, CheckboxInput, CircleCountdown, CollapsibleBreakdown, ConfigurationType, ConfirmationModal, ContextMenu, DEFAULT_CAMERA_ACTION, DataTypes, DatePicker, DateRangePicker, SvgDensityOfFish as DensityOfFishIcon, SvgDepth as DepthIcon, SvgDistanceFishCam as DistanceOfFishIcon, DotStatus, Drawer, DropdownWrapper, SvgError as ErrorIcon, EventLine, EventsTimeline, SvgExit as ExitIcon, FEED_LINE_BAR_SLOT_TESTID, FEED_LINE_BAR_TESTID, FEED_LINE_BREAKDOWN_AVAILABLE_TESTID, FEED_LINE_BREAKDOWN_PEN_TESTID, FEED_LINE_BREAKDOWN_TRANSPORT_TIME_TESTID, FEED_LINE_COMPARISON_CHART_TESTID, FEED_LINE_DAY_BAR_TESTID, FEED_LINE_DAY_EXPECTED_FEED_TESTID, FEED_LINE_DAY_FEED_RATE_TESTID, FEED_LINE_DAY_PLANNED_FEED_TESTID, FEED_LINE_RANGE, FEED_LINE_UTILIZATION_AVAILABLE_TESTID, FEED_LINE_UTILIZATION_PEN_TESTID, FEED_LINE_UTILIZATION_TRANSPORT_TIME_TESTID, FeedLineBar, FeedLineComparisonChart, FeedLineDayUtilization, FeedLineRange, FeedLineUtilizationBreakdown, FeedLineUtilizationChart, FeedStrategiesScenarioConfigurations, FeedingAutomation, FeedingMonitor, FeedingMonitorOverlay, SvgFeedingTube as FeedingTubeIcon, FilterableBreakdown, FlowChart, ForgotPasswordLogin, Form, FormCheckboxInput, FormContext, FormDatePickerInput, FormNumberInput, FormNumberRangeInput, FormRadioInput, FormSelectInput, FormSwitchInput, FormTextAreaInput, FormTextInput, FormTimeDropDown, FormTimeInput, Graph, Heading, HeightObserver, Icon, IconButton, Loader, MAX_CAMERA_DEPTH_M, MIN_CAMERA_DEPTH_M, MODAL_BACKGROUND_TESTID, MenuList, Modal, NewPasswordLogin, NewPasswordWithCodeLogin, SvgNormalizedActivity as NormalizedActivityIcon, NumberInput, SvgNumberOfFish as NumberOfFishIcon, OTPLogin, OTPSetUpLogin, SvgOxygen as OxygenIcon, PEN_BAR_AMOUNT_TESTID, PEN_BAR_REMOVE_TESTID, PEN_FEED_RATE_PER_AF_TESTID, PEN_NAME_TESTID, PEN_VISITS_PER_DATE_TESTID, SvgPellets as PelletsIcon, PenUtilization, RadioInput, SWITCH_SLIDER_TEST_ID, ScenarioList, SvgSchooling as SchollingIcon, SvgSchoolingOfFish as SchoolingOfFishIcon, ScoreCircle, SelectInput, ShowMore, SignalInfoDropdown, SignalLegendDropdown, SignalLegendToggle, SignalProgressBar, StatusDot, StrategyList, styles$h as Styles, Switch, SwitchInput, TIME_RANGE_PICKER, TIME_RANGE_PICKER_DISPLAY_VALUE_TESTID, TIME_RANGE_PICKER_TOGGLE_TESTID, TabContent, TabHeader, Tabs, SvgTemperature as TemperatureIcon, TextAreaInput, TextInput, TimeDropDown, TimeInput, TimeRangePicker, TimelineChart, ToastNotificationsProvider, UsernamePasswordLogin, UtilizationChart, SvgVisibility as VisibilityIcon, SvgVisibilityOfWater as VisibilityOfWaterIcon, VisitsChart, convertTime, deepEqual, format, getDiffInMinutes, getDiffInSeconds, getLeftOffsetFromTime, isBetweenValidator, isEmail, isGreaterThanValidator, isMandatory, legendOptions, lengthIsGreaterThanValidator, mapEventsByDay, name, passwordsMustBeTheSameValidator, resources, signalsConfiguration, tabsContext, textToNumber, useAccordionContext, useFormContext, useOnClickOutside, useTimeConverter, useToastNotifications };
//# sourceMappingURL=index.esm.js.map
